import * as React from 'react';
import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from 'react-bootstrap/Modal';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dropdown from 'react-bootstrap/Dropdown';
import { useParams } from 'react-router-dom';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { postRequest, putRequest, deleteRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { AuthContext } from '../../../authContext/context';
import { API_BASE, CUSTOMER_PORTAL_URL } from '../../../lib/config';
import { checkPermission } from '../../../utils/checkPermissions';
import Swal from 'sweetalert2';
import Notes from '../Notes/note';
import jsPDF from 'jspdf';
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventIcon from '@mui/icons-material/Event';
import BusinessIcon from '@mui/icons-material/Business';
import './conveyancing-badges.css';
import ViewQuoteDetailModal from '../../../components/ViewQuoteDetailModal';
import ViewQuoteDetailModalSale from '../../../components/ViewQuoteDetailModalSale';

function ConveyancingQuoteModal({ show, onHide, quoteData, leadData }) {
  console.log('🎯 === VIEW QUOTE DETAILS POPUP ===');
  console.log('QuoteData:', quoteData);
  console.log('Fixed Fees:', quoteData?.fixedFees);
  console.log('Disbursements:', quoteData?.disbursements);
  console.log('Breakdown:', quoteData?.breakdown);
  console.log('Branch Name:', quoteData?.branchName);
  console.log('Service Type:', quoteData?.serviceType);

  // Helper function to format camelCase fee labels to Title Case
  const formatFeeLabel = (label) => {
    if (!label) return '';

    // Convert camelCase to space-separated words
    let formatted = label
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();

    // Handle special acronyms and words
    formatted = formatted
      .replace(/\bIsa\b/g, 'ISA')
      .replace(/\bTt\b/g, 'TT')
      .replace(/\bHm\b/g, 'HM')
      .replace(/\bLand Registry\b/gi, 'Land Registry')
      .replace(/\bLand Charges\b/gi, 'Land Charges');

    return formatted;
  };

  // Calculate totals if breakdown is missing
  const calculateTotals = () => {
    const base = quoteData?.base || leadData?.legal_fee || 0;
    const legalFeeVAT = base * 0.20;

    let fixedFeesTotal = 0;
    let fixedFeesVAT = 0;

    if (quoteData?.fixedFees) {
      quoteData.fixedFees.forEach(fee => {
        fixedFeesTotal += fee.amount;
        if (!fee.label.toLowerCase().includes('identity')) {
          fixedFeesVAT += fee.amount * 0.20;
        }
      });
    }

    const disbursementsTotal = quoteData?.disbursementsTotal ||
      (quoteData?.disbursements?.reduce((sum, d) => sum + d.amount, 0) || 0);

    const totalVAT = legalFeeVAT + fixedFeesVAT;
    const grandTotal = base + legalFeeVAT + fixedFeesTotal + fixedFeesVAT + disbursementsTotal;

    return {
      base,
      legalFeeVAT,
      fixedFeesTotal,
      fixedFeesVAT,
      disbursementsTotal,
      totalVAT,
      grandTotal
    };
  };

  const totals = calculateTotals();

  // Helper function to calculate grand total for a section (Purchase or Sale)
  const calculateGrandTotal = (data) => {
    const base = data?.base || data?.legal_fee || 0;
    const fixedFees = data?.fixedFees || [];
    const disbursements = data?.disbursements || [];

    let fixedFeesTotal = 0;
    let fixedFeesVAT = 0;

    fixedFees.forEach(fee => {
      fixedFeesTotal += fee.amount;
      if (!fee.label.toLowerCase().includes('identity')) {
        fixedFeesVAT += fee.amount * 0.20;
      }
    });

    const legalFeeVAT = base * 0.20;
    const disbursementsTotal = disbursements.reduce((sum, d) => sum + d.amount, 0);
    const totalVAT = legalFeeVAT + fixedFeesVAT;
    const totalNet = base + fixedFeesTotal + disbursementsTotal;
    const grandTotal = totalNet + totalVAT;

    return {
      net: totalNet,
      vat: totalVAT,
      gross: grandTotal
    };
  };

  // Helper function to generate quote table in PDF
  const generateQuoteTableInPDF = (doc, data, type, startY) => {
    const formatFeeLabel = (label) => {
      if (!label) return '';
      let formatted = label
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
      return formatted;
    };

    const base = data?.base || data?.legal_fee || 0;
    const fixedFees = data?.fixedFees || [];
    const disbursements = data?.disbursements || [];

    // Calculate totals
    let fixedFeesTotal = 0;
    let fixedFeesVAT = 0;

    fixedFees.forEach(fee => {
      fixedFeesTotal += fee.amount;
      if (!fee.label.toLowerCase().includes('identity')) {
        fixedFeesVAT += fee.amount * 0.20;
      }
    });

    const legalFeeVAT = base * 0.20;
    const disbursementsTotal = disbursements.reduce((sum, d) => sum + d.amount, 0);
    const totalVAT = legalFeeVAT + fixedFeesVAT;
    const grandTotal = base + legalFeeVAT + fixedFeesTotal + fixedFeesVAT + disbursementsTotal;

    let yPosition = startY;

    // Section header
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(type === 'sale' ? 220 : 13, type === 'sale' ? 53 : 110, type === 'sale' ? 69 : 253);
    doc.text(type === 'sale' ? 'SALE DETAILS' : 'PURCHASE DETAILS', 10, yPosition);
    doc.setTextColor(0, 0, 0);
    yPosition += 8;

    // Total cost box
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text(`Total Cost: £${grandTotal.toFixed(2)}`, 10, yPosition);
    doc.setFontSize(9);
    doc.text(`(£${(grandTotal - totalVAT).toFixed(2)} + £${totalVAT.toFixed(2)} VAT)`, 70, yPosition);
    yPosition += 10;

    // Table header
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 90, 6);
    doc.rect(100, yPosition, 30, 6);
    doc.rect(130, yPosition, 30, 6);
    doc.rect(160, yPosition, 30, 6);

    doc.text('Description', 12, yPosition + 4);
    doc.text('Net', 110, yPosition + 4);
    doc.text('VAT', 140, yPosition + 4);
    doc.text('Total', 168, yPosition + 4);
    yPosition += 6;

    // Legal Fee row
    doc.setFont('helvetica', 'normal');
    doc.rect(10, yPosition, 90, 6);
    doc.rect(100, yPosition, 30, 6);
    doc.rect(130, yPosition, 30, 6);
    doc.rect(160, yPosition, 30, 6);

    doc.text('Legal Fees', 12, yPosition + 4);
    doc.text(`£${base.toFixed(2)}`, 102, yPosition + 4);
    doc.text(`£${legalFeeVAT.toFixed(2)}`, 132, yPosition + 4);
    doc.text(`£${(base + legalFeeVAT).toFixed(2)}`, 162, yPosition + 4);
    yPosition += 6;

    // Fixed fees
    fixedFees.forEach(fee => {
      const feeVAT = fee.label.toLowerCase().includes('identity') ? 0 : fee.amount * 0.20;
      const feeTotal = fee.amount + feeVAT;

      doc.rect(10, yPosition, 90, 6);
      doc.rect(100, yPosition, 30, 6);
      doc.rect(130, yPosition, 30, 6);
      doc.rect(160, yPosition, 30, 6);

      doc.setFontSize(9);
      doc.text(formatFeeLabel(fee.label), 12, yPosition + 4);
      doc.setFontSize(10);
      doc.text(`£${fee.amount.toFixed(2)}`, 102, yPosition + 4);
      doc.text(`£${feeVAT.toFixed(2)}`, 132, yPosition + 4);
      doc.text(`£${feeTotal.toFixed(2)}`, 162, yPosition + 4);
      yPosition += 6;
    });

    // Disbursements section
    if (disbursements.length > 0) {
      doc.setFont('helvetica', 'bold');
      doc.rect(10, yPosition, 90, 6);
      doc.rect(100, yPosition, 30, 6);
      doc.rect(130, yPosition, 30, 6);
      doc.rect(160, yPosition, 30, 6);

      doc.text('Disbursements', 12, yPosition + 4);
      doc.text(`£${disbursementsTotal.toFixed(2)}`, 102, yPosition + 4);
      doc.text('£0.00', 132, yPosition + 4);
      doc.text(`£${disbursementsTotal.toFixed(2)}`, 162, yPosition + 4);
      yPosition += 6;

      doc.setFont('helvetica', 'normal');
      disbursements.forEach(disb => {
        doc.rect(10, yPosition, 90, 6);
        doc.rect(100, yPosition, 30, 6);
        doc.rect(130, yPosition, 30, 6);
        doc.rect(160, yPosition, 30, 6);

        doc.setFontSize(9);
        doc.text(formatFeeLabel(disb.label), 12, yPosition + 4);
        doc.setFontSize(10);
        doc.text(`£${disb.amount.toFixed(2)}`, 102, yPosition + 4);
        doc.text('£0.00', 132, yPosition + 4);
        doc.text(`£${disb.amount.toFixed(2)}`, 162, yPosition + 4);
        yPosition += 6;
      });
    }

    // Total row
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 90, 7);
    doc.rect(100, yPosition, 30, 7);
    doc.rect(130, yPosition, 30, 7);
    doc.rect(160, yPosition, 30, 7);

    doc.setFontSize(11);
    doc.text('TOTAL', 12, yPosition + 5);
    doc.text(`£${(grandTotal - totalVAT).toFixed(2)}`, 102, yPosition + 5);
    doc.text(`£${totalVAT.toFixed(2)}`, 132, yPosition + 5);
    doc.text(`£${grandTotal.toFixed(2)}`, 162, yPosition + 5);
    yPosition += 10;

    return yPosition;
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for ${leadData?.service_type?.replace(/_/g, ' ')} #${leadData?.lead_id || 'N/A'}`, 10, 20);

    // Thank you message
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text(`Thank you for choosing My Law Matters for your ${leadData?.service_type?.replace(/_/g, ' ')} needs.`, 10, 30);

    let yPosition = 40;

    // Check if this is Purchase_Sale service type
    if (isPurchaseSale) {
      // Generate SALE section
      if (leadData?.saleQuote) {
        yPosition = generateQuoteTableInPDF(doc, leadData.saleQuote, 'sale', yPosition);
        yPosition += 5;
      }

      // Generate PURCHASE section
      if (leadData?.purchaseQuote || quoteData) {
        yPosition = generateQuoteTableInPDF(doc, leadData?.purchaseQuote || quoteData, 'purchase', yPosition);
      }
    } else {
      // Single service type (Purchase or Sale only)
      const type = leadData?.service_type?.toLowerCase() === 'sale' ? 'sale' : 'purchase';
      yPosition = generateQuoteTableInPDF(doc, quoteData, type, yPosition);
    }

    // Additional details
    yPosition += 5;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('This quote is valid for 30 days from the date of issue.', 10, yPosition);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-GB')}`, 10, yPosition + 5);

    // Footer
    doc.setFontSize(8);
    doc.text('My Law Matters - Professional Legal Services', 10, doc.internal.pageSize.height - 20);

    // Save the PDF
    const filename = `${leadData?.service_type?.replace(/_/g, '_')}_Quote_${leadData?.lead_id || 'Quote'}.pdf`;
    doc.save(filename);

    Swal.fire('Success', 'Quote downloaded successfully!', 'success');
  };

  const handleDownload = () => {
    generatePDF();
  };
  
  // Check if this is a Purchase_Sale type
  const isPurchaseSale = leadData?.service_type === 'Purchase_Sale';

  // Render function for quote table
  const renderQuoteTable = (data, type = 'purchase') => {
    const base = data?.base || data?.legal_fee || 0;
    const fixedFees = data?.fixedFees || [];
    const disbursements = data?.disbursements || [];

    // Calculate totals
    let fixedFeesTotal = 0;
    let fixedFeesVAT = 0;

    fixedFees.forEach(fee => {
      fixedFeesTotal += fee.amount;
      if (!fee.label.toLowerCase().includes('identity')) {
        fixedFeesVAT += fee.amount * 0.20;
      }
    });

    const legalFeeVAT = base * 0.20;
    const disbursementsTotal = disbursements.reduce((sum, d) => sum + d.amount, 0);
    const totalVAT = legalFeeVAT + fixedFeesVAT;
    const totalNet = base + fixedFeesTotal + disbursementsTotal;
    const grandTotal = totalNet + totalVAT;

    return (
      <>
        {/* Total Cost Summary */}
        <div className="mb-3 text-muted" style={{ fontSize: '0.95rem' }}>
          Total Cost: <strong>£{grandTotal.toFixed(2)}</strong> (£{totalNet.toFixed(2)} + £{totalVAT.toFixed(2)} VAT)
        </div>

        <div className="table-responsive">
          <Table bordered style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ width: '50%' }}>Description</th>
                <th className="text-end">Net</th>
                <th className="text-end">VAT</th>
                <th className="text-end">Gross</th>
              </tr>
            </thead>
            <tbody>
              {/* Legal Cost Section */}
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <td colSpan="4"><strong>Legal Cost</strong></td>
              </tr>

              {/* Legal Fees */}
              <tr>
                <td>Legal Fees</td>
                <td className="text-end">£{base.toFixed(2)}</td>
                <td className="text-end">£{legalFeeVAT.toFixed(2)}</td>
                <td className="text-end">£{(base + legalFeeVAT).toFixed(2)}</td>
              </tr>

              {/* Fixed Fees (all under Legal Cost) */}
              {fixedFees.length > 0 && fixedFees.map((fee, index) => {
                const isIdentityCheck = fee.label.toLowerCase().includes('identity');
                const vatRate = isIdentityCheck ? 0 : 0.20;
                const feeVAT = fee.amount * vatRate;
                const feeGross = fee.amount + feeVAT;

                return (
                  <tr key={`fixed-${index}`}>
                    <td>{formatFeeLabel(fee.label)}</td>
                    <td className="text-end">£{fee.amount.toFixed(2)}</td>
                    <td className="text-end">£{feeVAT.toFixed(2)}</td>
                    <td className="text-end">£{feeGross.toFixed(2)}</td>
                  </tr>
                );
              })}

              {/* Disbursements Section */}
              {disbursements.length > 0 && (
                <>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <td colSpan="4"><strong>Disbursements</strong></td>
                  </tr>

                  {disbursements.map((disb, index) => (
                    <tr key={`disb-${index}`}>
                      <td>{formatFeeLabel(disb.label)}</td>
                      <td className="text-end">£{disb.amount.toFixed(2)}</td>
                      <td className="text-end">£0.00</td>
                      <td className="text-end">£{disb.amount.toFixed(2)}</td>
                    </tr>
                  ))}
                </>
              )}

              {/* Grand Total */}
              <tr style={{ backgroundColor: '#172554', fontWeight: '700', color: 'white' }}>
                <td style={{ color: 'white', fontWeight: '700' }}>TOTAL (Legal Cost + Disbursement Cost)</td>
                <td className="text-end" style={{ color: 'white' }}>£{totalNet.toFixed(2)}</td>
                <td className="text-end" style={{ color: 'white' }}>£{totalVAT.toFixed(2)}</td>
                <td className="text-end" style={{ color: 'white' }}>£{grandTotal.toFixed(2)}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size={isPurchaseSale ? "lg" : "md"} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title id="contained-modal-title-vcenter">
          View Quote {isPurchaseSale && '- Sale & Purchase'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isPurchaseSale ? (
          <>
            {/* Purchase & Sale Stacked Vertically */}
            {/* Purchase Section */}
            {leadData?.purchaseQuote || quoteData ? (
              <>
                <h5 className="mb-3" style={{ fontWeight: '600', color: '#000000', backgroundColor: '#f0f0f0', padding: '10px' }}>
                  PURCHASE
                </h5>
                {renderQuoteTable(leadData?.purchaseQuote || quoteData, 'purchase')}
              </>
            ) : (
              <div className="alert alert-warning">
                Purchase quote data not available
              </div>
            )}

            {/* Sale Section */}
            {leadData?.saleQuote && (
              <>
                <div className="mt-4"></div>
                <h5 className="mb-3" style={{ fontWeight: '600', color: '#000000', backgroundColor: '#f0f0f0', padding: '10px' }}>
                  SALE
                </h5>
                {renderQuoteTable(leadData.saleQuote, 'sale')}
              </>
            )}

            {/* Combined Total */}
            {leadData?.purchaseQuote && leadData?.saleQuote && (
              <div className="mt-3">
                <Table bordered>
                  <tbody>
                    <tr style={{ backgroundColor: '#172554', fontWeight: '700', color: 'white' }}>
                      <td style={{ color: 'white', fontWeight: '700', width: '50%' }}>TOTAL SALE & PURCHASE</td>
                      <td className="text-end" style={{ color: 'white' }}>
                        £{(() => {
                          const purchaseTotal = calculateGrandTotal(leadData.purchaseQuote);
                          const saleTotal = calculateGrandTotal(leadData.saleQuote);
                          return (purchaseTotal.net + saleTotal.net).toFixed(2);
                        })()}
                      </td>
                      <td className="text-end" style={{ color: 'white' }}>
                        £{(() => {
                          const purchaseTotal = calculateGrandTotal(leadData.purchaseQuote);
                          const saleTotal = calculateGrandTotal(leadData.saleQuote);
                          return (purchaseTotal.vat + saleTotal.vat).toFixed(2);
                        })()}
                      </td>
                      <td className="text-end" style={{ color: 'white' }}>
                        £{(() => {
                          const purchaseTotal = calculateGrandTotal(leadData.purchaseQuote);
                          const saleTotal = calculateGrandTotal(leadData.saleQuote);
                          return (purchaseTotal.gross + saleTotal.gross).toFixed(2);
                        })()}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            <div className="mt-4 text-center border-top pt-3">
              <Button
                variant="primary"
                onClick={handleDownload}
                style={{
                  minWidth: '120px',
                  fontSize: '0.875rem'
                }}
              >
                <i className="fas fa-download me-2"></i>
                Download
              </Button>
            </div>
          </>
        ) : (
          <>
            {/* Single Service Type View (Purchase or Sale only) */}
            {renderQuoteTable(quoteData, leadData?.service_type?.toLowerCase() === 'sale' ? 'sale' : 'purchase')}

            {quoteData?.propertyValue && (
              <div className="mt-3 text-muted text-center">
                <small>Property Value: £{quoteData.propertyValue.toLocaleString('en-GB')}</small>
              </div>
            )}

            <div className="mt-4 text-center">
              <Button
                variant="primary"
                onClick={handleDownload}
                style={{
                  minWidth: '120px',
                  fontSize: '0.875rem'
                }}
              >
                <i className="fas fa-download me-2"></i>
                Download
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

// Revise Quote Modal Component for Sale & Purchase
function ReviseQuoteModal({ show, onHide, leadData, authToken, onReviseQuote, legalFeeData }) {
  // Separate state for Purchase and Sale fees
  const [purchaseFees, setPurchaseFees] = useState({
    // Purchase Legal Fees (with VAT)
    legal_fee: 0,
    tt_fee: 0,
    mortgage_admin_fee: 0,
    leasehold_fee: 0,
    help_to_buy_isa_fee: 0,
    help_to_buy_fee: 0,
    right_to_buy_fee: 0,
    shared_ownership_fee: 0,
    new_build_fee: 0,
    islamic_mortgage_fee: 0,
    auction_repossession_fee: 0,
    gifted_deposit_fee: 0,
    gifted_deposit_fee_additional: 0,
    buy_to_let_fee: 0,
    arranging_indemnity_policy: 0,
    // Purchase Disbursements
    identity_check: 0,
    stamp_duty: 0,
    hm_land_registry_fee: 0,
    land_registry_search: 0,
    land_charges_search: 0,
    search_pack: 0
  });

  const [saleFees, setSaleFees] = useState({
    // Sale Legal Fees (with VAT)
    legal_fee: 0,
    tt_fee: 0,
    leasehold_fee: 0,
    mortgage_admin_fee: 0,
    shared_ownership_fee: 0,
    auction_repossession_fee: 0,
    // Sale Disbursements
    identity_check: 0,
    official_copies: 0
  });

  const [purchaseTotals, setPurchaseTotals] = useState({
    net: 0,
    vat: 0,
    gross: 0,
    legalCost: { net: 0, vat: 0, gross: 0 },
    disbursementCost: { net: 0, vat: 0, gross: 0 }
  });
  const [saleTotals, setSaleTotals] = useState({
    net: 0,
    vat: 0,
    gross: 0,
    legalCost: { net: 0, vat: 0, gross: 0 },
    disbursementCost: { net: 0, vat: 0, gross: 0 }
  });
  const [grandTotal, setGrandTotal] = useState({ net: 0, vat: 0, gross: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  // 🎯 Fetch data from final_leads_calculations when modal opens
  React.useEffect(() => {
    if (show && leadData?.lead_id) {
      const fetchCalculationData = async () => {
        try {
          setIsFetching(true);
          const token = authToken || localStorage.getItem('token');

          console.log('📋 [Revise Modal] Fetching from final_leads_calculations for lead:', leadData.lead_id);

          // Get partner_id if exists
          const partnerId = leadData.partner_id?._id || leadData.partner_id;
          console.log('🤝 [Revise Modal] Partner ID:', partnerId);

          const API_BASE_URL = `${API_BASE}/v1/admin/`;
          const fetchUrl = partnerId
            ? `${API_BASE_URL}private/fetch_lead_calculations/${leadData.lead_id}?partner_id=${partnerId}`
            : `${API_BASE_URL}private/fetch_lead_calculations/${leadData.lead_id}`;

          console.log('📞 [Revise Modal] Fetching from:', fetchUrl);

          const response = await fetch(fetchUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });

          const result = await response.json();
          console.log('📡 [Revise Modal] API Response:', result);
          console.log('📦 [Revise Modal] Full Data:', JSON.stringify(result.data, null, 2));

          if (result.status === 200 && result.data) {
            const { purchase_breakdown, sale_breakdown } = result.data;
            console.log('🏠 [Revise Modal] Purchase Breakdown:', JSON.stringify(purchase_breakdown, null, 2));
            console.log('🏘️ [Revise Modal] Sale Breakdown:', JSON.stringify(sale_breakdown, null, 2));

            // 🏠 Load Purchase data
            let purchaseTotalsTemp = { net: 0, vat: 0, gross: 0 };
            if (purchase_breakdown?.fees) {
              const pFees = purchase_breakdown.fees;
              const pDisb = purchase_breakdown.disbursements || {};
              const newPurchaseFees = {
                // Legal Fees (with VAT)
                legal_fee: pFees.legalFee?.amount || 0,
                tt_fee: pFees.ttFee?.amount || pFees.telegraphicTransferFee?.amount || 0,
                mortgage_admin_fee: pFees.mortgageAdminFee?.amount || 0,
                leasehold_fee: pFees.leaseholdFee?.amount || 0,
                help_to_buy_isa_fee: pFees.helpToBuyISAFee?.amount || 0,
                help_to_buy_fee: pFees.helpToBuyFee?.amount || 0,
                right_to_buy_fee: pFees.rightToBuyFee?.amount || 0,
                shared_ownership_fee: pFees.sharedOwnershipFee?.amount || 0,
                new_build_fee: pFees.newBuildFee?.amount || 0,
                islamic_mortgage_fee: pFees.islamicMortgageFee?.amount || 0,
                auction_repossession_fee: pFees.auctionRepossessionFee?.amount || 0,
                gifted_deposit_fee: pFees.giftedDepositFeeFirstGiftor?.amount || 0,
                gifted_deposit_fee_additional: pFees.giftedDepositFeeAdditionalGiftors?.amount || 0,
                buy_to_let_fee: pFees.buyToLetFee?.amount || 0,
                arranging_indemnity_policy: pFees.arrangingIndemnityPolicy?.amount || 0,
                // Disbursements
                identity_check: pFees.identityCheck?.amount || 0,
                stamp_duty: pDisb.stampDuty?.amount || 0,
                hm_land_registry_fee: pDisb.hmLandRegistryFee?.amount || 0,
                land_registry_search: pDisb.landRegistrySearch?.amount || 0,
                land_charges_search: pDisb.landChargesSearch?.amount || 0,
                search_pack: pDisb.searchPack?.amount || 0
              };
              console.log('✅ [Revise Modal] Purchase Fees Loaded:', newPurchaseFees);
              setPurchaseFees(newPurchaseFees);
              const totals = calculatePurchaseTotals(newPurchaseFees, true, purchase_breakdown);
              console.log('📊 [Revise Modal] Purchase Totals:', totals);
              if (totals) purchaseTotalsTemp = totals;
            }

            // 🏘️ Load Sale data
            let saleTotalsTemp = { net: 0, vat: 0, gross: 0 };
            if (sale_breakdown?.fees) {
              const sFees = sale_breakdown.fees;
              const sDisb = sale_breakdown.disbursements || {};
              const newSaleFees = {
                // Legal Fees (with VAT)
                legal_fee: sFees.legalFee?.amount || 0,
                tt_fee: sFees.ttFee?.amount || sFees.telegraphicTransferFee?.amount || 0,
                leasehold_fee: sFees.leaseholdFee?.amount || 0,
                mortgage_admin_fee: sFees.mortgageAdminFee?.amount || 0,
                shared_ownership_fee: sFees.sharedOwnershipFee?.amount || 0,
                auction_repossession_fee: sFees.auctionRepossessionFee?.amount || 0,
                // Disbursements
                identity_check: sFees.identityCheck?.amount || 0,
                official_copies: sDisb.officialCopiesFee?.amount || sDisb.officialCopies?.amount || 0
              };
              console.log('✅ [Revise Modal] Sale Fees Loaded:', newSaleFees);
              setSaleFees(newSaleFees);
              const totals = calculateSaleTotals(newSaleFees, true, sale_breakdown);
              console.log('📊 [Revise Modal] Sale Totals:', totals);
              if (totals) saleTotalsTemp = totals;
            }

            // 🎯 Update Grand Total after both are loaded
            console.log('🎯 [Revise Modal] Updating Grand Total with:', { purchaseTotalsTemp, saleTotalsTemp });
            updateGrandTotal(purchaseTotalsTemp, saleTotalsTemp);

            console.log('✅ [Revise Modal] Data loaded from final_leads_calculations');
          }
        } catch (error) {
          console.error('❌ [Revise Modal] Error fetching data:', error);
        } finally {
          setIsFetching(false);
        }
      };

      fetchCalculationData();
    }
  }, [leadData?.lead_id, show]);


  // Calculate Purchase totals
  const calculatePurchaseTotals = (fees, useBreakdown = false, breakdown = null) => {
    if (useBreakdown && breakdown && breakdown.totals) {
      const totals = breakdown.totals;
      // Ensure totals has legalCost, disbursementCost AND top-level net/vat/gross
      if (!totals.legalCost || !totals.disbursementCost || totals.net === undefined || totals.gross === undefined) {
        // If missing, calculate it from fees
        console.log('⚠️ Totals incomplete (missing legalCost/disbursementCost or net/gross), calculating from fees...');
        // Continue to manual calculation below
      } else {
        // Ensure totals structure is complete
        const completeTotals = {
          net: totals.net || 0,
          vat: totals.vat || 0,
          gross: totals.gross || 0,
          legalCost: totals.legalCost,
          disbursementCost: totals.disbursementCost
        };
        setPurchaseTotals(completeTotals);
        // Don't return here - we need to update grand total
        // But we can't call updateGrandTotal directly because saleTotals might not be set yet
        return completeTotals;
      }
    }

    // Legal Fees (with 20% VAT)
    const legalFeeNet = Number(fees.legal_fee) || 0;
    const ttFeeNet = Number(fees.tt_fee) || 0;
    const mortgageAdminFeeNet = Number(fees.mortgage_admin_fee) || 0;
    const leaseholdFeeNet = Number(fees.leasehold_fee) || 0;
    const helpToBuyISAFeeNet = Number(fees.help_to_buy_isa_fee) || 0;
    const helpToBuyFeeNet = Number(fees.help_to_buy_fee) || 0;
    const rightToBuyFeeNet = Number(fees.right_to_buy_fee) || 0;
    const sharedOwnershipFeeNet = Number(fees.shared_ownership_fee) || 0;
    const newBuildFeeNet = Number(fees.new_build_fee) || 0;
    const islamicMortgageFeeNet = Number(fees.islamic_mortgage_fee) || 0;
    const auctionRepossessionFeeNet = Number(fees.auction_repossession_fee) || 0;
    const giftedDepositFeeNet = Number(fees.gifted_deposit_fee) || 0;
    const giftedDepositFeeAdditionalNet = Number(fees.gifted_deposit_fee_additional) || 0;
    const buyToLetFeeNet = Number(fees.buy_to_let_fee) || 0;
    const arrangingIndemnityPolicyNet = Number(fees.arranging_indemnity_policy) || 0;

    // Disbursements (no VAT except search fees)
    const identityCheckNet = Number(fees.identity_check) || 0;
    const stampDutyNet = Number(fees.stamp_duty) || 0;
    const hmLandRegistryFeeNet = Number(fees.hm_land_registry_fee) || 0;
    const landRegistrySearchNet = Number(fees.land_registry_search) || 0;
    const landChargesSearchNet = Number(fees.land_charges_search) || 0;
    const searchPackNet = Number(fees.search_pack) || 0;

    // Calculate VAT (20% on legal fees and search fees)
    const legalFeeVAT = legalFeeNet * 0.20;
    const ttFeeVAT = ttFeeNet * 0.20;
    const mortgageAdminFeeVAT = mortgageAdminFeeNet * 0.20;
    const leaseholdFeeVAT = leaseholdFeeNet * 0.20;
    const helpToBuyISAFeeVAT = helpToBuyISAFeeNet * 0.20;
    const helpToBuyFeeVAT = helpToBuyFeeNet * 0.20;
    const rightToBuyFeeVAT = rightToBuyFeeNet * 0.20;
    const sharedOwnershipFeeVAT = sharedOwnershipFeeNet * 0.20;
    const newBuildFeeVAT = newBuildFeeNet * 0.20;
    const islamicMortgageFeeVAT = islamicMortgageFeeNet * 0.20;
    const auctionRepossessionFeeVAT = auctionRepossessionFeeNet * 0.20;
    const giftedDepositFeeVAT = giftedDepositFeeNet * 0.20;
    const giftedDepositFeeAdditionalVAT = giftedDepositFeeAdditionalNet * 0.20;
    const buyToLetFeeVAT = buyToLetFeeNet * 0.20;
    const arrangingIndemnityPolicyVAT = arrangingIndemnityPolicyNet * 0.20;
    const landRegistrySearchVAT = landRegistrySearchNet * 0.20;
    const landChargesSearchVAT = landChargesSearchNet * 0.20;

    // Calculate Legal Cost (all fees before disbursements)
    const legalCostNet = legalFeeNet + ttFeeNet + mortgageAdminFeeNet + leaseholdFeeNet +
                        helpToBuyISAFeeNet + helpToBuyFeeNet + rightToBuyFeeNet + sharedOwnershipFeeNet +
                        newBuildFeeNet + islamicMortgageFeeNet + auctionRepossessionFeeNet + giftedDepositFeeNet +
                        giftedDepositFeeAdditionalNet + buyToLetFeeNet + arrangingIndemnityPolicyNet + identityCheckNet;

    const legalCostVAT = legalFeeVAT + ttFeeVAT + mortgageAdminFeeVAT + leaseholdFeeVAT +
                        helpToBuyISAFeeVAT + helpToBuyFeeVAT + rightToBuyFeeVAT + sharedOwnershipFeeVAT +
                        newBuildFeeVAT + islamicMortgageFeeVAT + auctionRepossessionFeeVAT + giftedDepositFeeVAT +
                        giftedDepositFeeAdditionalVAT + buyToLetFeeVAT + arrangingIndemnityPolicyVAT;

    const legalCostGross = legalCostNet + legalCostVAT;

    // Calculate Disbursement Cost (Third Party Expenditure)
    const disbursementCostNet = stampDutyNet + hmLandRegistryFeeNet + landRegistrySearchNet +
                               landChargesSearchNet + searchPackNet;

    const disbursementCostVAT = landRegistrySearchVAT + landChargesSearchVAT;

    const disbursementCostGross = disbursementCostNet + disbursementCostVAT;

    // Calculate Grand Totals
    const totalNet = legalCostNet + disbursementCostNet;
    const totalVAT = legalCostVAT + disbursementCostVAT;
    const totalGross = totalNet + totalVAT;

    const newTotals = {
      net: totalNet,
      vat: totalVAT,
      gross: totalGross,
      legalCost: { net: legalCostNet, vat: legalCostVAT, gross: legalCostGross },
      disbursementCost: { net: disbursementCostNet, vat: disbursementCostVAT, gross: disbursementCostGross }
    };
    setPurchaseTotals(newTotals);
    updateGrandTotal(newTotals, saleTotals);
  };

  // Calculate Sale totals
  const calculateSaleTotals = (fees, useBreakdown = false, breakdown = null) => {
    if (useBreakdown && breakdown && breakdown.totals) {
      const totals = breakdown.totals;
      // Ensure totals has legalCost, disbursementCost AND top-level net/vat/gross
      if (!totals.legalCost || !totals.disbursementCost || totals.net === undefined || totals.gross === undefined) {
        // If missing, calculate it from fees
        console.log('⚠️ Sale totals incomplete (missing legalCost/disbursementCost or net/gross), calculating from fees...');
        // Continue to manual calculation below
      } else {
        // Ensure totals structure is complete
        const completeTotals = {
          net: totals.net || 0,
          vat: totals.vat || 0,
          gross: totals.gross || 0,
          legalCost: totals.legalCost,
          disbursementCost: totals.disbursementCost
        };
        setSaleTotals(completeTotals);
        // Don't return here - we need to update grand total
        return completeTotals;
      }
    }

    // Legal Fees (with 20% VAT)
    const legalFeeNet = Number(fees.legal_fee) || 0;
    const ttFeeNet = Number(fees.tt_fee) || 0;
    const leaseholdFeeNet = Number(fees.leasehold_fee) || 0;
    const mortgageAdminFeeNet = Number(fees.mortgage_admin_fee) || 0;
    const sharedOwnershipFeeNet = Number(fees.shared_ownership_fee) || 0;
    const auctionRepossessionFeeNet = Number(fees.auction_repossession_fee) || 0;

    // Disbursements (no VAT)
    const identityCheckNet = Number(fees.identity_check) || 0;
    const officialCopiesNet = Number(fees.official_copies) || 0;

    // Calculate VAT (20% on legal fees)
    const legalFeeVAT = legalFeeNet * 0.20;
    const ttFeeVAT = ttFeeNet * 0.20;
    const leaseholdFeeVAT = leaseholdFeeNet * 0.20;
    const mortgageAdminFeeVAT = mortgageAdminFeeNet * 0.20;
    const sharedOwnershipFeeVAT = sharedOwnershipFeeNet * 0.20;
    const auctionRepossessionFeeVAT = auctionRepossessionFeeNet * 0.20;

    // Calculate Legal Cost (all fees before disbursements)
    const legalCostNet = legalFeeNet + ttFeeNet + leaseholdFeeNet + mortgageAdminFeeNet +
                        sharedOwnershipFeeNet + auctionRepossessionFeeNet + identityCheckNet;

    const legalCostVAT = legalFeeVAT + ttFeeVAT + leaseholdFeeVAT + mortgageAdminFeeVAT +
                        sharedOwnershipFeeVAT + auctionRepossessionFeeVAT;

    const legalCostGross = legalCostNet + legalCostVAT;

    // Calculate Disbursement Cost (Third Party Expenditure)
    const disbursementCostNet = officialCopiesNet;
    const disbursementCostVAT = 0; // No VAT on Official Copies
    const disbursementCostGross = disbursementCostNet + disbursementCostVAT;

    // Calculate Grand Totals
    const totalNet = legalCostNet + disbursementCostNet;
    const totalVAT = legalCostVAT + disbursementCostVAT;
    const totalGross = totalNet + totalVAT;

    const newTotals = {
      net: totalNet,
      vat: totalVAT,
      gross: totalGross,
      legalCost: { net: legalCostNet, vat: legalCostVAT, gross: legalCostGross },
      disbursementCost: { net: disbursementCostNet, vat: disbursementCostVAT, gross: disbursementCostGross }
    };
    setSaleTotals(newTotals);
    updateGrandTotal(purchaseTotals, newTotals);
  };

  // Update grand total
  const updateGrandTotal = (pTotals, sTotals) => {
    setGrandTotal({
      net: pTotals.net + sTotals.net,
      vat: pTotals.vat + sTotals.vat,
      gross: pTotals.gross + sTotals.gross
    });
  };


  const handleReviseQuote = async () => {
    try {
      setIsLoading(true);

      // 🎯 Build nested format payload for Sale & Purchase
      const payload = {
        lead_id: leadData.lead_id || leadData._id,
        // Purchase fees - ALL fees from Purchase service
        purchase_fees: {
          legal_fee: Number(purchaseFees.legal_fee || 0),
          tt_fee: Number(purchaseFees.tt_fee || 0),
          mortgage_admin_fee: Number(purchaseFees.mortgage_admin_fee || 0),
          leasehold_fee: Number(purchaseFees.leasehold_fee || 0),
          help_to_buy_isa_fee: Number(purchaseFees.help_to_buy_isa_fee || 0),
          help_to_buy_fee: Number(purchaseFees.help_to_buy_fee || 0),
          right_to_buy_fee: Number(purchaseFees.right_to_buy_fee || 0),
          shared_ownership_fee: Number(purchaseFees.shared_ownership_fee || 0),
          new_build_fee: Number(purchaseFees.new_build_fee || 0),
          islamic_mortgage_fee: Number(purchaseFees.islamic_mortgage_fee || 0),
          auction_repossession_fee: Number(purchaseFees.auction_repossession_fee || 0),
          gifted_deposit_fee: Number(purchaseFees.gifted_deposit_fee || 0),
          gifted_deposit_fee_additional: Number(purchaseFees.gifted_deposit_fee_additional || 0),
          buy_to_let_fee: Number(purchaseFees.buy_to_let_fee || 0),
          arranging_indemnity_policy: Number(purchaseFees.arranging_indemnity_policy || 0),
          identity_check: Number(purchaseFees.identity_check || 0),
          stamp_duty: Number(purchaseFees.stamp_duty || 0),
          hm_land_registry_fee: Number(purchaseFees.hm_land_registry_fee || 0),
          land_registry_search: Number(purchaseFees.land_registry_search || 0),
          land_charges_search: Number(purchaseFees.land_charges_search || 0),
          search_pack: Number(purchaseFees.search_pack || 0)
        },
        // Sale fees - ALL fees from Sale service
        sale_fees: {
          legal_fee: Number(saleFees.legal_fee || 0),
          tt_fee: Number(saleFees.tt_fee || 0),
          leasehold_fee: Number(saleFees.leasehold_fee || 0),
          mortgage_admin_fee: Number(saleFees.mortgage_admin_fee || 0),
          shared_ownership_fee: Number(saleFees.shared_ownership_fee || 0),
          auction_repossession_fee: Number(saleFees.auction_repossession_fee || 0),
          identity_check: Number(saleFees.identity_check || 0),
          official_copies: Number(saleFees.official_copies || 0)
        }
      };

      console.log('📝 [Revise Modal] Submitting revised quote for Sale & Purchase:', payload);

      // Call the parent's onReviseQuote callback
      await onReviseQuote(payload);

      // Close modal
      onHide();
    } catch (error) {
      console.error('❌ [Revise Modal] Error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Modal show={show} onHide={onHide} size="xl" centered className="revise-quote-modal">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600' }}>Revise Quote - Sale & Purchase</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem', maxHeight: '70vh', overflowY: 'auto' }}>

        {/* PURCHASE SECTION */}
        <div style={{ marginBottom: '2rem' }}>
          <h5 style={{
            backgroundColor: '#0d6efd',
            color: 'white',
            padding: '10px 15px',
            marginBottom: '0',
            borderRadius: '4px 4px 0 0',
            fontWeight: '600'
          }}>
            Purchase Section
          </h5>
          <div className="table-responsive">
            <Table bordered hover style={{ marginBottom: 0 }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', padding: '12px 15px', width: '40%' }}>Description</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Net</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>VAT</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Gross</th>
                </tr>
              </thead>
              <tbody>
                {/* Legal Fees */}
                <tr style={{ backgroundColor: '#e7f1ff' }}>
                  <td colSpan="4" style={{ padding: '8px 15px', fontWeight: '600', fontSize: '0.95rem' }}>
                    Legal Fees
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Legal Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.legal_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, legal_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.legal_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.legal_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TT Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.tt_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, tt_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.tt_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.tt_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Mortgage Admin Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.mortgage_admin_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, mortgage_admin_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.mortgage_admin_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.mortgage_admin_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Leasehold Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.leasehold_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, leasehold_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.leasehold_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.leasehold_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Help to Buy ISA Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.help_to_buy_isa_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, help_to_buy_isa_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.help_to_buy_isa_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.help_to_buy_isa_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Help to Buy Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.help_to_buy_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, help_to_buy_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.help_to_buy_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.help_to_buy_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Right to Buy Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.right_to_buy_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, right_to_buy_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.right_to_buy_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.right_to_buy_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Shared Ownership Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.shared_ownership_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, shared_ownership_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.shared_ownership_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.shared_ownership_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>New Build Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.new_build_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, new_build_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.new_build_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.new_build_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Islamic Mortgage Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.islamic_mortgage_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, islamic_mortgage_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.islamic_mortgage_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.islamic_mortgage_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Auction/Repossession Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.auction_repossession_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, auction_repossession_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.auction_repossession_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.auction_repossession_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Gifted Deposit Fee (1st Giftor)</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.gifted_deposit_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, gifted_deposit_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.gifted_deposit_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.gifted_deposit_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Gifted Deposit Fee (Additional Giftors)</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.gifted_deposit_fee_additional}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, gifted_deposit_fee_additional: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.gifted_deposit_fee_additional) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.gifted_deposit_fee_additional) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Buy to Let Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.buy_to_let_fee}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, buy_to_let_fee: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.buy_to_let_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.buy_to_let_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Arranging Indemnity Policy</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={purchaseFees.arranging_indemnity_policy}
                        onChange={(e) => {
                          const newFees = { ...purchaseFees, arranging_indemnity_policy: e.target.value };
                          setPurchaseFees(newFees);
                          calculatePurchaseTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.arranging_indemnity_policy) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.arranging_indemnity_policy) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Identity Check</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.identity_check).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>£0.00</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(purchaseFees.identity_check).toFixed(2)}
                  </td>
                </tr>

                {/* Disbursements */}
                <tr style={{ backgroundColor: '#e7f1ff' }}>
                  <td colSpan="4" style={{ padding: '8px 15px', fontWeight: '600', fontSize: '0.95rem' }}>
                    Disbursements
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>HM Land Registry Fee</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.hm_land_registry_fee).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>£0.00</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(purchaseFees.hm_land_registry_fee).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Stamp Duty Land Tax</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.stamp_duty).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>£0.00</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(purchaseFees.stamp_duty).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Land Registry Search</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.land_registry_search).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.land_registry_search) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.land_registry_search) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Land Charges Search</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.land_charges_search).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(purchaseFees.land_charges_search) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(purchaseFees.land_charges_search) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Search Pack</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(purchaseFees.search_pack).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>£0.00</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(purchaseFees.search_pack).toFixed(2)}
                  </td>
                </tr>

                {/* TOTAL LEGAL COST */}
                <tr style={{ backgroundColor: '#fff3cd', fontWeight: '600', borderTop: '2px solid #dee2e6' }}>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TOTAL LEGAL COST</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.legalCost?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.legalCost?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.legalCost?.gross || 0).toFixed(2)}
                  </td>
                </tr>

                {/* TOTAL DISBURSEMENT COST */}
                <tr style={{ backgroundColor: '#d1ecf1', fontWeight: '600' }}>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TOTAL DISBURSEMENT COST</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.disbursementCost?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.disbursementCost?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(purchaseTotals?.disbursementCost?.gross || 0).toFixed(2)}
                  </td>
                </tr>

                {/* Purchase Total (Legal cost + disbursement) */}
                <tr style={{ backgroundColor: '#d4edda', fontWeight: '700', fontSize: '1rem', borderTop: '2px solid #28a745' }}>
                  <td style={{ padding: '15px' }}>Total (Legal cost + disbursement)</td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(purchaseTotals?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(purchaseTotals?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(purchaseTotals?.gross || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        {/* SALE SECTION */}
        <div style={{ marginBottom: '1rem' }}>
          <h5 style={{
            backgroundColor: '#198754',
            color: 'white',
            padding: '10px 15px',
            marginBottom: '0',
            borderRadius: '4px 4px 0 0',
            fontWeight: '600'
          }}>
            Sale Section
          </h5>
          <div className="table-responsive">
            <Table bordered hover style={{ marginBottom: 0 }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', padding: '12px 15px', width: '40%' }}>Description</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Net</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>VAT</th>
                  <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Gross</th>
                </tr>
              </thead>
              <tbody>
                {/* Legal Fees */}
                <tr style={{ backgroundColor: '#d1f4e0' }}>
                  <td colSpan="4" style={{ padding: '8px 15px', fontWeight: '600', fontSize: '0.95rem' }}>
                    Legal Fees
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Legal Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.legal_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, legal_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.legal_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.legal_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>

                {/* Fixed Fees */}
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TT Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.tt_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, tt_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.tt_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.tt_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Leasehold Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.leasehold_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, leasehold_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.leasehold_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.leasehold_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Mortgage Admin Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.mortgage_admin_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, mortgage_admin_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.mortgage_admin_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.mortgage_admin_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Shared Ownership Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.shared_ownership_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, shared_ownership_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.shared_ownership_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.shared_ownership_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Auction/Repossession Fee</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ marginRight: '5px' }}>£</span>
                      <input
                        type="number"
                        value={saleFees.auction_repossession_fee}
                        onChange={(e) => {
                          const newFees = { ...saleFees, auction_repossession_fee: e.target.value };
                          setSaleFees(newFees);
                          calculateSaleTotals(newFees);
                        }}
                        style={{ width: '100px', padding: '5px', textAlign: 'right', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(Number(saleFees.auction_repossession_fee) * 0.20).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{(Number(saleFees.auction_repossession_fee) * 1.20).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Identity Check</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(saleFees.identity_check).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>£0.00</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(saleFees.identity_check).toFixed(2)}
                  </td>
                </tr>

                {/* Disbursements */}
                <tr style={{ backgroundColor: '#d1f4e0' }}>
                  <td colSpan="4" style={{ padding: '8px 15px', fontWeight: '600', fontSize: '0.95rem' }}>
                    Disbursements
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>Official Copies</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{Number(saleFees.official_copies).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £0.00
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem', fontWeight: '600' }}>
                    £{Number(saleFees.official_copies).toFixed(2)}
                  </td>
                </tr>

                {/* TOTAL LEGAL COST */}
                <tr style={{ backgroundColor: '#fff3cd', fontWeight: '600', borderTop: '2px solid #dee2e6' }}>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TOTAL LEGAL COST</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.legalCost?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.legalCost?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.legalCost?.gross || 0).toFixed(2)}
                  </td>
                </tr>

                {/* TOTAL DISBURSEMENT COST */}
                <tr style={{ backgroundColor: '#d1ecf1', fontWeight: '600' }}>
                  <td style={{ padding: '12px 15px', fontSize: '0.95rem' }}>TOTAL DISBURSEMENT COST</td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.disbursementCost?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.disbursementCost?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px 15px', fontSize: '0.95rem' }}>
                    £{(saleTotals?.disbursementCost?.gross || 0).toFixed(2)}
                  </td>
                </tr>

                {/* Sale Total (Legal cost + disbursement) */}
                <tr style={{ backgroundColor: '#d4edda', fontWeight: '700', fontSize: '1rem', borderTop: '2px solid #28a745' }}>
                  <td style={{ padding: '15px' }}>Total (Legal cost + disbursement)</td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(saleTotals?.net || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(saleTotals?.vat || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '15px' }}>
                    £{(saleTotals?.gross || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer style={{ borderTop: 'none', padding: '0 20px 20px 20px', backgroundColor: '#f8f9fa' }}>
        <Button
          variant="outline-secondary"
          onClick={onHide}
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            fontWeight: '500'
          }}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleReviseQuote}
          disabled={isLoading}
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            fontWeight: '500',
            backgroundColor: '#dc3545',
            borderColor: '#dc3545'
          }}
        >
          {isLoading ? 'Updating...' : 'Revise Quote'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

// Customer Search Modal Component
function CustomerSearchModal({ show, onHide, authToken, onCustomerAdd, selectedCustomers = [], serviceType = 'Purchase' }) {
  const [searchFields, setSearchFields] = React.useState({
    title: '',
    forename: '',
    surname: '',
    email: '',
    phone_number: ''
  });
  const [searchResults, setSearchResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const debounceRef = React.useRef();

  const fetchCustomerSearch = async () => {
    const isEmpty = Object.values(searchFields).every(v => !v);
    if (isEmpty) {
      setSearchResults([]);
      return;
    }

    try {
      setLoading(true);
      const res = await postRequest('private/leadsCustomerList', searchFields, authToken);
      setSearchResults(res?.data || []);
    } catch (err) {
      console.error('Error fetching search:', err);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchCustomerSearch, 400);
    return () => clearTimeout(debounceRef.current);
  }, [searchFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchFields((prev) => ({ ...prev, [name]: value }));
  };

  const isCustomerAdded = (customerId) => {
    return selectedCustomers.some(c => c._id === customerId);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{serviceType === 'Sale' ? 'Add Vendor' : 'Add Purchaser'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='m-0'>
          {['title', 'forename', 'surname', 'email', 'phone_number'].map((field, idx) => (
            <Col xs={field === 'email' || field === 'phone_number' ? 6 : 4} key={idx}>
              <Box sx={{ '& > :not(style)': { m: 1, width: '100%' } }}>
                <TextField
                  label={field === 'phone_number' ? 'Phone Number' : field.charAt(0).toUpperCase() + field.slice(1)}
                  name={field}
                  value={searchFields[field]}
                  onChange={handleChange}
                  variant="outlined"
                  type={field === 'email' ? 'email' : field === 'phone_number' ? 'tel' : 'text'}
                />
              </Box>
            </Col>
          ))}
        </Row>

        <Row className='mt-4'>
          <Col>
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Add</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" className='text-center'>Loading...</td></tr>
                ) : searchResults.length > 0 ? (
                  searchResults.map((customer) => (
                    <tr key={customer._id}>
                      <td>{customer.title} {customer.forename} {customer.surname}</td>
                      <td>{customer.email}</td>
                      <td>{customer.phone_number}</td>
                      <td>
                        <Button
                          variant="outlined"
                          size="small"
                          disabled={isCustomerAdded(customer._id)}
                          onClick={() => {
                            onCustomerAdd(customer);
                            onHide();
                          }}
                          style={{
                            fontSize: '12px',
                            padding: '4px 12px'
                          }}
                        >
                          {isCustomerAdded(customer._id) ? 'Added' : 'Add'}
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4" className='text-center'>No customers found</td></tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

// Edit Modal Component  
function EditConveyancingModal({ show, onHide, leadData, authToken, onUpdate }) {
  const [formData, setFormData] = React.useState({
    // Property Address
    line1: '',
    line2: '',
    town: '',
    county: '',
    postcode: '',

    // Property Details
    property_value: '',
    service_type: 'Purchase',
    ownership_type: 'Freehold',
    completion_date: '',

    // Purchasers
    purchasers: [],

    // Info fields - Purchase (18 fields)
    firstTimeBuyer: false,
    helpToBuyISA: false,
    helpToBuy: false,
    helpToBuyEquityLoan: false,
    rightToBuy: false,
    sharedOwnership: false,
    buyingWithMortgage: false,
    newBuild: false,
    islamicMortgage: false,
    auctionRepossession: false,
    giftedDeposit: '',
    multipleProperties: false,
    buyToLet: false,
    arrangingIndemnityPolicy: false,
    unregisteredProperty: false,
    staircasing: false,
    isNonUKResident: false,
    nonResidentialMixed: false,

    // Info fields - Sale specific (5 fields)
    sellingWithMortgage: false
  });

  const [isLoading, setIsLoading] = React.useState(false);
  const [showCustomerModal, setShowCustomerModal] = React.useState(false);

  // Auto-fill form when modal opens or leadData changes
  React.useEffect(() => {
    if (leadData && show) {
      console.log('Auto-filling edit form with lead data:', leadData);
      
      // Parse property address
      let addressData = {
        line1: '',
        line2: '',
        town: '',
        county: '',
        postcode: ''
      };

      if (leadData.property_address) {
        if (typeof leadData.property_address === 'string') {
          const parts = leadData.property_address.split(',').map(p => p.trim());
          addressData.line1 = parts[0] || '';
          addressData.line2 = parts[1] || '';
          addressData.town = parts[2] || '';
          addressData.county = parts[3] || '';
          addressData.postcode = parts[parts.length - 1] || '';
        } else if (typeof leadData.property_address === 'object') {
          addressData.line1 = leadData.property_address.address1 || leadData.property_address.line1 || '';
          addressData.line2 = leadData.property_address.address2 || leadData.property_address.line2 || '';
          addressData.town = leadData.property_address.town || leadData.property_address.city || '';
          addressData.county = leadData.property_address.county || leadData.property_address.state || '';
          addressData.postcode = leadData.property_address.postcode || leadData.property_address.postal_code || '';
        }
      }

      setFormData({
        ...addressData,
        property_value: leadData.property_value || '',
        service_type: leadData.service_type || 'Purchase',
        ownership_type: leadData.leasehold ? 'Leasehold' : 'Freehold',
        completion_date: leadData.completion_date ? new Date(leadData.completion_date).toISOString().split('T')[0] : '',
        purchasers: leadData.customer_ids || [],
        // Info fields - Purchase
        firstTimeBuyer: leadData.first_time_buyer || false,
        helpToBuyISA: leadData.help_to_buy_isa || false,
        helpToBuy: leadData.help_to_buy || false,
        helpToBuyEquityLoan: leadData.help_to_buy_equity_loan || false,
        rightToBuy: leadData.right_to_buy || false,
        sharedOwnership: leadData.shared_ownership || false,
        buyingWithMortgage: !!leadData.mortgage_lender,
        newBuild: leadData.new_build || false,
        islamicMortgage: leadData.islamic_mortgage || false,
        auctionRepossession: leadData.auction_repossession || false,
        giftedDeposit: leadData.gifted_deposit || '',
        multipleProperties: leadData.multiple_properties || false,
        buyToLet: leadData.buy_to_let || false,
        arrangingIndemnityPolicy: leadData.arranging_indemnity_policy || false,
        unregisteredProperty: leadData.unregistered_property || false,
        staircasing: leadData.staircasing || false,
        isNonUKResident: leadData.is_non_uk_resident || false,
        nonResidentialMixed: leadData.non_residential_mixed || false,
        // Info fields - Sale
        sellingWithMortgage: leadData.selling_with_mortgage || leadData.info?.sellingWithMortgage || leadData.conveyancing_details?.selling_with_mortgage || false
      });
    }
  }, [leadData, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const updatePayload = {
        property_address: {
          address1: formData.line1,
          address2: formData.line2,
          town: formData.town,
          county: formData.county,
          postcode: formData.postcode
        },
        property_value: parseFloat(formData.property_value) || 0,
        ownership_type: formData.ownership_type,
        completion_date: formData.completion_date,
        
        // Customer fields
        customer_ids: formData.purchasers.map(p => p._id || p),
        
        // Info fields - Purchase
        first_time_buyer: formData.firstTimeBuyer,
        help_to_buy_isa: formData.helpToBuyISA,
        help_to_buy: formData.helpToBuy,
        help_to_buy_equity_loan: formData.helpToBuyEquityLoan,
        right_to_buy: formData.rightToBuy,
        shared_ownership: formData.sharedOwnership,
        buying_with_mortgage: formData.buyingWithMortgage,
        new_build: formData.newBuild,
        islamic_mortgage: formData.islamicMortgage,
        auction_repossession: formData.auctionRepossession,
        gifted_deposit: formData.giftedDeposit,
        multiple_properties: formData.multipleProperties,
        buy_to_let: formData.buyToLet,
        arranging_indemnity_policy: formData.arrangingIndemnityPolicy,
        unregistered_property: formData.unregisteredProperty,
        staircasing: formData.staircasing,
        is_non_uk_resident: formData.isNonUKResident,
        non_residential_mixed: formData.nonResidentialMixed,

        // Info fields - Sale
        selling_with_mortgage: formData.sellingWithMortgage
      };

      console.log('Updating conveyancing lead:', updatePayload);

      // Use appropriate API endpoint based on service_type
      const apiEndpoint = formData.service_type === 'Sale'
        ? `private/editConveyancingSale/${leadData._id}`
        : `private/editConveyancingPurchase/${leadData._id}`;

      const response = await putRequest(apiEndpoint, updatePayload);

      if (response?.status === 'success' || response?.status === 200) {
        Swal.fire('Success', 'Conveyancing details updated successfully!', 'success');
        onUpdate(updatePayload);
        onHide();
      } else {
        throw new Error(response?.message || 'Update failed');
      }
    } catch (error) {
      console.error('Error updating conveyancing:', error);
      Swal.fire('Error', error.message || 'Failed to update conveyancing details', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleInfoClick = (field) => {
    setFormData(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleRemovePurchaser = (index) => {
    setFormData(prev => ({
      ...prev,
      purchasers: prev.purchasers.filter((_, i) => i !== index)
    }));
  };

  const handleAddPurchaser = (customer) => {
    setFormData(prev => ({
      ...prev,
      purchasers: [...prev.purchasers, customer]
    }));
  };

  // Info button style
  const infoButtonStyle = (isActive) => ({
    padding: '6px 12px',
    margin: '3px',
    border: isActive ? '1px solid #6f42c1' : '1px solid #ced4da',
    borderRadius: '3px',
    backgroundColor: isActive ? '#6f42c1' : 'white',
    color: isActive ? 'white' : '#495057',
    fontSize: '13px',
    fontWeight: '400',
    cursor: 'pointer',
    transition: 'all 0.15s',
    outline: 'none',
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  });

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '500' }}>
          Edit Conveyancing #{leadData?.lead_id || 'L5633'} - {leadData?.service_type?.replace(/_/g, ' ') || 'Purchase'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '0' }}>
        {/* Purchase/Sale Details Header */}
        <div style={{ 
          backgroundColor: '#e9ecef', 
          padding: '10px 20px', 
          marginBottom: '0',
          fontSize: '14px',
          fontWeight: '500',
          color: '#495057'
        }}>
          {formData.service_type === 'Sale' ? 'Sale' : 'Purchase'} Details
        </div>

        <Form onSubmit={handleSubmit} style={{ padding: '20px' }}>
          {/* Property Section */}
          <div style={{ marginBottom: '25px' }}>
            <h6 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '15px', color: '#212529' }}>Property</h6>
            
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label style={{ fontSize: '13px', marginBottom: '5px', color: '#495057', fontWeight: '500' }}>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="line1"
                    value={formData.line1}
                    onChange={handleChange}
                    placeholder="Address Line 1"
                    style={{ marginBottom: '8px', fontSize: '14px' }}
                  />
                  <Form.Control
                    type="text"
                    name="line2"
                    value={formData.line2}
                    onChange={handleChange}
                    placeholder="Address Line 2"
                    style={{ marginBottom: '8px', fontSize: '14px' }}
                  />
                  <Form.Control
                    type="text"
                    name="town"
                    value={formData.town}
                    onChange={handleChange}
                    placeholder="Town/City"
                    style={{ marginBottom: '8px', fontSize: '14px' }}
                  />
                  <Form.Control
                    type="text"
                    name="county"
                    value={formData.county}
                    onChange={handleChange}
                    placeholder="County"
                    style={{ marginBottom: '8px', fontSize: '14px' }}
                  />
                  <Form.Control
                    type="text"
                    name="postcode"
                    value={formData.postcode}
                    onChange={handleChange}
                    placeholder="Postcode"
                    style={{ fontSize: '14px' }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontSize: '13px', marginBottom: '5px', color: '#495057', fontWeight: '500' }}>Service Type</Form.Label>
                  <Form.Select
                    name="service_type"
                    value={formData.service_type || 'Purchase'}
                    onChange={handleChange}
                  >
                    <option value="Purchase">Purchase</option>
                    <option value="Sale">Sale</option>
                    <option value="Remortgage">Remortgage</option>
                  </Form.Select>
                </Form.Group>
                
                {/* Put Purchase/Sale Price and Ownership Type in same row */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: '13px', marginBottom: '5px', color: '#495057', fontWeight: '500' }}>
                        {formData.service_type === 'Sale' ? 'Sale Price' : 'Purchase Price'}
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>£</InputGroup.Text>
                        <Form.Control
                          type="number"
                          name="property_value"
                          value={formData.property_value}
                          onChange={handleChange}
                          placeholder="0.00"
                          style={{ fontSize: '14px' }}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: '13px', marginBottom: '5px', color: '#495057', fontWeight: '500' }}>Ownership Type</Form.Label>
                      <Form.Select
                        name="ownership_type"
                        value={formData.ownership_type}
                        onChange={handleChange}
                      >
                        <option value="Freehold">Freehold</option>
                        <option value="Leasehold">Leasehold</option>
                        <option value="Share of Freehold">Share of Freehold</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                {/* Only show Est. Completion Date for Purchase and Remortgage, NOT for Sale */}
                {(formData.service_type === 'Purchase' || formData.service_type === 'Remortgage' || !formData.service_type) && (
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', marginBottom: '5px', color: '#495057', fontWeight: '500' }}>Est. Completion Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="completion_date"
                      value={formData.completion_date}
                      onChange={handleChange}
                    />
                  </Form.Group>
                )}
              </Col>
            </Row>
          </div>

          {/* Purchasers/Vendors Section */}
          <div style={{ marginBottom: '25px' }}>
            <h6 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '15px', color: '#212529' }}>
              {formData.service_type === 'Sale' ? 'Vendors' : 'Purchasers'}
            </h6>
            
            <div style={{ marginBottom: '15px' }}>
              {formData.purchasers.map((purchaser, index) => (
                <div key={index} style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: '10px',
                  padding: '10px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  border: '1px solid #dee2e6'
                }}>
                  <span style={{ flex: 1 }}>
                    {purchaser.title || ''} {purchaser.forename || purchaser.firstName || ''} {purchaser.surname || purchaser.lastName || ''}
                  </span>
                  <span style={{ marginRight: '20px', color: '#6c757d' }}>
                    <MailOutlineIcon fontSize="small" style={{ marginRight: '5px' }} />
                    {purchaser.email || ''}
                  </span>
                  <span style={{ marginRight: '20px', color: '#6c757d' }}>
                    <PhoneIcon fontSize="small" style={{ marginRight: '5px' }} />
                    {purchaser.phone_number || purchaser.phone || ''}
                  </span>
                  <Button
                    size="small"
                    variant="text"
                    color="error"
                    onClick={() => handleRemovePurchaser(index)}
                  >
                    ×
                  </Button>
                </div>
              ))}
              
              <Button
                variant="text"
                size="small"
                style={{ color: '#dc3545', textDecoration: 'underline' }}
                onClick={() => setShowCustomerModal(true)}
              >
                {formData.service_type === 'Sale' ? 'Add Vendor' : 'Add Purchaser'}
              </Button>
            </div>
          </div>

          {/* Info Section */}
          <div style={{ marginBottom: '25px' }}>
            <h6 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '15px', color: '#212529' }}>Info</h6>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {(formData.service_type === 'Sale'
                ? [
                    // Sale Info - Only 5 fields
                    { field: 'sellingWithMortgage', label: 'Selling with Mortgage' },
                    { field: 'arrangingIndemnityPolicy', label: 'Arranging an Indemnity Policy' },
                    { field: 'unregisteredProperty', label: 'Unregistered Property' },
                    { field: 'sharedOwnership', label: 'Shared Ownership' },
                    { field: 'auctionRepossession', label: 'Auction / Repossession' }
                  ]
                : [
                    // Purchase Info - All 18 fields
                    { field: 'firstTimeBuyer', label: 'First Time Buyer', hasCheck: true },
                    { field: 'helpToBuyISA', label: 'Help to Buy ISA' },
                    { field: 'helpToBuy', label: 'Help to Buy' },
                    { field: 'helpToBuyEquityLoan', label: 'Help to Buy Equity Loan' },
                    { field: 'rightToBuy', label: 'Right to Buy' },
                    { field: 'sharedOwnership', label: 'Shared Ownership' },
                    { field: 'buyingWithMortgage', label: 'Buying with Mortgage' },
                    { field: 'newBuild', label: 'New Build' },
                    { field: 'islamicMortgage', label: 'Islamic Mortgage' },
                    { field: 'auctionRepossession', label: 'Auction / Repossession' },
                    { field: 'giftedDeposit', label: 'Gifted Deposit - Num Giftors', hasInput: true },
                    { field: 'multipleProperties', label: 'Multiple Properties' },
                    { field: 'buyToLet', label: 'Buy to Let' },
                    { field: 'arrangingIndemnityPolicy', label: 'Arranging an Indemnity Policy' },
                    { field: 'unregisteredProperty', label: 'Unregistered Property' },
                    { field: 'staircasing', label: 'Staircasing' },
                    { field: 'isNonUKResident', label: 'Is Non-UK Resident' },
                    { field: 'nonResidentialMixed', label: 'Non-Residential / Mixed Use' }
                  ]
              ).map((item) => (
                <div key={item.field} style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <button
                    type="button"
                    onClick={() => handleInfoClick(item.field)}
                    style={infoButtonStyle(formData[item.field])}
                  >
                    {item.hasCheck && formData[item.field] && <span>✓ </span>}
                    {item.label}
                  </button>
                  {item.hasInput && formData[item.field] && (
                    <input
                      type="number"
                      value={formData.giftedDeposit}
                      onChange={(e) => setFormData(prev => ({ ...prev, giftedDeposit: e.target.value }))}
                      style={{
                        width: '60px',
                        marginLeft: '8px',
                        padding: '4px 8px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '14px'
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: 'none', padding: '0 20px 20px 20px', backgroundColor: '#f8f9fa', justifyContent: 'flex-start' }}>
        <Button
          variant="danger"
          onClick={handleSubmit}
          disabled={isLoading}
          style={{
            backgroundColor: '#dc3545',
            border: 'none',
            padding: '8px 24px',
            fontSize: '14px',
            fontWeight: '500',
            borderRadius: '3px'
          }}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>

      {/* Customer Search Modal */}
      <CustomerSearchModal
        show={showCustomerModal}
        onHide={() => setShowCustomerModal(false)}
        authToken={authToken}
        onCustomerAdd={handleAddPurchaser}
        serviceType={formData.service_type}
        selectedCustomers={formData.purchasers}
      />
    </Modal>
  );
}

export default function ViewLeadSalePurchase() {
  const [modalShow, setModalShow] = React.useState(false);
  const [reviseModalShow, setReviseModalShow] = React.useState(false);
  const [leadData, setLeadData] = React.useState(null);

  // FORCE service_type for Sale-Purchase view
  const effectiveLeadData = leadData ? {
    ...leadData,
    service_type: leadData.service_type || 'Purchase_Sale'
  } : null;

  const [contactAttempts, setContactAttempts] = React.useState(leadData?.contact_attempts || 0);
  const [quoteHistory, setQuoteHistory] = React.useState([]);
  const [revisionCount, setRevisionCount] = React.useState(0);
  const [selectedQuote, setSelectedQuote] = React.useState(null);
  const [showQuoteDetailModal, setShowQuoteDetailModal] = React.useState(false);
  const [editModalShow, setEditModalShow] = React.useState(false);
  const [legalFeeData, setLegalFeeData] = React.useState(null);
  const [quoteFeeData, setQuoteFeeData] = React.useState(null);
  const [partners, setPartners] = React.useState([]);
  
  // Branch and cost calculation states
  const [branchInfo, setBranchInfo] = React.useState(null);
  const [conveyancingCosts, setConveyancingCosts] = React.useState(null);
  const [matchedBranch, setMatchedBranch] = React.useState(null);
  const [calculatedQuote, setCalculatedQuote] = React.useState(null);

  // Populated vendors and purchasers state
  const [populatedVendors, setPopulatedVendors] = React.useState([]);
  const [populatedPurchasers, setPopulatedPurchasers] = React.useState([]);
  const [isLoadingVendors, setIsLoadingVendors] = React.useState(false);
  const [isLoadingPurchasers, setIsLoadingPurchasers] = React.useState(false);

  // Communication / Email states
  const [emailTemplates, setEmailTemplates] = React.useState([]);
  const [emailLogs, setEmailLogs] = React.useState([]);
  const [loadingEmails, setLoadingEmails] = React.useState(false);
  const [sendingEmail, setSendingEmail] = React.useState(false);
  const [viewEmailModal, setViewEmailModal] = React.useState(false);
  const [selectedEmail, setSelectedEmail] = React.useState(null);

  const navigate = useNavigate();
  const authCtx = React.useContext(AuthContext);
  const { lead_id } = useParams();
  const userPermissions = authCtx.permissions;
  
  // Check permissions
  const canEditLeads = checkPermission(userPermissions, 'leads', 'edit');
  const canDeleteLeads = checkPermission(userPermissions, 'leads', 'delete');
  const canReviseQuotes = checkPermission(userPermissions, 'leads', 'revise_quotes');
  const canChangeGroupCode = checkPermission(userPermissions, 'leads', 'change_group_code');

  console.log('✅ Lead ID from params:', lead_id);

  const handleUpdateContactAttempt = async (type) => {
    let updatedCount = contactAttempts;

    if (type === 'increase') updatedCount += 1;
    else if (type === 'reset') updatedCount = 0;

    try {
      const res = await postRequest('private/change-contact-status', {
        lead_id: lead_id,
        contact_attempts: updatedCount,
      }, authCtx.token);

      if (res.status === 200 || res.status === 'success') {
        setContactAttempts(updatedCount);
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  // Fetch email templates from Automation actions - Only for Conveyancing product
  const fetchEmailTemplates = async () => {
    try {
      console.log('📧 === FETCHING CONVEYANCING AUTOMATION EMAIL TEMPLATES ===');
      console.log('Auth token:', authCtx.token ? 'Present' : 'Missing');
      console.log('Full leadData:', leadData);
      console.log('Lead data product_id:', leadData?.product_id);

      // Get conveyancing product ID from leadData
      let productId = leadData?.product_id?._id || leadData?.product_id;
      console.log('🔍 Product ID from leadData:', productId);

      // The email automations live on the "Conveyancing" product, and every
      // conveyancing service (including Sale & Purchase) shares it. Resolve to that
      // product's id so the Send Email dropdown is populated regardless of the lead's
      // stored product_id. (Products use the `title` field.)
      try {
        const productsRes = await postRequest('private/getAllProducts', {}, authCtx.token);
        console.log('📦 Products response:', productsRes);

        if (productsRes?.data) {
          const conveyancingProduct = productsRes.data.find(p =>
            (p.title || p.name || p.product_name || '').toLowerCase().includes('conveyancing')
          );

          if (conveyancingProduct) {
            productId = conveyancingProduct._id || conveyancingProduct.product_id;
            console.log('✅ Using Conveyancing product id for automations:', productId);
          } else {
            console.log('⚠️ Conveyancing product not found in products list');
          }
        }
      } catch (prodErr) {
        console.log('❌ Error fetching products:', prodErr);
      }

      // Fetch automation actions for this product
      console.log('📤 Fetching automation actions...');

      const automationUrl = `${API_BASE}/v1/admin/automationList`;
      console.log('🌐 Automation API URL:', automationUrl);

      // Pull automations from the API. When includeProduct is false we don't send a
      // productId, so "apply to all" (empty products) automations are guaranteed to
      // come back — this is the fallback when a product-scoped query returns nothing.
      const fetchAutomations = async (includeProduct) => {
        const body = { page: 1, limit: 100 };
        if (includeProduct && productId) body.productId = productId;

        const response = await fetch(automationUrl, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });
        const responseData = await response.json();
        console.log('📡 Automations response:', responseData, 'ok:', response.ok);
        if (response.ok && (responseData?.status === 200 || responseData?.status === 'success')) {
          return responseData.data?.docs || responseData.data || [];
        }
        return [];
      };

      const extractTemplates = (automations) => {
        const templates = [];
        (automations || []).forEach((automation) => {
          // Effect type is like "Send Email to customer"
          if (automation.effect && automation.effect.type?.toLowerCase().includes('send email')) {
            templates.push({
              _id: automation.effect.emailTemplateId?._id || automation._id,
              name: automation.effect.emailTemplateId?.name || 'Unnamed Template',
              template_id: automation.effect.emailTemplateId?._id,
              automation_id: automation._id,
              effect: automation.effect
            });
          }
        });
        return templates;
      };

      // Try product-scoped first; if it yields no email templates, retry without the
      // product filter so apply-to-all automations still populate the dropdown.
      let emailTemplates = extractTemplates(await fetchAutomations(true));
      if (emailTemplates.length === 0) {
        console.log('⚠️ No product-scoped templates, retrying without product filter...');
        emailTemplates = extractTemplates(await fetchAutomations(false));
      }

      console.log('📧 Total email templates extracted:', emailTemplates.length);
      setEmailTemplates(emailTemplates);
    } catch (error) {
      console.error('❌ Error fetching automation email templates:', error);
      setEmailTemplates([]);
    }
  };

  // Fetch email logs/communication history
  const fetchEmailLogs = async () => {
    try {
      setLoadingEmails(true);
      console.log('📧 Fetching email logs for lead:', lead_id);

      // Fetch actual sent email logs
      const emailLogsResponse = await postRequest('private/getEmailLogs', {
        lead_id: lead_id,
        page: 1,
        limit: 100
      }, authCtx.token);

      console.log('📧 Email logs response:', emailLogsResponse);

      const sentEmails = (emailLogsResponse?.status === 200 || emailLogsResponse?.status === 'success')
        ? (emailLogsResponse.data || [])
        : [];

      // Fetch "Immediately" automations for this lead's product
      let immediateAutomations = [];
      if (leadData?.product_id) {
        try {
          console.log('🔄 Fetching Immediately automations for product:', leadData.product_id);

          const automationsResponse = await postRequest('private/getImmediateAutomations', {
            product_id: leadData.product_id,
            trigger: 'Quotes/Generate New Quote'
          }, authCtx.token);

          console.log('🔄 Automations response:', automationsResponse);

          if (automationsResponse?.status === 200 || automationsResponse?.status === 'success') {
            // Transform automations to match email log format for display
            immediateAutomations = (automationsResponse.data || []).map(automation => ({
              _id: `automation-${automation._id}`,
              automation_id: automation._id,
              automation_name: automation.name,
              template_name: automation.emailTemplate?.name || automation.emailTemplate?.title || 'Email Template',
              subject: automation.emailTemplate?.subject || '',
              content: automation.emailTemplate?.content || '',
              recipient_name: 'Configured Automation',
              recipient_email: 'Triggers: Immediately',
              sent_at: null, // Not sent yet, this is just showing configured automations
              status: 'configured',
              isAutomation: true // Flag to distinguish from actual sent emails
            }));
            console.log('✅ Immediate automations loaded:', immediateAutomations.length);
          }
        } catch (autoError) {
          console.error('Error fetching automations:', autoError);
        }
      }

      // Show only sent emails in communication tab
      // Don't show "Not triggered" configured automations
      const allLogs = [...sentEmails];
      setEmailLogs(allLogs);
      console.log('✅ Email logs loaded - Sent:', sentEmails.length);

      setLoadingEmails(false);
    } catch (error) {
      console.error('Error fetching email logs:', error);
      setEmailLogs([]);
      setLoadingEmails(false);
    }
  };

  // Generate Sale-Purchase Fee Table HTML for email templates
  const generateSalePurchaseFeeTable = (purchaseData, saleData) => {
    const formatCurrency = (amount) => {
      const value = Number(amount) || 0;
      return `£${value.toFixed(2)}`;
    };

    // Helper to calculate totals from fees object
    const calculateTotals = (fees, disbursements) => {
      let feesNet = 0, feesVat = 0, feesGross = 0;
      let disbNet = 0, disbVat = 0, disbGross = 0;

      if (fees) {
        Object.values(fees).forEach(fee => {
          if (typeof fee === 'object' && fee !== null) {
            feesNet += Number(fee.amount || 0);
            feesVat += Number(fee.vat || 0);
            feesGross += Number(fee.gross || 0);
          }
        });
      }

      if (disbursements) {
        Object.values(disbursements).forEach(disb => {
          if (typeof disb === 'object' && disb !== null) {
            disbNet += Number(disb.amount || 0);
            disbVat += Number(disb.vat || 0);
            disbGross += Number(disb.gross || 0);
          }
        });
      }

      return {
        fees: { net: feesNet, vat: feesVat, gross: feesGross },
        disb: { net: disbNet, vat: disbVat, gross: disbGross },
        total: {
          net: feesNet + disbNet,
          vat: feesVat + disbVat,
          gross: feesGross + disbGross
        }
      };
    };

    let tableHTML = '';

    // 🎯 SALE TABLE FIRST (as per user requirement)
    let saleTotals = null;
    if (saleData) {
      saleTotals = calculateTotals(saleData.fees, saleData.disbursements);

      tableHTML += `
        <h4 style="margin: 20px 0 10px 0; font-weight: 600;">Sale</h4>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 1px solid #ddd;">
          <thead>
            <tr style="background-color: #f8f9fa; border-bottom: 2px solid #ddd;">
              <th style="padding: 8px; text-align: left; border: 1px solid #ddd;"></th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">NET</th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">VAT</th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">GROSS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="4" style="padding: 8px; font-weight: 600; background-color: #f8f9fa; border: 1px solid #ddd;">Legal Cost</td>
            </tr>
      `;

      // Sale Fees
      if (saleData.fees) {
        Object.entries(saleData.fees).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && Number(value.amount || 0) > 0) {
            tableHTML += `
              <tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${value.label || key}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.amount)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.vat)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.gross)}</td>
              </tr>
            `;
          }
        });
      }

      tableHTML += `
            <tr style="font-weight: 600;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL LEGAL COST</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.fees.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.fees.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.fees.gross)}</td>
            </tr>
            <tr>
              <td colspan="4" style="padding: 8px; font-weight: 600; background-color: #f8f9fa; border: 1px solid #ddd;">Disbursement - Third Party Expenditure</td>
            </tr>
      `;

      // Sale Disbursements
      if (saleData.disbursements) {
        Object.entries(saleData.disbursements).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && Number(value.amount || 0) > 0) {
            tableHTML += `
              <tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${value.label || key}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.amount)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${Number(value.vat || 0) > 0 ? formatCurrency(value.vat) : '-'}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.gross)}</td>
              </tr>
            `;
          }
        });
      }

      tableHTML += `
            <tr style="font-weight: 600;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL DISBURSEMENT COST</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.disb.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.disb.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.disb.gross)}</td>
            </tr>
            <tr style="font-weight: 700; background-color: #f0f0f0;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL (Legal Cost + Disbursement Cost)</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.total.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.total.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(saleTotals.total.gross)}</td>
            </tr>
          </tbody>
        </table>
      `;
    }

    // 🎯 PURCHASE TABLE SECOND
    let purchaseTotals = null;
    if (purchaseData) {
      purchaseTotals = calculateTotals(purchaseData.fees, purchaseData.disbursements);

      tableHTML += `
        <h4 style="margin: 20px 0 10px 0; font-weight: 600;">Purchase</h4>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 1px solid #ddd;">
          <thead>
            <tr style="background-color: #f8f9fa; border-bottom: 2px solid #ddd;">
              <th style="padding: 8px; text-align: left; border: 1px solid #ddd;"></th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">NET</th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">VAT</th>
              <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">GROSS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="4" style="padding: 8px; font-weight: 600; background-color: #f8f9fa; border: 1px solid #ddd;">Legal Cost</td>
            </tr>
      `;

      // Purchase Fees
      if (purchaseData.fees) {
        Object.entries(purchaseData.fees).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && Number(value.amount || 0) > 0) {
            tableHTML += `
              <tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${value.label || key}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.amount)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.vat)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.gross)}</td>
              </tr>
            `;
          }
        });
      }

      tableHTML += `
            <tr style="font-weight: 600;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL LEGAL COST</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.fees.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.fees.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.fees.gross)}</td>
            </tr>
            <tr>
              <td colspan="4" style="padding: 8px; font-weight: 600; background-color: #f8f9fa; border: 1px solid #ddd;">Disbursement - Third Party Expenditure</td>
            </tr>
      `;

      // Purchase Disbursements
      if (purchaseData.disbursements) {
        Object.entries(purchaseData.disbursements).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && Number(value.amount || 0) > 0) {
            tableHTML += `
              <tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${value.label || key}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.amount)}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${Number(value.vat || 0) > 0 ? formatCurrency(value.vat) : '-'}</td>
                <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(value.gross)}</td>
              </tr>
            `;
          }
        });
      }

      tableHTML += `
            <tr style="font-weight: 600;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL DISBURSEMENT COST</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.disb.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.disb.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.disb.gross)}</td>
            </tr>
            <tr style="font-weight: 700; background-color: #f0f0f0;">
              <td style="padding: 8px; border: 1px solid #ddd;">TOTAL (Legal Cost + Disbursement Cost)</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.total.net)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.total.vat)}</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${formatCurrency(purchaseTotals.total.gross)}</td>
            </tr>
          </tbody>
        </table>
      `;
    }

    // Combined Total (using already calculated totals)
    if (purchaseTotals && saleTotals) {
      const combinedNet = purchaseTotals.total.net + saleTotals.total.net;
      const combinedVat = purchaseTotals.total.vat + saleTotals.total.vat;
      const combinedGross = purchaseTotals.total.gross + saleTotals.total.gross;

      tableHTML += `
        <div style="background-color: #d1e7dd; border: 1px solid #a3cfbb; border-radius: 5px; padding: 15px; margin-top: 20px;">
          <h4 style="color: #0a3622; margin: 0 0 10px 0;">COMBINED TOTAL (Purchase + Sale)</h4>
          <p style="font-size: 1.2rem; font-weight: bold; margin: 0; color: #0a3622;">
            ${formatCurrency(combinedNet)} Net + ${formatCurrency(combinedVat)} VAT = ${formatCurrency(combinedGross)} Gross
          </p>
        </div>
      `;
    }

    console.log('📊 Generated Sale-Purchase Fee Table HTML for email');
    return tableHTML;
  };

  // Handle view email template
  const handleViewEmailTemplate = (emailLog) => {
    // Replace placeholders with actual data
    let content = emailLog.content || '';

    // Get customer data (first purchaser or first customer)
    const customer = leadData?.purchasers?.[0] || leadData?.customers?.[0] || {};
    const fullName = `${customer.forename || ''} ${customer.surname || ''}`.trim() || 'Customer';

    // Format current date
    const currentDate = new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Get property address
    let propertyAddress = '';

    // ✅ Check if Sale-Purchase service type - show BOTH addresses
    const isSalePurchase = leadData?.service_type === 'Purchase_Sale' ||
                          leadData?.service_type === 'Sale_Purchase' ||
                          leadData?.service_type === 'Purchase Sale' ||
                          leadData?.service_type === 'Sale Purchase';

    if (isSalePurchase) {
      // For Sale-Purchase, format BOTH addresses
      let saleAddress = '';
      let purchaseAddress = '';

      // Get Sale Property Address
      if (leadData?.salePropertyDetails?.address) {
        const saleAddr = leadData.salePropertyDetails.address;
        const saleAddressParts = [
          saleAddr.address1 || saleAddr.line1,
          saleAddr.address2 || saleAddr.line2,
          saleAddr.city || saleAddr.town,
          saleAddr.county || saleAddr.country,
          saleAddr.postcode
        ].filter(part => part && part.trim() !== '');
        saleAddress = saleAddressParts.join(', ');
      }

      // Get Purchase Property Address
      if (leadData?.purchasePropertyDetails?.address) {
        const purchaseAddr = leadData.purchasePropertyDetails.address;
        const purchaseAddressParts = [
          purchaseAddr.address1 || purchaseAddr.line1,
          purchaseAddr.address2 || purchaseAddr.line2,
          purchaseAddr.city || purchaseAddr.town,
          purchaseAddr.county || purchaseAddr.country,
          purchaseAddr.postcode
        ].filter(part => part && part.trim() !== '');
        purchaseAddress = purchaseAddressParts.join(', ');
      }

      // Combine both addresses with labels
      if (saleAddress && purchaseAddress) {
        propertyAddress = `Sale Property: ${saleAddress}\nPurchase Property: ${purchaseAddress}`;
      } else if (saleAddress) {
        propertyAddress = `Sale Property: ${saleAddress}`;
      } else if (purchaseAddress) {
        propertyAddress = `Purchase Property: ${purchaseAddress}`;
      }
    } else {
      // For non Sale-Purchase, use existing logic (single address)
      if (leadData?.address) {
        if (typeof leadData.address === 'string') {
          propertyAddress = leadData.address;
        } else if (typeof leadData.address === 'object') {
          const addressParts = [
            leadData.address.line1,
            leadData.address.line2,
            leadData.address.city || leadData.address.town,
            leadData.address.county || leadData.address.country,
            leadData.address.postcode
          ].filter(part => part && part.trim() !== '');
          propertyAddress = addressParts.join(', ');
        }
      } else if (leadData?.property_address) {
        if (typeof leadData.property_address === 'string') {
          propertyAddress = leadData.property_address;
        } else if (typeof leadData.property_address === 'object') {
          const addressParts = [
            leadData.property_address.address1 || leadData.property_address.line1,
            leadData.property_address.address2 || leadData.property_address.line2,
            leadData.property_address.city || leadData.property_address.town,
            leadData.property_address.county || leadData.property_address.country,
            leadData.property_address.postcode
          ].filter(part => part && part.trim() !== '');
          propertyAddress = addressParts.join(', ');
        }
      }
    }

    // Format property price
    const propertyPrice = leadData?.property_value
      ? `£${Number(leadData.property_value).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : '';

    // Replace customer placeholders (both single and double brace)
    content = content.replace(/\{\{customer_title\}\}/g, customer.title || '');
    content = content.replace(/\{customer_title\}/g, customer.title || '');
    content = content.replace(/\{\{customer_forename\}\}/g, customer.forename || '');
    content = content.replace(/\{customer_forename\}/g, customer.forename || '');
    content = content.replace(/\{\{customer_surname\}\}/g, customer.surname || '');
    content = content.replace(/\{customer_surname\}/g, customer.surname || '');
    content = content.replace(/\{\{customer_email\}\}/g, customer.email || '');
    content = content.replace(/\{customer_email\}/g, customer.email || '');
    content = content.replace(/\{\{customer_phone\}\}/g, customer.phone_number || '');
    content = content.replace(/\{customer_phone\}/g, customer.phone_number || '');
    content = content.replace(/\{\{customer_name\}\}/g, fullName);
    content = content.replace(/\{customer_name\}/g, fullName);

    // Replace client placeholders
    content = content.replace(/\{\{client_name\}\}/g, fullName);
    content = content.replace(/\{client_name\}/g, fullName);
    content = content.replace(/\{\{client\}\}/g, fullName);
    content = content.replace(/\{client\}/g, fullName);
    content = content.replace(/\{\{ClientName\}\}/g, fullName);
    content = content.replace(/\{ClientName\}/g, fullName);

    // Replace date placeholders
    content = content.replace(/\{\{date\}\}/g, currentDate);
    content = content.replace(/\{date\}/g, currentDate);

    // Replace reference/lead_id placeholders
    content = content.replace(/\{\{reference\}\}/g, leadData?.lead_id || '');
    content = content.replace(/\{reference\}/g, leadData?.lead_id || '');
    content = content.replace(/\{\{lead_id\}\}/g, leadData?.lead_id || '');
    content = content.replace(/\{lead_id\}/g, leadData?.lead_id || '');

    // Replace property placeholders
    content = content.replace(/\{\{property\}\}/g, propertyAddress);
    content = content.replace(/\{property\}/g, propertyAddress);
    content = content.replace(/\{\{property_address\}\}/g, propertyAddress);
    content = content.replace(/\{property_address\}/g, propertyAddress);
    content = content.replace(/\{\{price\}\}/g, propertyPrice);
    content = content.replace(/\{price\}/g, propertyPrice);
    content = content.replace(/\{\{property_value\}\}/g, propertyPrice);
    content = content.replace(/\{property_value\}/g, propertyPrice);

    // Replace tenure/ownership placeholders
    const tenure = leadData?.ownership_type || 'Freehold';
    content = content.replace(/\{\{tenure\}\}/g, tenure);
    content = content.replace(/\{tenure\}/g, tenure);

    // Replace URL placeholders
    const portalUrl = CUSTOMER_PORTAL_URL;
    content = content.replace(/\{\{LeadInstructUrl\}\}/g, portalUrl);
    content = content.replace(/\{LeadInstructUrl\}/g, portalUrl);
    content = content.replace(/\{\{AutoLoginUrl\}\}/g, portalUrl);
    content = content.replace(/\{AutoLoginUrl\}/g, portalUrl);
    content = content.replace(/\{\{confirmation_link\}\}/g, portalUrl);
    content = content.replace(/\{confirmation_link\}/g, portalUrl);

    // Replace branch placeholders
    const branchName = leadData?.branch_id?.branchname || leadData?.branch_id?.name || 'My Law Matters';
    content = content.replace(/\{\{branch_name\}\}/g, branchName);
    content = content.replace(/\{branch_name\}/g, branchName);
    content = content.replace(/\{\{branch_phone\}\}/g, leadData?.branch_id?.phone || '');
    content = content.replace(/\{branch_phone\}/g, leadData?.branch_id?.phone || '');
    content = content.replace(/\{\{branch_email\}\}/g, leadData?.branch_id?.email || '');
    content = content.replace(/\{branch_email\}/g, leadData?.branch_id?.email || '');

    // Generate fee table HTML for sale-purchase if legalFeeData exists
    if (legalFeeData && (legalFeeData.purchase || legalFeeData.sale)) {
      const feeTableHTML = generateSalePurchaseFeeTable(
        legalFeeData.purchase,
        legalFeeData.sale
      );
      console.log('📊 Generated fee table HTML for email template');

      // Replace {customer_fee}, {{customer_fee}}, {fee_table}, {{fee_table}} placeholders
      content = content.replace(/\{\{customer_fee\}\}/g, feeTableHTML);
      content = content.replace(/\{customer_fee\}/g, feeTableHTML);
      content = content.replace(/\{\{fee_table\}\}/g, feeTableHTML);
      content = content.replace(/\{fee_table\}/g, feeTableHTML);
    }

    // Convert markdown links to HTML
    content = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" style="color: #667eea; text-decoration: underline;">$1</a>');

    setSelectedEmail({
      ...emailLog,
      content: content
    });
    setViewEmailModal(true);
  };

  // Send email using template
  const handleSendEmail = async (templateId, templateName) => {
    try {
      // First show confirmation
      const confirmResult = await Swal.fire({
        icon: 'question',
        title: 'Send Email?',
        html: `<p>Are you sure you want to send <strong>"${templateName}"</strong> to the customer?</p>`,
        showCancelButton: true,
        confirmButtonText: 'Yes, Send Email',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });

      // If user cancels, return
      if (!confirmResult.isConfirmed) {
        return;
      }

      setSendingEmail(true);

      console.log('📧 Send Email clicked:', {
        templateId,
        templateName,
        lead_id: lead_id
      });

      const customerEmails = leadData?.customers?.map(c => c.email).filter(e => e) || [];

      if (customerEmails.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'No Email Address',
          text: 'No customer email address found for this lead.'
        });
        setSendingEmail(false);
        return;
      }

      const response = await postRequest('private/sendEmailFromTemplate', {
        lead_id: lead_id,
        template_id: templateId,
        customer_emails: customerEmails
      }, authCtx.token);

      if (response?.status === 200 || response?.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Email Sent',
          text: `Email "${templateName}" has been sent successfully!`
        });
        fetchEmailLogs();
      }
    } catch (error) {
      console.error('Error sending email:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to send email'
      });
    } finally {
      setSendingEmail(false);
    }
  };

  const handleDeleteLead = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this conveyancing lead #${lead_id}? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        console.log('Attempting to delete lead with ID:', lead_id);
        
        // Use the DELETE method with fetch API
        const response = await fetch(`/api/v1/admin/private/delete-lead/${lead_id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json'
          }
        });
        
        console.log('Delete response status:', response.status);
        
        let res;
        if (response.ok) {
          res = await response.json();
          console.log('Delete response data:', res);
        } else {
          // If the specific delete endpoint fails, log the error
          const errorText = await response.text();
          console.error('Delete failed with status:', response.status, 'Error:', errorText);
          throw new Error(`Delete failed with status ${response.status}`);
        }
        
        if (res && (res.status === 200 || res.status === 'success')) {
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'The conveyancing lead has been deleted successfully.',
            timer: 1500,
            showConfirmButton: false
          });
          
          // Navigate back to leads list after a short delay
          setTimeout(() => {
            navigate('/leads');
          }, 1500);
        } else {
          console.error('Delete failed with response:', res);
          Swal.fire('Error!', res?.message || 'Failed to delete conveyancing lead.', 'error');
        }
      } catch (error) {
        console.error('Error deleting conveyancing lead:', error);
        console.error('Error details:', error.message, error.stack);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'An error occurred while deleting the conveyancing lead.'
        });
      }
    }
  };

  // Handle revise quote
  const handleReviseQuote = async (payload) => {
    try {
      console.log('🔄 ===== REVISE QUOTE (Sale-Purchase - NEW API) =====');
      console.log('📦 Received payload from modal:', payload);

      // 🎯 Transform flat fees to NESTED format for PURCHASE breakdown
      const purchaseFees = {
        legalFee: {
          amount: Number(payload.purchase_fees?.legal_fee || 0),
          vat: Number(payload.purchase_fees?.legal_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.legal_fee || 0) * 1.20,
          label: 'Legal Fee'
        },
        ttFee: {
          amount: Number(payload.purchase_fees?.tt_fee || 0),
          vat: Number(payload.purchase_fees?.tt_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.tt_fee || 0) * 1.20,
          label: 'TT Fee'
        },
        leaseholdFee: {
          amount: Number(payload.purchase_fees?.leasehold_fee || 0),
          vat: Number(payload.purchase_fees?.leasehold_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.leasehold_fee || 0) * 1.20,
          label: 'Leasehold Fee'
        },
        mortgageAdminFee: {
          amount: Number(payload.purchase_fees?.mortgage_admin_fee || 0),
          vat: Number(payload.purchase_fees?.mortgage_admin_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.mortgage_admin_fee || 0) * 1.20,
          label: 'Mortgage Admin Fee'
        },
        helpToBuyISAFee: {
          amount: Number(payload.purchase_fees?.help_to_buy_isa_fee || 0),
          vat: Number(payload.purchase_fees?.help_to_buy_isa_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.help_to_buy_isa_fee || 0) * 1.20,
          label: 'Help to Buy ISA Fee'
        },
        helpToBuyFee: {
          amount: Number(payload.purchase_fees?.help_to_buy_fee || 0),
          vat: Number(payload.purchase_fees?.help_to_buy_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.help_to_buy_fee || 0) * 1.20,
          label: 'Help to Buy Fee'
        },
        rightToBuyFee: {
          amount: Number(payload.purchase_fees?.right_to_buy_fee || 0),
          vat: Number(payload.purchase_fees?.right_to_buy_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.right_to_buy_fee || 0) * 1.20,
          label: 'Right to Buy Fee'
        },
        sharedOwnershipFee: {
          amount: Number(payload.purchase_fees?.shared_ownership_fee || 0),
          vat: Number(payload.purchase_fees?.shared_ownership_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.shared_ownership_fee || 0) * 1.20,
          label: 'Shared Ownership Fee'
        },
        newBuildFee: {
          amount: Number(payload.purchase_fees?.new_build_fee || 0),
          vat: Number(payload.purchase_fees?.new_build_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.new_build_fee || 0) * 1.20,
          label: 'New Build Fee'
        },
        islamicMortgageFee: {
          amount: Number(payload.purchase_fees?.islamic_mortgage_fee || 0),
          vat: Number(payload.purchase_fees?.islamic_mortgage_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.islamic_mortgage_fee || 0) * 1.20,
          label: 'Islamic Mortgage Fee'
        },
        auctionRepossessionFee: {
          amount: Number(payload.purchase_fees?.auction_repossession_fee || 0),
          vat: Number(payload.purchase_fees?.auction_repossession_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.auction_repossession_fee || 0) * 1.20,
          label: 'Auction/Repossession Fee'
        },
        giftedDepositFeeFirstGiftor: {
          amount: Number(payload.purchase_fees?.gifted_deposit_fee || 0),
          vat: Number(payload.purchase_fees?.gifted_deposit_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.gifted_deposit_fee || 0) * 1.20,
          label: 'Gifted Deposit Fee (1st Giftor)'
        },
        giftedDepositFeeAdditionalGiftors: {
          amount: Number(payload.purchase_fees?.gifted_deposit_fee_additional || 0),
          vat: Number(payload.purchase_fees?.gifted_deposit_fee_additional || 0) * 0.20,
          gross: Number(payload.purchase_fees?.gifted_deposit_fee_additional || 0) * 1.20,
          label: 'Gifted Deposit Fee (Additional Giftors)'
        },
        buyToLetFee: {
          amount: Number(payload.purchase_fees?.buy_to_let_fee || 0),
          vat: Number(payload.purchase_fees?.buy_to_let_fee || 0) * 0.20,
          gross: Number(payload.purchase_fees?.buy_to_let_fee || 0) * 1.20,
          label: 'Buy to Let Fee'
        },
        arrangingIndemnityPolicy: {
          amount: Number(payload.purchase_fees?.arranging_indemnity_policy || 0),
          vat: Number(payload.purchase_fees?.arranging_indemnity_policy || 0) * 0.20,
          gross: Number(payload.purchase_fees?.arranging_indemnity_policy || 0) * 1.20,
          label: 'Arranging Indemnity Policy'
        },
        identityCheck: {
          amount: Number(payload.purchase_fees?.identity_check || 0),
          vat: 0,
          gross: Number(payload.purchase_fees?.identity_check || 0),
          label: 'Identity Check'
        }
      };

      const purchaseDisbursements = {
        stampDuty: {
          amount: Number(payload.purchase_fees?.stamp_duty || 0),
          vat: 0,
          gross: Number(payload.purchase_fees?.stamp_duty || 0),
          label: 'Stamp Duty'
        },
        hmLandRegistryFee: {
          amount: Number(payload.purchase_fees?.hm_land_registry_fee || 0),
          vat: 0,
          gross: Number(payload.purchase_fees?.hm_land_registry_fee || 0),
          label: 'HM Land Registry Fee'
        },
        landRegistrySearch: {
          amount: Number(payload.purchase_fees?.land_registry_search || 0),
          vat: Number(payload.purchase_fees?.land_registry_search || 0) * 0.20,
          gross: Number(payload.purchase_fees?.land_registry_search || 0) * 1.20,
          label: 'Land Registry Search'
        },
        landChargesSearch: {
          amount: Number(payload.purchase_fees?.land_charges_search || 0),
          vat: Number(payload.purchase_fees?.land_charges_search || 0) * 0.20,
          gross: Number(payload.purchase_fees?.land_charges_search || 0) * 1.20,
          label: 'Land Charges Search'
        },
        searchPack: {
          amount: Number(payload.purchase_fees?.search_pack || 0),
          vat: 0,
          gross: Number(payload.purchase_fees?.search_pack || 0),
          label: 'Search Pack'
        }
      };

      // Calculate Purchase Totals
      const purchaseLegalCostNet = Object.values(purchaseFees).reduce((sum, fee) => sum + fee.amount, 0);
      const purchaseLegalCostVat = Object.values(purchaseFees).reduce((sum, fee) => sum + fee.vat, 0);
      const purchaseLegalCostGross = Object.values(purchaseFees).reduce((sum, fee) => sum + fee.gross, 0);

      const purchaseDisbursementCostNet = Object.values(purchaseDisbursements).reduce((sum, fee) => sum + fee.amount, 0);
      const purchaseDisbursementCostVat = Object.values(purchaseDisbursements).reduce((sum, fee) => sum + fee.vat, 0);
      const purchaseDisbursementCostGross = Object.values(purchaseDisbursements).reduce((sum, fee) => sum + fee.gross, 0);

      const purchaseTotalNet = purchaseLegalCostNet + purchaseDisbursementCostNet;
      const purchaseTotalVat = purchaseLegalCostVat + purchaseDisbursementCostVat;
      const purchaseTotalGross = purchaseLegalCostGross + purchaseDisbursementCostGross;

      const purchaseTotals = {
        legalCost: { net: purchaseLegalCostNet, vat: purchaseLegalCostVat, gross: purchaseLegalCostGross },
        disbursementCost: { net: purchaseDisbursementCostNet, vat: purchaseDisbursementCostVat, gross: purchaseDisbursementCostGross },
        total: { net: purchaseTotalNet, vat: purchaseTotalVat, gross: purchaseTotalGross }
      };

      // 🎯 Transform flat fees to NESTED format for SALE breakdown
      const saleFees = {
        legalFee: {
          amount: Number(payload.sale_fees?.legal_fee || 0),
          vat: Number(payload.sale_fees?.legal_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.legal_fee || 0) * 1.20,
          label: 'Legal Fee'
        },
        ttFee: {
          amount: Number(payload.sale_fees?.tt_fee || 0),
          vat: Number(payload.sale_fees?.tt_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.tt_fee || 0) * 1.20,
          label: 'TT Fee'
        },
        leaseholdFee: {
          amount: Number(payload.sale_fees?.leasehold_fee || 0),
          vat: Number(payload.sale_fees?.leasehold_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.leasehold_fee || 0) * 1.20,
          label: 'Leasehold Fee'
        },
        mortgageAdminFee: {
          amount: Number(payload.sale_fees?.mortgage_admin_fee || 0),
          vat: Number(payload.sale_fees?.mortgage_admin_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.mortgage_admin_fee || 0) * 1.20,
          label: 'Mortgage Admin Fee'
        },
        sharedOwnershipFee: {
          amount: Number(payload.sale_fees?.shared_ownership_fee || 0),
          vat: Number(payload.sale_fees?.shared_ownership_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.shared_ownership_fee || 0) * 1.20,
          label: 'Shared Ownership Fee'
        },
        auctionRepossessionFee: {
          amount: Number(payload.sale_fees?.auction_repossession_fee || 0),
          vat: Number(payload.sale_fees?.auction_repossession_fee || 0) * 0.20,
          gross: Number(payload.sale_fees?.auction_repossession_fee || 0) * 1.20,
          label: 'Auction/Repossession Fee'
        },
        identityCheck: {
          amount: Number(payload.sale_fees?.identity_check || 0),
          vat: 0,
          gross: Number(payload.sale_fees?.identity_check || 0),
          label: 'Identity Check'
        }
      };

      const saleDisbursements = {
        officialCopies: {
          amount: Number(payload.sale_fees?.official_copies || 0),
          vat: 0,
          gross: Number(payload.sale_fees?.official_copies || 0),
          label: 'Official Copies'
        }
      };

      // Calculate Sale Totals
      const saleLegalCostNet = Object.values(saleFees).reduce((sum, fee) => sum + fee.amount, 0);
      const saleLegalCostVat = Object.values(saleFees).reduce((sum, fee) => sum + fee.vat, 0);
      const saleLegalCostGross = Object.values(saleFees).reduce((sum, fee) => sum + fee.gross, 0);

      const saleDisbursementCostNet = Object.values(saleDisbursements).reduce((sum, fee) => sum + fee.amount, 0);
      const saleDisbursementCostVat = Object.values(saleDisbursements).reduce((sum, fee) => sum + fee.vat, 0);
      const saleDisbursementCostGross = Object.values(saleDisbursements).reduce((sum, fee) => sum + fee.gross, 0);

      const saleTotalNet = saleLegalCostNet + saleDisbursementCostNet;
      const saleTotalVat = saleLegalCostVat + saleDisbursementCostVat;
      const saleTotalGross = saleLegalCostGross + saleDisbursementCostGross;

      const saleTotals = {
        legalCost: { net: saleLegalCostNet, vat: saleLegalCostVat, gross: saleLegalCostGross },
        disbursementCost: { net: saleDisbursementCostNet, vat: saleDisbursementCostVat, gross: saleDisbursementCostGross },
        total: { net: saleTotalNet, vat: saleTotalVat, gross: saleTotalGross }
      };

      // Calculate Combined Grand Total
      const grandTotalNet = purchaseTotalNet + saleTotalNet;
      const grandTotalVat = purchaseTotalVat + saleTotalVat;
      const grandTotalGross = purchaseTotalGross + saleTotalGross;

      console.log('✅ Nested format created for Sale-Purchase:', {
        purchase_breakdown: { fees: purchaseFees, disbursements: purchaseDisbursements, totals: purchaseTotals },
        sale_breakdown: { fees: saleFees, disbursements: saleDisbursements, totals: saleTotals },
        grand_totals: { net: grandTotalNet, vat: grandTotalVat, gross: grandTotalGross }
      });

      // 🔄 Call NEW reviseQuote API with separate purchase and sale breakdowns
      const API_BASE_URL = `${API_BASE}/v1/admin/`;
      const apiUrl = `${API_BASE_URL}private/reviseQuote/${lead_id}`;
      console.log('📡 Calling NEW reviseQuote API:', apiUrl);

      // Combine Purchase and Sale fees with proper prefixes to avoid key conflicts
      const combinedFees = {};
      const combinedDisbursements = {};

      console.log('🔍 Sale Fees Detail (before combining):', JSON.stringify(saleFees, null, 2));

      // Add Purchase fees with "purchase" prefix
      Object.keys(purchaseFees).forEach(key => {
        const prefixedKey = 'purchase' + key.charAt(0).toUpperCase() + key.slice(1);
        combinedFees[prefixedKey] = purchaseFees[key];
      });

      // Add Sale fees with "sale" prefix
      Object.keys(saleFees).forEach(key => {
        const prefixedKey = 'sale' + key.charAt(0).toUpperCase() + key.slice(1);
        combinedFees[prefixedKey] = saleFees[key];
      });

      // Add Purchase disbursements with "purchase" prefix
      Object.keys(purchaseDisbursements).forEach(key => {
        const prefixedKey = 'purchase' + key.charAt(0).toUpperCase() + key.slice(1);
        combinedDisbursements[prefixedKey] = purchaseDisbursements[key];
      });

      // Add Sale disbursements with "sale" prefix
      Object.keys(saleDisbursements).forEach(key => {
        const prefixedKey = 'sale' + key.charAt(0).toUpperCase() + key.slice(1);
        combinedDisbursements[prefixedKey] = saleDisbursements[key];
      });

      const requestBody = {
        fees: combinedFees,
        disbursements: combinedDisbursements,
        totals: {
          // ✅ Nested format matching database structure
          total: {
            net: grandTotalNet,
            vat: grandTotalVat,
            gross: grandTotalGross
          },
          legalCost: {
            net: purchaseLegalCostNet + saleLegalCostNet,
            vat: purchaseLegalCostVat + saleLegalCostVat,
            gross: purchaseLegalCostGross + saleLegalCostGross
          },
          disbursementCost: {
            net: purchaseDisbursementCostNet + saleDisbursementCostNet,
            vat: purchaseDisbursementCostVat + saleDisbursementCostVat,
            gross: purchaseDisbursementCostGross + saleDisbursementCostGross
          }
        },
        // Keep breakdowns for reference/history
        purchase_breakdown: {
          fees: purchaseFees,
          disbursements: purchaseDisbursements,
          totals: purchaseTotals
        },
        sale_breakdown: {
          fees: saleFees,
          disbursements: saleDisbursements,
          totals: saleTotals
        }
      };

      console.log('📤 Final Request Body:', JSON.stringify(requestBody, null, 2));
      console.log('📤 Sale Breakdown in Request:', JSON.stringify(requestBody.sale_breakdown, null, 2));

      const res = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        },
        body: JSON.stringify(requestBody)
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ API Error Response:', errorText);
        throw new Error(`API call failed: ${res.status} - ${errorText}`);
      }

      const result = await res.json();
      console.log('✅ Revise Quote API Response:', result);

      if (result?.status === 200) {
        console.log('✅ Quote revised successfully!');

        // 📚 Fetch fresh quote history from database
        await fetchQuoteHistory();

        // 🔄 Refresh active quote by reloading lead data
        window.location.reload();

        Swal.fire('Success', 'Quote revised successfully!', 'success');

        // Close the revise quote modal
        setReviseModalShow(false);
      } else {
        Swal.fire('Error', result?.message || 'Failed to revise quote', 'error');
      }
    } catch (err) {
      console.error('❌ Error revising quote:', err);
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    }
  };

  const slugify = (text) =>
    text
      ?.toLowerCase()
      ?.replace(/ /g, '-')
      ?.replace(/[^\w-]+/g, '')
      ?.replace(/-+/g, '-');

  React.useEffect(() => {
    async function fetchConveyancingLead() {
      console.log('🔍 === FETCHING CONVEYANCING LEAD DATA ===');
      console.log('Lead ID from params:', lead_id);
      console.log('Current URL:', window.location.href);
      console.log('Auth token present:', !!authCtx.token);
      console.log('Auth token length:', authCtx.token?.length);
      
      try {
        // Try conveyancing-specific API first
        console.log('🔄 Trying getConveyancingLead API...');
  //const apiUrl = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'}/api/v1/admin/private/getConveyancingLead/${lead_id}`;
  const apiUrl = `${API_BASE}/v1/admin/private/getConveyancingLead/${lead_id}`;
        console.log('🌐 Full API URL:', apiUrl);

        const res = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json'
          }
        });

        console.log('📡 Response status:', res.status);
        console.log('📡 Response statusText:', res.statusText);
        console.log('📡 Response ok:', res.ok);
        console.log('📡 Response headers:', [...res.headers.entries()]);

        const data = await res.json();
        console.log('📡 Raw Conveyancing API Response:', data);
        console.log('📡 Response data type:', typeof data);
        console.log('📡 Response keys:', Object.keys(data));
        
        if (data.status === 200 && data.data) {
          console.log('✅ Conveyancing data received successfully:', data.data);
          console.log('📋 Data._id:', data.data._id);
          console.log('📋 Data.lead_id:', data.data.lead_id);
          console.log('📋 Available fields:', Object.keys(data.data));
          console.log('💰 Property value:', data.data.property_value);
          console.log('🏠 Property address:', data.data.property_address);
          console.log('📋 Service type:', data.data.service_type);
          console.log('👥 Customers:', data.data.customer_ids);

          // Infer service_type from product_title if not set
          let leadDataWithServiceType = { ...data.data };
          console.log('🔍 BEFORE INFERENCE - service_type:', leadDataWithServiceType.service_type);
          console.log('🔍 BEFORE INFERENCE - product_title:', leadDataWithServiceType.product_title);

          if (!leadDataWithServiceType.service_type && leadDataWithServiceType.product_title) {
            const productTitle = leadDataWithServiceType.product_title.toLowerCase();
            console.log('🔍 Product title for inference:', productTitle);

            if (productTitle.includes('review of legal pack') || productTitle.includes('review legal pack')) {
              leadDataWithServiceType.service_type = 'Review_Legal_Pack';
              console.log('✅ Inferred service_type: Review_Legal_Pack');
            } else if (productTitle.includes('purchase') && productTitle.includes('sale')) {
              leadDataWithServiceType.service_type = 'Purchase_Sale';
              console.log('✅ Inferred service_type: Purchase_Sale');
            } else if (productTitle.includes('sale')) {
              leadDataWithServiceType.service_type = 'Sale';
              console.log('✅ Inferred service_type: Sale');
            } else if (productTitle.includes('purchase')) {
              leadDataWithServiceType.service_type = 'Purchase';
              console.log('✅ Inferred service_type: Purchase');
            }
          } else if (!leadDataWithServiceType.service_type) {
            console.log('⚠️ WARNING: No service_type and no product_title - defaulting to Purchase_Sale for sale-purchase page');
            leadDataWithServiceType.service_type = 'Purchase_Sale';
          }

          console.log('✅ FINAL service_type before setLeadData:', leadDataWithServiceType.service_type);
          setLeadData(leadDataWithServiceType);
          setContactAttempts(leadDataWithServiceType?.contact_attempts || 0);

          // ✅ Fetch calculation for Quote Summary (for Sale & Purchase)
          if (leadDataWithServiceType.service_type === 'Purchase_Sale') {
            try {
              console.log('📊 Fetching calculation for Quote Summary on page load...');
              const calcResponse = await fetch(`${API_BASE}/v1/admin/private/fetch_lead_calculations/${lead_id}`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${authCtx.token}`
                }
              });
              const calcResult = await calcResponse.json();

              if (calcResult?.status === 200 && calcResult?.data) {
                const calcData = calcResult.data;
                console.log('✅ Calculation data fetched for Quote Summary:', calcData);
                console.log('📊 calcData.totals:', calcData.totals);
                console.log('📊 calcData.totals.total:', calcData.totals?.total);

                // Set quoteFeeData for Quote Summary
                if (calcData.purchase_breakdown && calcData.sale_breakdown) {
                  setQuoteFeeData({
                    purchase_breakdown: calcData.purchase_breakdown || {},
                    sale_breakdown: calcData.sale_breakdown || {},
                    fees: calcData.fees || {},
                    disbursements: calcData.disbursements || {},
                    totals: calcData.totals || {}
                  });
                  console.log('✅ quoteFeeData set on page load for Quote Summary!');
                }
              }
            } catch (calcError) {
              console.log('⚠️ Error fetching calculation for Quote Summary:', calcError);
            }
          }

          // Also fetch conveyancing-specific details
          try {
            console.log('🔄 Fetching conveyancing-specific details...');
            
            // Try multiple endpoints for conveyancing details
            const conveyancingEndpoints = [
              { url: `private/getConveyancingDetails/${lead_id}`, name: 'getConveyancingDetails' },
              { url: `private/getConveyancingPurchase/${lead_id}`, name: 'getConveyancingPurchase' },
              { url: `private/conveyancing-details/${lead_id}`, name: 'conveyancing-details' }
            ];
            
            let conveyancingData = null;
            
            for (const endpoint of conveyancingEndpoints) {
              try {
                console.log(`🔄 Trying ${endpoint.name}...`);
                const convRes = await postRequest(endpoint.url, {}, authCtx.token);
                console.log(`📋 ${endpoint.name} response:`, convRes);
                
                if (convRes?.status === 200 && convRes?.data) {
                  console.log(`✅ Conveyancing details found via ${endpoint.name}:`, convRes.data);
                  conveyancingData = convRes.data;
                  break;
                }
              } catch (err) {
                console.log(`❌ ${endpoint.name} failed:`, err.message);
              }
            }
            
            if (conveyancingData) {
              // Merge conveyancing details directly with lead data
              console.log('🔄 Merging conveyancing data with lead data...');
              console.log('📊 Conveyancing vendors:', conveyancingData.vendors);
              console.log('📊 Conveyancing purchasers:', conveyancingData.purchasers);
              console.log('📊 Conveyancing salePropertyDetails:', conveyancingData.salePropertyDetails);
              console.log('📊 Conveyancing purchasePropertyDetails:', conveyancingData.purchasePropertyDetails);

              setLeadData(prev => {
                const merged = {
                  ...prev,
                  ...conveyancingData, // Merge all conveyancing fields directly
                  conveyancingDetails: conveyancingData // Also keep original for reference
                };

                // Preserve populated objects from prev if they're already populated
                if (prev?.partner_id && typeof prev.partner_id === 'object') {
                  merged.partner_id = prev.partner_id;
                  console.log('✅ Preserved partner_id object during conveyancing merge');
                }

                if (prev?.lender_panel_id && typeof prev.lender_panel_id === 'object') {
                  merged.lender_panel_id = prev.lender_panel_id;
                  console.log('✅ Preserved lender_panel_id object during conveyancing merge');
                }

                return merged;
              });

              console.log('✅ Conveyancing data merged successfully');
            } else {
              console.log('ℹ️ No conveyancing details found from any endpoint');
            }
          } catch (convErr) {
            console.log('❌ Error fetching conveyancing details:', convErr);
          }
        } else {
          console.log('❌ No conveyancing data found for ID:', lead_id);
          console.log('📊 Full API response:', JSON.stringify(data, null, 2));
          
          // Debug: Check if there are any conveyancing leads at all
          console.log('🔍 Checking all conveyancing leads in database...');
          console.log('dkednks')
          try {
            const allLeadsRes = await fetch(`${API_BASE}/api/v1/admin/private/getAllConveyancingLeads?page=1&limit=50`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authCtx.token}`,
                'Content-Type': 'application/json'
              }
            });
            const allLeadsData = await allLeadsRes.json();
            console.log('📊 All conveyancing leads in database:', allLeadsData);
            console.log('📊 Total leads found:', allLeadsData.data?.length || 0);
            if (allLeadsData.data?.length > 0) {
              console.log('📊 First lead example:', allLeadsData.data[0]);
              console.log('📊 Lead IDs in database:', allLeadsData.data.map(lead => ({ _id: lead._id, lead_id: lead.lead_id })));
            }
          } catch (debugErr) {
            console.log('❌ Debug query failed:', debugErr);
          }
          
          // If this lead is a Sale, prefer the sale-details endpoint so we get server-side Sale calculations
          if (leadData?.service_type === 'Sale') {
            console.log('🔄 Lead is Sale - trying Sale Details API endpoint...');
            try {
              const saleRes = await fetch(`/api/v1/admin/private/sale-details/${lead_id}`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${authCtx.token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (saleRes.ok) {
                const saleData = await saleRes.json();
                if (saleData.status === 'success' && saleData.data) {
                  console.log('✅ Sale Details from API:', saleData.data);
                  const sd = saleData.data;

                  // Merge sale details into leadData
                  if (leadData) {
                    const merged = {
                      ...leadData,
                      property_address: sd.property_address || leadData.property_address || leadData.address || {},
                      address: sd.property_address || sd.address || leadData.address || leadData.property_address || {},
                      purchasers: sd.purchasers || leadData.purchasers || leadData.customers || [],
                      customers: sd.purchasers || leadData.customers || leadData.purchasers || [],
                      customer_ids: (sd.purchasers && sd.purchasers.map(p => p._id || p)) || leadData.customer_ids || [],
                      property_value: sd.property_value || sd.purchasePrice || leadData.property_value || 0,
                      purchase_price: sd.purchasePrice || sd.property_value || leadData.purchase_price || leadData.property_value || 0,
                      ownership_type: sd.ownershipType || leadData.ownership_type || (leadData.leasehold ? 'Leasehold' : 'Freehold'),
                      completion_date: sd.completionDate || leadData.completion_date || null,
                      conveyancing_info: sd.info || leadData.conveyancing_info || {},
                      matchedBranch: sd.matchedBranch || null,
                      calculatedQuote: sd.calculatedQuote || null,
                      conveyancingData: sd.conveyancingData || leadData.conveyancingData || null
                    };
                    console.log('📊 Merged sale-details into leadData:', merged);
                    setLeadData(merged);
                  }

                  // Build legalFeeData from calculatedQuote so the modal can display it like Purchase
                  if (sd.calculatedQuote) {
                    const cq = sd.calculatedQuote;
                    const disbs = cq.disbursements || [];
                    const findDisb = (match) => (disbs.find(d => (d.label||d.name||'').toLowerCase().includes(match)) || {}).amount || 0;
                    const saleFeeData = {
                      legal_fee: Number(cq.base) || 0,
                      branch_name: sd.matchedBranch?.name,
                      branch_id: sd.matchedBranch?._id,
                      tt_fee: Number(cq.ttFee) || 30,
                      identity_check: Number(cq.identityCheck) || 10,
                      stamp_duty: 0,
                      land_registry_search: findDisb('land registry') || 0,
                      land_charges_search: findDisb('land charges') || 0,
                      hm_land_registry_fee: findDisb('hm land registry') || 0,
                      search_pack: findDisb('search pack') || 0,
                      property_value: sd.property_value || 0,
                      service_type: 'Sale',
                      all_fixed_fees: cq.fixedFees || [],
                      all_disbursements: cq.disbursements || []
                    };

                    console.log('📦 saleFeeData prepared from calculatedQuote:', saleFeeData);
                    setLegalFeeData(saleFeeData);
                  }

                  // We did the Sale merge; skip trying purchase-details
                }
              }
            } catch (err) {
              console.log('❌ Sale Details API failed:', err);
            }
          } else {
            console.log('🔄 Trying Purchase Details API endpoint...');

            // Try the Purchase Details API first
            try {
              const purchaseRes = await fetch(`/api/v1/admin/private/purchase-details/${lead_id}`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${authCtx.token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (purchaseRes.ok) {
                const purchaseData = await purchaseRes.json();
                if (purchaseData.status === 'success' && purchaseData.data) {
                  console.log('✅ Purchase Details from API:', purchaseData.data);
                  console.log('📦 Property Address object:', purchaseData.data.property_address);
                  console.log('💰 Calculated Quote:', purchaseData.data.calculatedQuote);
                  console.log('🏢 Matched Branch:', purchaseData.data.matchedBranch);
                  console.log('📋 Conveyancing Data:', purchaseData.data.conveyancingData);
                  window.purchaseDetailsData = purchaseData.data;

                  // Merge purchase details into the main leadData so the view can render Purchase/Sale fields
                  if (leadData) {
                    const pd = purchaseData.data;
                    const merged = {
                      ...leadData,
                      // prefer property_address from purchase details when available
                      property_address: pd.property_address || leadData.property_address || leadData.address || {},
                      address: pd.property_address || pd.address || leadData.address || leadData.property_address || {},
                      purchasers: pd.purchasers || leadData.purchasers || leadData.customers || [],
                      customers: pd.purchasers || leadData.customers || leadData.purchasers || [],
                      customer_ids: (pd.purchasers && pd.purchasers.map(p => p._id || p)) || leadData.customer_ids || [],
                      property_value: pd.purchasePrice || pd.property_value || leadData.property_value || 0,
                      purchase_price: pd.purchasePrice || pd.purchase_price || leadData.purchase_price || leadData.property_value || 0,
                      ownership_type: pd.ownershipType || leadData.ownership_type || leadData.leasehold ? 'Leasehold' : 'Freehold',
                      completion_date: pd.completionDate || leadData.completion_date || null,
                      conveyancing_info: pd.info || leadData.conveyancing_info || {},
                      matchedBranch: pd.matchedBranch || null,
                      calculatedQuote: pd.calculatedQuote || null,
                      conveyancingData: pd.conveyancingData || leadData.conveyancingData || null
                    };

                    console.log('📊 Merged purchase-details into leadData:', merged);
                    setLeadData(merged);
                  }
                }
              }
            } catch (err) {
              console.log('❌ Purchase Details API failed:', err);
            }
          }
          
          console.log('🔄 Trying new conveyancing-view GET endpoint...');
          
          // Try the new GET endpoint
          try {
            const getRes = await fetch(`${API_BASE}/api/v1/admin/private/conveyancing-view/${lead_id}`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authCtx.token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (getRes.ok) {
              const getData = await getRes.json();
              if (getData.status === 'success' && getData.data) {
                console.log('✅ Conveyancing view data from GET endpoint:', getData.data);
                console.log('📊 Address:', getData.data.address);
                console.log('👥 Purchasers:', getData.data.purchasers);
                console.log('💰 Purchase Price:', getData.data.purchase_price);
                console.log('🏠 Ownership Type:', getData.data.ownership_type);
                console.log('📅 Completion Date:', getData.data.completion_date);
                console.log('ℹ️ Info:', getData.data.info);
                console.log('🏢 Group Code:', getData.data.group_code);
                console.log('📞 Acquisition:', getData.data.acquisition);
                console.log('📄 Full Data:', getData.data.fullData);
                
                // Store the API response data for easy access
                window.conveyancingApiData = getData.data;
                
                // Merge the API response with fullData
                const mergedData = {
                  ...getData.data.fullData,
                  // Override with specific API response fields
                  // Keep the property_address object if it exists in fullData
                  property_address: getData.data.fullData?.property_address || getData.data.fullData?.address || getData.data.address,
                  property: getData.data.address,
                  address: getData.data.fullData?.address || getData.data.fullData?.property_address,
                  purchasers: getData.data.purchasers,
                  customers: getData.data.purchasers,
                  property_value: getData.data.purchase_price,
                  ownership_type: getData.data.ownership_type,
                  completion_date: getData.data.completion_date,
                  conveyancing_info: getData.data.info,
                  group_code: getData.data.group_code,
                  acquisition: getData.data.acquisition
                };

                // Preserve populated objects from fullData if they're already populated
                if (getData.data.fullData?.partner_id && typeof getData.data.fullData.partner_id === 'object') {
                  mergedData.partner_id = getData.data.fullData.partner_id;
                  console.log('✅ Preserved partner_id object from fullData:', getData.data.fullData.partner_id);
                }

                if (getData.data.fullData?.lender_panel_id && typeof getData.data.fullData.lender_panel_id === 'object') {
                  mergedData.lender_panel_id = getData.data.fullData.lender_panel_id;
                  console.log('✅ Preserved lender_panel_id object from fullData:', getData.data.fullData.lender_panel_id);
                }

                console.log('📊 Merged data for view:', {
                  property_address: mergedData.property_address,
                  address: mergedData.address,
                  fullData_address: getData.data.fullData?.address,
                  fullData_property_address: getData.data.fullData?.property_address,
                  lender_panel_id: mergedData.lender_panel_id,
                  partner_id: mergedData.partner_id
                });
                
                setLeadData(mergedData);
                setContactAttempts(mergedData?.contact_attempts || 0);
                setQuoteHistory(mergedData?.quote_history || []);
                setRevisionCount(mergedData?.revision_count || 0);
                return;
              }
            }
          } catch (getErr) {
            console.log('❌ GET endpoint failed:', getErr);
          }
          
          console.log('🔄 Trying fallback lead-overview-data API...');
          
          try {
            const fallbackRes = await postRequest(`private/lead-overview-data/${lead_id}`, {}, authCtx.token);
            console.log('📡 Fallback API Response:', fallbackRes);
            
            if (fallbackRes.status === 'success' && fallbackRes.data) {
              console.log('✅ Lead data received from fallback:', fallbackRes.data);

              // Infer service_type from product_title if not set
              let leadDataWithServiceType = { ...fallbackRes.data };
              if (!leadDataWithServiceType.service_type && leadDataWithServiceType.product_title) {
                const productTitle = leadDataWithServiceType.product_title.toLowerCase();
                console.log('🔍 Product title for inference (fallback):', productTitle);

                if (productTitle.includes('review of legal pack') || productTitle.includes('review legal pack')) {
                  leadDataWithServiceType.service_type = 'Review_Legal_Pack';
                  console.log('✅ Inferred service_type: Review_Legal_Pack (fallback)');
                } else if (productTitle.includes('purchase') && productTitle.includes('sale')) {
                  leadDataWithServiceType.service_type = 'Purchase_Sale';
                  console.log('✅ Inferred service_type: Purchase_Sale (fallback)');
                } else if (productTitle.includes('sale')) {
                  leadDataWithServiceType.service_type = 'Sale';
                  console.log('✅ Inferred service_type: Sale (fallback)');
                } else if (productTitle.includes('purchase')) {
                  leadDataWithServiceType.service_type = 'Purchase';
                  console.log('✅ Inferred service_type: Purchase (fallback)');
                }
              }

              setLeadData(leadDataWithServiceType);
              setContactAttempts(leadDataWithServiceType?.contact_attempts || 0);
              setQuoteHistory(leadDataWithServiceType.quote_history || []);
              setRevisionCount(leadDataWithServiceType.revision_count || 0);
            } else {
              console.log('❌ Fallback API also failed or returned no data');
            }
          } catch (fallbackErr) {
            console.error("❌ Error in fallback API:", fallbackErr);
          }
        }
      } catch (err) {
        console.error("❌ Error fetching conveyancing lead data", err);
        console.log('🔄 Attempting fallback due to error...');
        
        try {
          const fallbackRes = await postRequest(`private/lead-overview-data/${lead_id}`, {}, authCtx.token);
          console.log('📡 Fallback API Response after error:', fallbackRes);
          
          if (fallbackRes.status === 'success' && fallbackRes.data) {
            console.log('✅ Lead data received from fallback after error:', fallbackRes.data);

            // Infer service_type from product_title if not set
            let leadDataWithServiceType = { ...fallbackRes.data };
            if (!leadDataWithServiceType.service_type && leadDataWithServiceType.product_title) {
              const productTitle = leadDataWithServiceType.product_title.toLowerCase();
              console.log('🔍 Product title for inference (catch fallback):', productTitle);

              if (productTitle.includes('review of legal pack') || productTitle.includes('review legal pack')) {
                leadDataWithServiceType.service_type = 'Review_Legal_Pack';
                console.log('✅ Inferred service_type: Review_Legal_Pack (catch fallback)');
              } else if (productTitle.includes('purchase') && productTitle.includes('sale')) {
                leadDataWithServiceType.service_type = 'Purchase_Sale';
                console.log('✅ Inferred service_type: Purchase_Sale (catch fallback)');
              } else if (productTitle.includes('sale')) {
                leadDataWithServiceType.service_type = 'Sale';
                console.log('✅ Inferred service_type: Sale (catch fallback)');
              } else if (productTitle.includes('purchase')) {
                leadDataWithServiceType.service_type = 'Purchase';
                console.log('✅ Inferred service_type: Purchase (catch fallback)');
              }
            }

            setLeadData(leadDataWithServiceType);
            setContactAttempts(leadDataWithServiceType?.contact_attempts || 0);
            setQuoteHistory(leadDataWithServiceType.quote_history || []);
            setRevisionCount(leadDataWithServiceType.revision_count || 0);
          }
        } catch (fallbackErr) {
          console.error("❌ Both primary and fallback APIs failed:", fallbackErr);
        }
      }
      
      console.log('🔍 === FETCH COMPLETE ===');
    }

    fetchConveyancingLead();
    // fetchPartners(); // Disabled - partnersList API call removed
  }, [lead_id, authCtx.token]);

  // const fetchPartners = async () => {
  //   try {
  //     const res = await postRequest('private/partnersList', {}, authCtx.token);
  //     if (res?.status === 200 && res?.data) {
  //       setPartners(res.data);
  //     }
  //   } catch (err) {
  //     console.error('Error fetching partners:', err);
  //   }
  // };

  // Fetch email templates and communication logs
  React.useEffect(() => {
    if (leadData && authCtx.token) {
      fetchEmailTemplates();
      fetchEmailLogs();
    }
  }, [leadData, authCtx.token]);

  // Effect to handle postcode matching and cost calculation
  React.useEffect(() => {
    const handlePostcodeMatching = async () => {
      if (!leadData || !leadData.property_address) return;
      
      console.log('🔍 === STARTING POSTCODE MATCHING ===');
      console.log('Lead data:', leadData);
      
      // Extract postcode from property address
      let postcode = null;
      const addressObj = leadData.property_address || leadData.property;
      
      if (typeof addressObj === 'string') {
        // If it's a string, try to extract postcode from the end
        const addressParts = addressObj.split(',').map(p => p.trim());
        postcode = addressParts[addressParts.length - 1];
      } else if (addressObj) {
        postcode = addressObj.postcode || addressObj.postal_code || addressObj.post_code;
      }
      
      if (!postcode) {
        console.log('❌ No postcode found in property address');
        return;
      }
      
      console.log('📮 Extracted postcode:', postcode);
      
      // Find matching branch
      const branch = await fetchBranchByPostcode(postcode);
      if (branch) {
        setMatchedBranch(branch);
        setBranchInfo(branch);
        console.log('✅ Matched branch:', branch);
        
        // Fetch conveyancing costs for this branch
        if (leadData.product_id) {
          const costs = await fetchConveyancingCosts(branch._id, leadData.product_id);
              if (costs) {
            setConveyancingCosts(costs);
            
            // Calculate new quote based on branch costs
            const branchQuote = calculateBranchBasedQuote(
              leadData.property_value || 0,
              leadData.service_type || 'Purchase',
              costs,
              leadData.service_type === 'Sale' ? {
                // Sale-specific options
                mortgage_outstanding: leadData.mortgage_outstanding,
                estate_agent: leadData.estate_agent,
                chain_free: leadData.chain_free
              } : {
                // Purchase-specific options
                leasehold: leadData.leasehold,
                mortgage_lender: leadData.mortgage_lender,
                help_to_buy: leadData.help_to_buy,
                shared_ownership: leadData.shared_ownership
              }
            );
            
            if (branchQuote) {
              setCalculatedQuote(branchQuote);
              console.log('✅ Branch-based quote calculated:', branchQuote);
            }
          }
        }
      }
    };
    
    handlePostcodeMatching();
  }, [leadData?.property_address, leadData?.product_id]);

  // Effect to populate vendors and purchasers with customer details
  React.useEffect(() => {
    const populateCustomers = async () => {
      if (!leadData || !authCtx.token) {
        console.log('⚠️ Cannot populate - leadData or token missing');
        return;
      }

      console.log('🔍 ====== POPULATING VENDORS AND PURCHASERS ======');
      console.log('📊 Full leadData object:', leadData);
      console.log('📊 leadData.vendors:', leadData.vendors);
      console.log('📊 leadData.vendors type:', typeof leadData.vendors);
      console.log('📊 leadData.vendors isArray:', Array.isArray(leadData.vendors));
      console.log('📊 leadData.vendors length:', leadData.vendors?.length);
      console.log('📊 leadData.purchasers:', leadData.purchasers);
      console.log('📊 service_type:', leadData.service_type);

      // Populate vendors
      if (leadData.vendors && Array.isArray(leadData.vendors) && leadData.vendors.length > 0) {
        console.log('✅ Vendors array found with', leadData.vendors.length, 'items');
        const firstVendor = leadData.vendors[0];
        console.log('🔍 First vendor:', firstVendor, 'Type:', typeof firstVendor);
        const isPopulated = firstVendor && typeof firstVendor === 'object' && firstVendor.forename;
        console.log('🔍 Is populated?', isPopulated);

        if (!isPopulated) {
          console.log('📞 Fetching vendor details from API...');
          setIsLoadingVendors(true);
          try {
            const vendorPromises = leadData.vendors.map(async (vendorId) => {
              const id = typeof vendorId === 'string' ? vendorId : vendorId._id;
              console.log('🔍 Fetching vendor with ID:', id);
              try {
                const customerRes = await postRequest(`private/getCustomerIndividualData/${id}`, {}, authCtx.token);
                console.log('📋 Vendor API response for ID', id, ':', customerRes);
                return customerRes?.data || null;
              } catch (err) {
                console.error('❌ Error fetching vendor ID', id, ':', err);
                return null;
              }
            });

            const vendorDetails = await Promise.all(vendorPromises);
            const validVendors = vendorDetails.filter(v => v && v._id);
            console.log('✅ Populated vendors:', validVendors);
            console.log('✅ Setting populatedVendors state with', validVendors.length, 'vendors');
            setPopulatedVendors(validVendors);
          } catch (err) {
            console.error('❌ Error fetching vendors:', err);
          } finally {
            setIsLoadingVendors(false);
          }
        } else {
          console.log('✅ Vendors already populated');
          setPopulatedVendors(leadData.vendors);
          setIsLoadingVendors(false);
        }
      } else {
        console.log('⚠️ No vendors array found or vendors array is empty');
        setPopulatedVendors([]);
        setIsLoadingVendors(false);
      }

      // Populate purchasers
      if (leadData.purchasers && Array.isArray(leadData.purchasers) && leadData.purchasers.length > 0) {
        console.log('✅ Purchasers array found with', leadData.purchasers.length, 'items');
        const firstPurchaser = leadData.purchasers[0];
        console.log('🔍 First purchaser:', firstPurchaser, 'Type:', typeof firstPurchaser);
        const isPopulated = firstPurchaser && typeof firstPurchaser === 'object' && firstPurchaser.forename;
        console.log('🔍 Is populated?', isPopulated);

        if (!isPopulated) {
          console.log('📞 Fetching purchaser details from API...');
          setIsLoadingPurchasers(true);
          try {
            const purchaserPromises = leadData.purchasers.map(async (purchaserId) => {
              const id = typeof purchaserId === 'string' ? purchaserId : purchaserId._id;
              console.log('🔍 Fetching purchaser with ID:', id);
              try {
                const customerRes = await postRequest(`private/getCustomerIndividualData/${id}`, {}, authCtx.token);
                console.log('📋 Purchaser API response for ID', id, ':', customerRes);
                return customerRes?.data || null;
              } catch (err) {
                console.error('❌ Error fetching purchaser ID', id, ':', err);
                return null;
              }
            });

            const purchaserDetails = await Promise.all(purchaserPromises);
            const validPurchasers = purchaserDetails.filter(p => p && p._id);
            console.log('✅ Populated purchasers:', validPurchasers);
            console.log('✅ Setting populatedPurchasers state with', validPurchasers.length, 'purchasers');
            setPopulatedPurchasers(validPurchasers);
          } catch (err) {
            console.error('❌ Error fetching purchasers:', err);
          } finally {
            setIsLoadingPurchasers(false);
          }
        } else {
          console.log('✅ Purchasers already populated');
          setPopulatedPurchasers(leadData.purchasers);
          setIsLoadingPurchasers(false);
        }
      } else {
        console.log('⚠️ No purchasers array found or purchasers array is empty');
        setPopulatedPurchasers([]);
        setIsLoadingPurchasers(false);
      }

      console.log('🔍 ====== POPULATION COMPLETE ======');
    };

    populateCustomers();
  }, [leadData?.vendors, leadData?.purchasers, authCtx.token]);

  // Effect to fetch legal fee by postcode when the view loads
  React.useEffect(() => {
    console.log('🔥 fetchLegalFeeByPostcode useEffect TRIGGERED');
    console.log('🔥 leadData:', leadData);
    console.log('🔥 service_type:', leadData?.service_type);

    const fetchLegalFeeByPostcode = async () => {
      // For Sale & Purchase, we need BOTH sale and purchase property details
      const isSalePurchase = leadData?.service_type === 'Sale & Purchase' || leadData?.service_type === 'Purchase_Sale';
      console.log('🔥 isSalePurchase:', isSalePurchase);

      if (!leadData) {
        console.log('🔥 EARLY RETURN: No leadData');
        return;
      }

      // Check if we have required data based on service type
      if (isSalePurchase) {
        // For Sale & Purchase, we need both property details
        if (!leadData.salePropertyDetails && !leadData.purchasePropertyDetails) {
          console.log('⚠️ Sale & Purchase lead but no property details found');
          return;
        }
      } else {
        // For other service types, check for standard property fields
        if (!leadData.property_address || !leadData.property_value) return;
      }

      console.log('📮 === FETCHING LEGAL FEE BY POSTCODE (SALE & PURCHASE) ===');
      console.log('🏷️ Service Type:', leadData.service_type);
      console.log('🏠 Sale Property Details:', leadData.salePropertyDetails);
      console.log('🏡 Purchase Property Details:', leadData.purchasePropertyDetails);

      // Declare postcodes at function scope
      let salePostcode = null;
      let purchasePostcode = null;
      let postcode = null;

      // For Sale & Purchase, calculate fees for BOTH parts
      if (isSalePurchase) {
        // Calculate Sale part legal fee
        if (leadData.salePropertyDetails?.address) {
          const saleAddr = leadData.salePropertyDetails.address;
          salePostcode = saleAddr.postcode || saleAddr.postal_code || saleAddr.post_code;
        }

        // Calculate Purchase part legal fee
        if (leadData.purchasePropertyDetails?.address) {
          const purchaseAddr = leadData.purchasePropertyDetails.address;
          purchasePostcode = purchaseAddr.postcode || purchaseAddr.postal_code || purchaseAddr.post_code;
        }

        console.log('📮 Sale Postcode:', salePostcode);
        console.log('📮 Purchase Postcode:', purchasePostcode);
        console.log('💰 Sale Price:', leadData.salePropertyDetails?.salePrice);
        console.log('💰 Purchase Price:', leadData.purchasePropertyDetails?.purchasePrice);

        if (!salePostcode && !purchasePostcode) {
          console.log('❌ No postcodes found for Sale & Purchase calculation');
          return;
        }

        // We'll fetch both fees and combine them
        // Continue with the Sale & Purchase specific logic below
      } else {
        // Extract postcode from property address for non Sale & Purchase types
        const addressObj = leadData.property_address || leadData.property;

        if (typeof addressObj === 'string') {
          // If it's a string, try to extract postcode from the end
          const addressParts = addressObj.split(',').map(p => p.trim());
          postcode = addressParts[addressParts.length - 1];
        } else if (addressObj) {
          postcode = addressObj.postcode || addressObj.postal_code || addressObj.post_code;
        }

        if (!postcode) {
          console.log('❌ No postcode found in property address for legal fee calculation');
          return;
        }

        console.log('📮 Postcode:', postcode);
        console.log('💰 Purchase price:', leadData.property_value);
        console.log('🏷️ Service Type:', leadData.service_type || 'Purchase');
      }

      try {
        // Check if partner is selected
        const partnerId = leadData.partner_id
          ? (typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id)
          : null;

        console.log('🤝 Partner ID for rate card:', partnerId);

        // For Sale & Purchase, use the NEW combined API
        if (isSalePurchase) {
          console.log('💰 === CALLING NEW COMBINED SALE_PURCHASE FEE API ===');

          // Prepare payload for combined API
          const combinedPayload = {
            lead_id: leadData.lead_id || leadData._id,
            product_id: leadData.product_id?._id || leadData.product_id,

            // Purchase data
            purchase_postcode: purchasePostcode,
            purchase_property_value: leadData.purchasePropertyDetails?.purchasePrice || 0,
            purchase_ownership_type: leadData.purchasePropertyDetails?.ownershipType || 'Freehold',
            purchase_info: leadData.purchasePropertyDetails?.info || leadData.info || {},

            // Sale data
            sale_postcode: salePostcode,
            sale_property_value: leadData.salePropertyDetails?.salePrice || 0,
            sale_ownership_type: leadData.salePropertyDetails?.ownershipType || 'Freehold',
            sale_info: leadData.salePropertyDetails?.info || leadData.info || {},

            // Partner ID if selected
            partner_id: partnerId
          };

          console.log('📤 Combined API payload:', combinedPayload);

          // Call the new combined API
          const response = await postRequest('private/calculateAndSaveSalePurchaseFee', combinedPayload, authCtx.token);

          console.log('📥 Combined API response:', response);

          if (response?.status === 200 && response?.data) {
            console.log('✅ Combined Sale_Purchase fees calculated and saved!');

            // Set quoteFeeData with nested format (including totals)
            setQuoteFeeData({
              fees: response.data.fees,
              disbursements: response.data.disbursements,
              totals: response.data.totals
            });

            // Also set legalFeeData for backward compatibility (flat format)
            const flatFeeData = {
              legal_fee: response.data.legal_fee,
              branch_name: response.data.branch_name,
              branch_id: response.data.branch_id,
              total_net: response.data.total_net,
              total_vat: response.data.total_vat,
              total_gross: response.data.total_gross,
              // Keep purchase and sale data separate for modal display
              purchase: response.data.purchase,
              sale: response.data.sale
            };

            setLegalFeeData(flatFeeData);
            console.log('💾 Set legalFeeData and quoteFeeData states');
            return; // Exit early since we're done
          } else {
            console.error('❌ Failed to calculate combined Sale_Purchase fees:', response);
          }
        } else {
          // Original logic for non Sale & Purchase types
          const propertyValue = leadData.service_type === 'Sale'
            ? (leadData.salePropertyDetails?.salePrice || leadData.property_value)
            : leadData.property_value;

          const payload = {
            postcode: postcode,
            purchase_price: propertyValue,
            service_type: leadData.service_type || 'Purchase'
          };

          // Add partner_id if exists (to fetch partner rate card instead of branch rate card)
          if (partnerId) {
            payload.partner_id = partnerId;
            console.log('✅ Using Partner Rate Card for partner:', partnerId);
          } else {
            console.log('📋 Using Branch Rate Card (no partner selected)');
          }

          const response = await postRequest(`private/getLegalFeeByPostcode`, payload, authCtx.token);

          console.log('🔍 Raw API Response:', response);
          console.log('🔍 Response status:', response?.status);
          console.log('🔍 Response data:', response?.data);

          if (response?.status === 200 && response?.data) {
            console.log('✅ Legal fee fetched successfully:', response.data);
            const legalFeeData = response.data;

            // Update the legal fee data
            if (legalFeeData.legal_fee || legalFeeData.legal_fees) {
              const feeData = {
                legal_fee: legalFeeData.legal_fee || legalFeeData.legal_fees,
                legal_fees: legalFeeData.legal_fees || legalFeeData.legal_fee,  // Support both variations
                branch_name: legalFeeData.branch_name,
                branch_id: legalFeeData.branch_id,
                tt_fee: legalFeeData.tt_fee,
                tt_fee_label: legalFeeData.tt_fee_label,
                identity_check: legalFeeData.identity_check,
                identity_check_label: legalFeeData.identity_check_label,
                land_registry_search: legalFeeData.land_registry_search,
                land_registry_search_label: legalFeeData.land_registry_search_label,
                land_charges_search: legalFeeData.land_charges_search,
                land_charges_search_label: legalFeeData.land_charges_search_label,
                stamp_duty: legalFeeData.stamp_duty,
                stamp_duty_label: legalFeeData.stamp_duty_label,
                hm_land_registry_fee: legalFeeData.hm_land_registry_fee,
                hm_land_registry_fee_label: legalFeeData.hm_land_registry_fee_label,
                search_pack: legalFeeData.search_pack,
                search_pack_label: legalFeeData.search_pack_label,
                all_fixed_fees: legalFeeData.all_fixed_fees,
                all_disbursements: legalFeeData.all_disbursements,
                // Sale-specific fields
                official_copies: legalFeeData.official_copies,
                mortgage_admin_fee: legalFeeData.mortgage_admin_fee,
                auction_repossession_fee: legalFeeData.auction_repossession_fee
              };
              console.log('💾 Setting legalFeeData state with:', feeData);
              setLegalFeeData(feeData);

              // Don't update leadData here to prevent infinite loop
              // The legal fee data is already stored in legalFeeData state

              console.log('💸 TT Fee:', legalFeeData.tt_fee);
              console.log('🔍 Identity Check:', legalFeeData.identity_check);
              console.log('📊 Full legalFeeData state:', legalFeeData);
            }
          } else {
            console.log('⚠️ Legal fee API response not in expected format');
            console.log('Expected: { status: 200, data: {...} }');
            console.log('Got:', response);
          }
        } // Close else block for non Sale & Purchase types
      } catch (error) {
        console.error('❌ Error fetching legal fee by postcode:', error);
      }
    };

    fetchLegalFeeByPostcode();
  }, [
    leadData?.property_address,
    leadData?.property_value,
    leadData?.partner_id,
    leadData?.service_type,
    leadData?.salePropertyDetails?.address?.postcode,
    leadData?.salePropertyDetails?.salePrice,
    leadData?.purchasePropertyDetails?.address?.postcode,
    leadData?.purchasePropertyDetails?.purchasePrice
  ]);

  // 📚 Fetch Quote History from Database
  const fetchQuoteHistory = async () => {
    if (!lead_id) return;

    try {
      console.log('📚 [Sale-Purchase] Fetching quote history from database...');

      const API_BASE_URL = `${API_BASE}/v1/admin/`;
      const response = await fetch(`${API_BASE_URL}private/getQuoteHistory/${lead_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        }
      });

      const result = await response.json();

      if (result.status === 200 && result.data) {
        console.log('✅ [Sale-Purchase] Quote history fetched:', result.data);
        setQuoteHistory(result.data);
      } else {
        console.warn('⚠️ [Sale-Purchase] No quote history found');
        setQuoteHistory([]);
      }
    } catch (error) {
      console.error('❌ [Sale-Purchase] Error fetching quote history:', error);
      setQuoteHistory([]);
    }
  };

  // 🎯 Fetch quote history on mount
  React.useEffect(() => {
    fetchQuoteHistory();
  }, [lead_id, authCtx.token]);

  // 🎯 COMMENTED OUT: This API is for regular Purchase, not Sale-Purchase
  // For Sale-Purchase, data comes from getConveyancingLead API
  /*
  React.useEffect(() => {
    const fetchActiveQuoteCalculation = async () => {
      if (!leadData || !leadData.lead_id) return;

      try {
        const leadId = leadData.lead_id || leadData._id;

        console.log(`💾 [Sale-Purchase] Fetching calculation from DATABASE for lead:`, leadId);

        // Fetch from database using fetch_lead_calculations API
        const API_BASE_URL = `${API_BASE}/v1/admin/`;
        const response = await fetch(`${API_BASE_URL}private/fetch_lead_calculations/${leadId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authCtx.token}`
          }
        });

        const res = await response.json();

        console.log('📡 [Sale-Purchase] Database Response:', res);

        if (res?.status === 200 && res?.data) {
          console.log('✅ [Sale-Purchase] Calculation loaded from DATABASE:', res.data);

          // For Sale-Purchase, data is in purchase_breakdown and sale_breakdown
          const { purchase_breakdown, sale_breakdown, fees, disbursements, totals } = res.data;

          // Set quoteFeeData for Revise Quote Modal (use breakdowns if available)
          if (purchase_breakdown && sale_breakdown) {
            setQuoteFeeData({
              purchase_breakdown,
              sale_breakdown,
              fees: fees || {},
              disbursements: disbursements || {},
              totals: totals || {}
            });

            // Transform to flat structure for ViewQuoteDetailModal from breakdowns
            const pFees = purchase_breakdown.fees || {};
            const pDisb = purchase_breakdown.disbursements || {};
            const sFees = sale_breakdown.fees || {};
            const sDisb = sale_breakdown.disbursements || {};

            const transformedData = {
              branch_name: res.data.branch_name,
              branch_id: res.data.branch_id,

              // Purchase fees
              purchase_legal_fee: pFees.legalFee?.amount || 0,
              purchase_tt_fee: pFees.ttFee?.amount || 0,
              purchase_mortgage_admin_fee: pFees.mortgageAdminFee?.amount || 0,
              purchase_leasehold_fee: pFees.leaseholdFee?.amount || 0,
              purchase_help_to_buy_isa_fee: pFees.helpToBuyISAFee?.amount || 0,
              purchase_help_to_buy_fee: pFees.helpToBuyFee?.amount || 0,
              purchase_right_to_buy_fee: pFees.rightToBuyFee?.amount || 0,
              purchase_shared_ownership_fee: pFees.sharedOwnershipFee?.amount || 0,
              purchase_new_build_fee: pFees.newBuildFee?.amount || 0,
              purchase_islamic_mortgage_fee: pFees.islamicMortgageFee?.amount || 0,
              purchase_auction_repossession_fee: pFees.auctionRepossessionFee?.amount || 0,
              purchase_gifted_deposit_fee: pFees.giftedDepositFeeFirstGiftor?.amount || 0,
              purchase_buy_to_let_fee: pFees.buyToLetFee?.amount || 0,
              purchase_arranging_indemnity_policy: pFees.arrangingIndemnityPolicy?.amount || 0,
              purchase_identity_check: pFees.identityCheck?.amount || 0,

              // Purchase disbursements
              purchase_stamp_duty: pDisb.stampDuty?.amount || 0,
              purchase_hm_land_registry_fee: pDisb.hmLandRegistryFee?.amount || 0,
              purchase_land_registry_search: pDisb.landRegistrySearch?.amount || 0,
              purchase_land_charges_search: pDisb.landChargesSearch?.amount || 0,
              purchase_search_pack: pDisb.searchPack?.amount || 0,

              // Sale fees
              sale_legal_fee: sFees.legalFee?.amount || 0,
              sale_tt_fee: sFees.ttFee?.amount || 0,
              sale_leasehold_fee: sFees.leaseholdFee?.amount || 0,
              sale_mortgage_admin_fee: sFees.mortgageAdminFee?.amount || 0,
              sale_shared_ownership_fee: sFees.sharedOwnershipFee?.amount || 0,
              sale_auction_repossession_fee: sFees.auctionRepossessionFee?.amount || 0,
              sale_identity_check: sFees.identityCheck?.amount || 0,

              // Sale disbursements
              sale_official_copies: sDisb.officialCopiesFee?.amount || sDisb.officialCopies?.amount || 0,

              // Keep nested structure for modal
              purchase_breakdown: purchase_breakdown,
              sale_breakdown: sale_breakdown,
              fees: fees || {},
              disbursements: disbursements || {},
              api_response: res.data
            };

            console.log('🔄 [Sale-Purchase] Transformed data for ViewQuoteDetailModal:', transformedData);
            setLegalFeeData(transformedData);
          } else {
            // Fallback to old format if breakdowns not available
            setQuoteFeeData({ fees: fees || {}, disbursements: disbursements || {}, totals: totals || {} });

            const transformedData = {
              branch_name: res.data.branch_name,
              branch_id: res.data.branch_id,
              legal_fee: fees?.legalFee?.amount || 0,
              tt_fee: fees?.ttFee?.amount || 0,
              fees: fees,
              disbursements: disbursements,
              api_response: res.data
            };
            setLegalFeeData(transformedData);
          }
        } else {
          console.warn('⚠️ [Sale-Purchase] No calculation found in database, will use current values');
        }
      } catch (error) {
        console.error('❌ [Sale-Purchase] Error fetching calculation from database:', error);
      }
    };

    fetchActiveQuoteCalculation();
  }, [leadData?.lead_id, authCtx.token]);
  */

  const calculateQuote = () => {
    if (!leadData) return { base: 0, vat: 0, total: 0, breakdown: {} };
    
    // If we have backend-calculated values, use them
    if (leadData.total_quote && leadData.legal_fee !== undefined) {
      return {
        base: parseFloat(leadData.legal_fee || 0).toFixed(2),
        vat: parseFloat(leadData.vat_amount || 0).toFixed(2),
        total: parseFloat(leadData.total_quote || 0).toFixed(2),
        breakdown: {
          fixedFees: leadData.fixed_fees || {},
          disbursements: leadData.disbursements || {}
        }
      };
    }
    
    // Fallback calculation for legacy data
    let baseFee = parseFloat(leadData.legal_fee || 575);
    let additionalFees = 0;
    
    // Add fixed fees based on options
    if (leadData.leasehold) additionalFees += 150;
    if (leadData.mortgage_lender) additionalFees += 150;
    if (leadData.help_to_buy) additionalFees += 150;
    if (leadData.shared_ownership) additionalFees += 150;
    additionalFees += 30; // TT fee
    
    const subtotal = baseFee + additionalFees;
    const disbursements = 340; // Search pack + Identity check
    const vat = subtotal * 0.20;
    const total = subtotal + vat + disbursements;
    
    return { 
      base: subtotal.toFixed(2), 
      vat: vat.toFixed(2), 
      total: total.toFixed(2),
      breakdown: {
        baseFee: baseFee,
        additionalFees: additionalFees,
        disbursements: disbursements
      }
    };
  };

  // 🔁 Handle Regenerate Quote - Restore Original Quote
  const handleRegenerateQuote = async () => {
    try {
      const confirmResult = await Swal.fire({
        title: 'Regenerate Original Quote?',
        text: 'This will restore the original quote values. Current changes will be saved to history.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, regenerate it!'
      });

      if (!confirmResult.isConfirmed) {
        return;
      }

      console.log('🔁 ===== REGENERATE QUOTE (Sale-Purchase) =====');
      console.log('📋 Lead ID:', lead_id);

      // Call regenerateQuote API
      const API_BASE_URL = `${API_BASE}/v1/admin/`;
      const apiUrl = `${API_BASE_URL}private/regenerateQuote/${lead_id}`;
      console.log('📡 Calling regenerateQuote API:', apiUrl);

      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        }
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ API Error Response:', errorText);
        throw new Error(`API call failed: ${res.status} - ${errorText}`);
      }

      const result = await res.json();
      console.log('✅ Regenerate Quote API Response:', result);

      if (result.status === 200) {
        // Refresh data
        await fetchQuoteHistory();

        // Reload page to refresh active quote
        Swal.fire('Success', 'Original quote restored successfully!', 'success').then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire('Error', result?.message || 'Failed to regenerate quote', 'error');
      }
    } catch (err) {
      console.error('❌ Error regenerating quote:', err);
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    }
  };

  // OLD IMPLEMENTATION - REMOVED
  // Function to regenerate quote - fetch original values again
  const handleRegenerateQuote_OLD = async () => {
    try {
      // First, show confirmation
      const result = await Swal.fire({
        title: 'Regenerate Quote?',
        text: 'This will reset all values to the original quote. Continue?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Regenerate',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) return;

      // Re-fetch legal fee by postcode to get original values
      if (leadData?.property_address && leadData?.property_value) {
        let postcode = null;
        const addressObj = leadData.property_address || leadData.property;

        if (typeof addressObj === 'string') {
          const addressParts = addressObj.split(',').map(p => p.trim());
          postcode = addressParts[addressParts.length - 1];
        } else if (addressObj) {
          postcode = addressObj.postcode || addressObj.postal_code || addressObj.post_code;
        }

        if (postcode) {
          const response = await postRequest(`private/getLegalFeeByPostcode`, {
            postcode: postcode,
            purchase_price: leadData.property_value,
            service_type: leadData.service_type || 'Purchase'
          }, authCtx.token);

          if (response?.status === 200 && response?.data) {
            const legalFeeData = response.data;

            // Reset to original values
            const feeData = {
              legal_fee: legalFeeData.legal_fee || legalFeeData.legal_fees,
              branch_name: legalFeeData.branch_name,
              branch_id: legalFeeData.branch_id,
              tt_fee: legalFeeData.tt_fee,
              identity_check: legalFeeData.identity_check,
              land_registry_search: legalFeeData.land_registry_search,
              land_registry_search_label: legalFeeData.land_registry_search_label,
              land_charges_search: legalFeeData.land_charges_search,
              land_charges_search_label: legalFeeData.land_charges_search_label,
              stamp_duty: legalFeeData.stamp_duty,
              stamp_duty_label: legalFeeData.stamp_duty_label,
              hm_land_registry_fee: legalFeeData.hm_land_registry_fee,
              hm_land_registry_fee_label: legalFeeData.hm_land_registry_fee_label,
              search_pack: legalFeeData.search_pack,
              search_pack_label: legalFeeData.search_pack_label,
              all_fixed_fees: legalFeeData.all_fixed_fees,
              all_disbursements: legalFeeData.all_disbursements
            };
            
            // Update states with original values
            setLegalFeeData(feeData);
            
            // Reset revision count to 0
            setRevisionCount(0);
            setQuoteHistory([]);
            
            Swal.fire('Success!', 'Quote has been regenerated with original values.', 'success');
          } else {
            throw new Error('Failed to fetch original quote values');
          }
        } else {
          throw new Error('No postcode found to regenerate quote');
        }
      } else {
        throw new Error('Missing property address or value to regenerate quote');
      }
    } catch (err) {
      console.error('Error regenerating quote:', err);
      Swal.fire('Error!', err.message || 'An error occurred while regenerating the quote.', 'error');
    }
  };

  // Handle viewing quote details
  const handleViewQuoteDetail = async (quote) => {
    console.log('🔴 handleViewQuoteDetail called with quote:', quote);
    console.log('Lead Data:', leadData);
    console.log('🏠 Service Type:', leadData?.service_type);

    try {
      // If viewing a specific historical quote, handle it separately
      if (quote && quote.fees) {
        console.log('📜 Viewing historical quote:', quote);
        // Convert historical quote format to legalFeeData format for the modal
        const historicalFeeData = {
          legal_fee: quote.fees.legal_fee || 0,
          tt_fee: quote.fees.tt_fee || 0,
          identity_check: quote.fees.identity_check || 0,
          stamp_duty: quote.fees.stamp_duty || 0,
          hm_land_registry_fee: quote.fees.hm_land_registry_fee || 0,
          land_registry_search: quote.fees.land_registry_search || 0,
          land_charges_search: quote.fees.land_charges_search || 0,
          search_pack: quote.fees.search_pack || 0,
          branch_name: quote.branch_name || legalFeeData?.branch_name,
          branch_id: legalFeeData?.branch_id,
          all_fixed_fees: legalFeeData?.all_fixed_fees || [],
          all_disbursements: legalFeeData?.all_disbursements || []
        };
        const quoteDetailsData = { legalFeeData: historicalFeeData, leadData };
        setSelectedQuote(quoteDetailsData);
        setShowQuoteDetailModal(true);
        return;
      }

      // If legalFeeData is already loaded with revised/updated values, use it directly
      // This ensures that after revise quote, the view quote detail shows the updated values
      if (legalFeeData && legalFeeData.legal_fee !== undefined) {
        console.log('✅ Using existing legalFeeData (possibly revised):', legalFeeData);
        const quoteDetailsData = { legalFeeData, leadData };
        setSelectedQuote(quoteDetailsData);
        setShowQuoteDetailModal(true);
        return;
      }

      // Get postcode from lead data
      let postcode = '';

      // For Purchase_Sale, prioritize purchase property address
      if (leadData?.service_type === 'Purchase_Sale' && leadData?.purchasePropertyDetails?.address) {
        const purchaseAddress = leadData.purchasePropertyDetails.address;
        postcode = purchaseAddress.postcode || '';
      }
      // Otherwise use general property_address
      else if (leadData?.property_address) {
        const addressObj = leadData.property_address;
        postcode = addressObj.postcode || addressObj.postal_code || addressObj.post_code || '';
      }

      if (!postcode) {
        console.log('⚠️ No postcode found for legal fee calculation');
        // If no postcode, open modal with existing data
        const quoteDetailsData = { legalFeeData, leadData };
        setSelectedQuote(quoteDetailsData);
        setShowQuoteDetailModal(true);
        return;
      }

      console.log('📮 Fetching legal fee for postcode:', postcode);
      console.log('🏠 Service Type:', leadData?.service_type);

      // SALE flow: branch-based costs and calculation
      if (leadData?.service_type === 'Sale') {
        console.log('🏢 Sale service type detected - fetching branch-based costs');
        const branch = await fetchBranchByPostcode(postcode);
        if (branch && leadData.product_id) {
          const costs = await fetchConveyancingCosts(branch._id, leadData.product_id);
          if (costs) {
            console.log('💰 Got conveyancing costs for Sale:', costs);
            const saleQuote = calculateBranchBasedQuote(
              leadData.property_value || 0,
              'Sale',
              costs,
              {
                mortgage_outstanding: leadData.mortgage_outstanding,
                estate_agent: leadData.estate_agent,
                chain_free: leadData.chain_free
              }
            );

            // Build saleFeeData from costs and saleQuote (fallback to costs-derived values)
            // Use legal_fee from backend API response (already calculated)
            let ttFee = costs.tt_fee || 30;
            let identityCheck = costs.identity_check || 10;
            let officialCopies = costs.official_copies || 14;
            let legalFeeFromRange = costs.legal_fee || saleQuote?.legal_fee || 0;
            let extractedMortgageAdminFee = costs.mortgage_admin_fee || (saleQuote && saleQuote.mortgage_admin_fee) || 0;

            console.log('🔍 Using fees from backend API:', {
              legal_fee: costs.legal_fee,
              tt_fee: costs.tt_fee,
              identity_check: costs.identity_check,
              mortgage_admin_fee: costs.mortgage_admin_fee,
              official_copies: costs.official_copies
            });

            if (costs) {
              const propertyValue = leadData.property_value || 0;

              // Root-level propertyRangeFees (preferred) - check both minValue and minPropertyValue formats
              if (costs.propertyRangeFees && Array.isArray(costs.propertyRangeFees)) {
                const matchingRange = costs.propertyRangeFees.find(r =>
                  propertyValue >= (r.minValue || r.minPropertyValue || 0) &&
                  propertyValue <= (r.maxValue || r.maxPropertyValue || Infinity)
                );
                if (matchingRange) {
                  const candidate = matchingRange.legalFee ?? matchingRange.legal_fee ?? matchingRange.legalFees ?? matchingRange.legal_fees ?? matchingRange.amount ?? matchingRange.fee ?? null;
                  if (candidate !== null && candidate !== undefined) {
                    legalFeeFromRange = parseFloat(candidate) || legalFeeFromRange;
                    console.log('✅ Found legal fee from range (root):', legalFeeFromRange);
                  }
                }
              }

              // Transactions may contain transaction-level fixedFees and propertyRangeFees
              if (costs.transactions && Array.isArray(costs.transactions)) {
                const normalizeTransactionType = (t) => {
                  if (!t) return '';
                  if (typeof t === 'string') return t;
                  if (typeof t === 'object') return (t.name || t.label || t.type || t.transactionType || '') + '';
                  return '';
                };

                let tx = costs.transactions.find(t => {
                  const txType = (normalizeTransactionType(t.transactionType) || '').toLowerCase();
                  return txType === 'sale' || txType.includes('sale');
                });
                if (!tx) tx = costs.transactions.find(t => (normalizeTransactionType(t.transactionType) || '').toLowerCase().includes('sale')) || costs.transactions[0];

                if (tx) {
                  // Transaction-level propertyRangeFees array
                  if (tx.propertyRangeFees && Array.isArray(tx.propertyRangeFees)) {
                    const matchingRange = tx.propertyRangeFees.find(r => propertyValue >= (r.minValue||0) && propertyValue <= (r.maxValue||Infinity));
                    if (matchingRange) {
                      const candidate = matchingRange.legalFee ?? matchingRange.legal_fee ?? matchingRange.legalFees ?? matchingRange.legal_fees ?? matchingRange.amount ?? matchingRange.fee ?? null;
                      if (candidate !== null && candidate !== undefined) {
                        legalFeeFromRange = parseFloat(candidate) || legalFeeFromRange;
                        console.log('✅ Found legal fee from range (transaction):', legalFeeFromRange);
                      }
                    }
                  }

                  // Transaction.propertyValues object (legacy shape)
                  if ((!legalFeeFromRange || legalFeeFromRange === 0) && tx.propertyValues) {
                    const propertyRanges = Object.keys(tx.propertyValues || {}).sort((a, b) => {
                      const aMax = parseInt(a.split('-')[1]?.replace(/[^\d]/g, '') || '999999999');
                      const bMax = parseInt(b.split('-')[1]?.replace(/[^\d]/g, '') || '999999999');
                      return aMax - bMax;
                    });
                    for (const range of propertyRanges) {
                      const [minStr, maxStr] = range.split('-');
                      const min = parseInt((minStr || '').replace(/[^\d]/g, '')) || 0;
                      const max = parseInt((maxStr || '').replace(/[^\d]/g, '')) || Infinity;
                      if (propertyValue >= min && propertyValue <= max) {
                        const v = parseFloat(tx.propertyValues[range]) || 0;
                        if (v) { legalFeeFromRange = v; break; }
                      }
                    }
                  }

                  // Extract fixedFees: array or object
                  if (tx.fixedFees) {
                    if (Array.isArray(tx.fixedFees)) {
                      tx.fixedFees.forEach(f => {
                        const label = (f.label || f.name || '').toString().toLowerCase();
                        const amt = parseFloat(f.amount || f.value || 0) || 0;
                        if (/telegraphic|tt|transfer/.test(label) && amt) ttFee = amt;
                        if (/mortgage\s*admin|mortgageadmin|mortgage_admin|mortgage admin|mortgageadminfee/i.test(label) && amt) extractedMortgageAdminFee = amt;
                      });
                    } else if (typeof tx.fixedFees === 'object') {
                      Object.values(tx.fixedFees).forEach(f => {
                        const label = (f.label || f.name || '') + '';
                        const l = label.toLowerCase();
                        const amt = parseFloat(f.amount || f || 0) || 0;
                        if (/telegraphic|tt|transfer/.test(l) && amt) ttFee = amt;
                        if (/mortgage\s*admin|mortgageadmin|mortgage_admin|mortgage admin|mortgageadminfee/i.test(l) && amt) extractedMortgageAdminFee = amt;
                      });
                    }
                  }

                  // Transaction-level disbursements
                  if (tx.disbursements && Array.isArray(tx.disbursements)) {
                    const idItem = tx.disbursements.find(d => /identity/i.test(d.label || d.name || ''));
                    if (idItem) identityCheck = parseFloat(idItem.amount || 0) || identityCheck;
                    const ocItem = tx.disbursements.find(d => /official/i.test(d.label || d.name || ''));
                    if (ocItem) officialCopies = parseFloat(ocItem.amount || 0) || officialCopies;
                  }
                }
              }

              // Root-level fixedFees/disbursements fallback extraction
              if (costs.fixedFees && Array.isArray(costs.fixedFees)) {
                const ttItem = costs.fixedFees.find(f => /telegraphic|tt|transfer/i.test(f.label || f.name || ''));
                if (ttItem) ttFee = parseFloat(ttItem.amount || 0) || ttFee;
                const mItem = costs.fixedFees.find(f => /mortgage\s*admin|mortgageadmin|mortgage_admin|mortgage admin|mortgageadminfee/i.test(f.label || f.name || ''));
                if (mItem) extractedMortgageAdminFee = parseFloat(mItem.amount || 0) || extractedMortgageAdminFee;
              }

              if (costs.disbursements && Array.isArray(costs.disbursements)) {
                const idItem = costs.disbursements.find(d => /identity/i.test(d.label || d.name || ''));
                if (idItem) identityCheck = parseFloat(idItem.amount || 0) || identityCheck;
                const ocItem = costs.disbursements.find(d => /official/i.test(d.label || d.name || ''));
                if (ocItem) officialCopies = parseFloat(ocItem.amount || 0) || officialCopies;
              }

              // Extract common disbursements (HM Land Registry, Land Registry Search, Land Charges Search, Search Pack)
              let hmLandRegistryFee = 0;
              let landRegistrySearch = 0;
              let landChargesSearch = 0;
              let searchPack = 0;

              // Prefer saleQuote disbursements if present
              if (saleQuote && saleQuote.all_disbursements && Array.isArray(saleQuote.all_disbursements)) {
                saleQuote.all_disbursements.forEach(d => {
                  const label = (d.label || d.name || '').toString().toLowerCase();
                  const amt = parseFloat(d.amount || d.value || 0) || 0;
                  if (label.includes('hm land registry')) hmLandRegistryFee = amt;
                  if (label.includes('land registry') && label.includes('search')) landRegistrySearch = amt;
                  if (label.includes('land charges')) landChargesSearch = amt;
                  if (label.includes('search pack') || label.includes('searches')) searchPack = amt;
                });
              }

              // Fall back to root-level costs.disbursements
              if (costs.disbursements && Array.isArray(costs.disbursements)) {
                costs.disbursements.forEach(d => {
                  const label = (d.label || d.name || '').toString().toLowerCase();
                  const amt = parseFloat(d.amount || d.value || 0) || 0;
                  if (!hmLandRegistryFee && label.includes('hm land registry')) hmLandRegistryFee = amt;
                  if (!landRegistrySearch && label.includes('land registry') && label.includes('search')) landRegistrySearch = amt;
                  if (!landChargesSearch && label.includes('land charges')) landChargesSearch = amt;
                  if (!searchPack && (label.includes('search pack') || label.includes('searches'))) searchPack = amt;
                });
              }

              // Also check transaction-level disbursements (already partially handled above)
              if (costs.transactions && Array.isArray(costs.transactions)) {
                costs.transactions.forEach(tx => {
                  if (tx.disbursements && Array.isArray(tx.disbursements)) {
                    tx.disbursements.forEach(d => {
                      const label = (d.label || d.name || '').toString().toLowerCase();
                      const amt = parseFloat(d.amount || d.value || 0) || 0;
                      if (!hmLandRegistryFee && label.includes('hm land registry')) hmLandRegistryFee = amt;
                      if (!landRegistrySearch && label.includes('land registry') && label.includes('search')) landRegistrySearch = amt;
                      if (!landChargesSearch && label.includes('land charges')) landChargesSearch = amt;
                      if (!searchPack && (label.includes('search pack') || label.includes('searches'))) searchPack = amt;
                    });
                  }
                });
              }

              // Attach the discovered disbursement values back to variables used by the modal
              // These will be included in saleFeeData below
              var _hmLandRegistryFee = hmLandRegistryFee;
              var _landRegistrySearch = landRegistrySearch;
              var _landChargesSearch = landChargesSearch;
              var _searchPack = searchPack;
            }

            const saleFeeData = {
              // Prefer the legal fee determined from propertyRangeFees (exact match),
              // otherwise use the calculated saleQuote. This ensures property_value range mapping drives legal fee.
              legal_fee: (legalFeeFromRange && Number(legalFeeFromRange)) || saleQuote?.legal_fee || 0,
              branch_name: branch.name,
              branch_id: branch._id,
              tt_fee: ttFee,
              identity_check: identityCheck,
              // Prefer extracted mortgage admin fee from branch transaction fixedFees, then saleQuote, otherwise fallback to 150 when mortgage outstanding
              mortgage_admin_fee: (extractedMortgageAdminFee && Number(extractedMortgageAdminFee)) || (saleQuote && saleQuote.mortgage_admin_fee) || (leadData.mortgage_outstanding ? 150 : 0),
              official_copies: officialCopies,
              stamp_duty: saleQuote?.stamp_duty || 0,
              land_registry_search: saleQuote?.land_registry_search || _landRegistrySearch || 0,
              land_charges_search: saleQuote?.land_charges_search || _landChargesSearch || 0,
              hm_land_registry_fee: saleQuote?.hm_land_registry_fee || _hmLandRegistryFee || 0,
              search_pack: saleQuote?.search_pack || _searchPack || 0,
              additional_fees: saleQuote?.additional_fees || 0,
              property_value: leadData?.property_value || 0,
              service_type: 'Sale',
              calculation_source: saleQuote?.calculation_source || 'branch_costs',
              // If the branch returned vat/total use it, otherwise compute totals in the same way Purchase flow does
              vat_amount: saleQuote?.vat_amount || (function() {
                const lf = Number(((legalFeeFromRange && Number(legalFeeFromRange)) || saleQuote?.legal_fee || 0));
                const tt = Number(ttFee || 0);
                const idc = Number(identityCheck || 0);
                const ma = Number(((extractedMortgageAdminFee && Number(extractedMortgageAdminFee)) || (saleQuote && saleQuote.mortgage_admin_fee) || (leadData.mortgage_outstanding ? 150 : 0)) || 0);
                const oc = Number(officialCopies || 0);
                // VAT applies to legal fee, TT and mortgage admin fee (official copies and many disbursements are 0% VAT)
                return Math.round(((lf * 0.20) + (tt * 0.20) + (ma * 0.20)) * 100) / 100;
              })(),
              total_quote: saleQuote?.total_quote || (function() {
                const lf = Number(((legalFeeFromRange && Number(legalFeeFromRange)) || saleQuote?.legal_fee || 0));
                const tt = Number(ttFee || 0);
                const idc = Number(identityCheck || 0);
                const sd = Number(saleQuote?.stamp_duty || 0);
                const hm = Number(saleQuote?.hm_land_registry_fee || _hmLandRegistryFee || 0);
                const lrs = Number(saleQuote?.land_registry_search || _landRegistrySearch || 0);
                const lcs = Number(saleQuote?.land_charges_search || _landChargesSearch || 0);
                const sp = Number(saleQuote?.search_pack || _searchPack || 0);
                const ma = Number(((extractedMortgageAdminFee && Number(extractedMortgageAdminFee)) || (saleQuote && saleQuote.mortgage_admin_fee) || (leadData.mortgage_outstanding ? 150 : 0)) || 0);
                const oc = Number(officialCopies || 0);

                const totalNet = lf + tt + idc + sd + hm + lrs + lcs + sp + (leadData?.service_type === 'Sale' ? (ma + oc) : 0);
                const totalVAT = Math.round((lf * 0.20 + tt * 0.20 + ma * 0.20) * 100) / 100;
                return Math.round((totalNet + totalVAT) * 100) / 100;
              })(),
              all_fixed_fees: saleQuote?.all_fixed_fees || costs?.fixedFees || [],
              all_disbursements: saleQuote?.all_disbursements || costs?.disbursements || [],
              costs_data: costs
            };

            setLegalFeeData(saleFeeData);
            setSelectedQuote({ legalFeeData: saleFeeData, leadData });
            setShowQuoteDetailModal(true);
            return;
          }
        }
        // If branch or costs missing, fall through to generic fallback
        console.log('⚠️ Could not obtain branch costs for Sale; falling back to existing data');
        setSelectedQuote({ legalFeeData, leadData });
        setShowQuoteDetailModal(true);
        return;
      }

      // PURCHASE_SALE flow: handle both sale and purchase quotes
      if (leadData?.service_type === 'Purchase_Sale') {
        console.log('🏢🏠 Purchase_Sale service type detected');

        // 🎯 STEP 1: Try to fetch existing calculation from database
        try {
          console.log('📞 Step 1: Fetching calculation using fetch_lead_calculations API...');

          // Get partner_id if exists
          const partnerId = leadData.partner_id?._id || leadData.partner_id;
          console.log('🤝 Partner ID for fetch:', partnerId);

          // Use same API as Purchase (GET request) - Include partner_id as query parameter
          const API_BASE_URL = `${API_BASE}/v1/admin/`;
          const fetchUrl = partnerId
            ? `${API_BASE_URL}private/fetch_lead_calculations/${lead_id}?partner_id=${partnerId}`
            : `${API_BASE_URL}private/fetch_lead_calculations/${lead_id}`;

          console.log('📞 Fetching from:', fetchUrl);

          const response = await fetch(fetchUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authCtx.token}`
            }
          });

          const res = await response.json();

          if (res?.status === 200 && res?.data) {
            console.log('✅ Found existing calculation in database');

            const calculationData = res.data;

            // Set quoteFeeData (for Quote Summary)
            // ✅ For Sale & Purchase: Use totals from combined calculation (has nested total structure)
            if (calculationData.purchase_breakdown && calculationData.sale_breakdown) {
              console.log('✅ Sale & Purchase: Setting quoteFeeData with combined totals from database');
              console.log('📊 calculationData.totals:', calculationData.totals);
              console.log('📊 calculationData.totals.total:', calculationData.totals?.total);
              setQuoteFeeData({
                purchase_breakdown: calculationData.purchase_breakdown || {},
                sale_breakdown: calculationData.sale_breakdown || {},
                fees: calculationData.fees || {},
                disbursements: calculationData.disbursements || {},
                totals: calculationData.totals || {} // ✅ This has nested { total: {net, vat, gross}, legalCost, disbursementCost }
              });
              console.log('✅ quoteFeeData set! Check Quote Summary now.');
            } else {
              // For single Purchase or Sale
              setQuoteFeeData({
                fees: calculationData.fees || {},
                disbursements: calculationData.disbursements || {},
                totals: calculationData.totals || {}
              });
            }

            // Helper function to convert breakdown to renderQuoteTable format
            const convertBreakdownToQuoteFormat = (breakdown, serviceType) => {
              if (!breakdown || !breakdown.fees) return null;

              const fixedFees = [];
              const disbursements = [];
              const fees = breakdown.fees || {};
              const disbs = breakdown.disbursements || {};

              // Extract fixed fees from fees Map
              Object.entries(fees).forEach(([key, value]) => {
                const feeLabel = value.label || key;
                const feeAmount = value.amount || value.net || 0;

                // Skip legal fee (it's the base)
                if (key.toLowerCase().includes('legalfee') || key.toLowerCase() === 'legal_fee') {
                  return;
                }

                // Add to fixed fees if it has amount
                if (feeAmount > 0) {
                  fixedFees.push({ label: feeLabel, amount: feeAmount });
                }
              });

              // Extract disbursements from disbursements Map
              Object.entries(disbs).forEach(([key, value]) => {
                const disbLabel = value.label || key;
                const disbAmount = value.amount || value.net || 0;

                if (disbAmount > 0) {
                  disbursements.push({ label: disbLabel, amount: disbAmount });
                }
              });

              // Get legal fee (base)
              const legalFeeEntry = Object.entries(fees).find(([key]) =>
                key.toLowerCase().includes('legalfee') || key.toLowerCase() === 'legal_fee'
              );
              const baseLegalFee = legalFeeEntry ? (legalFeeEntry[1].amount || legalFeeEntry[1].net || 0) : 0;

              return {
                base: baseLegalFee,
                fixedFees,
                disbursements
              };
            };

            // Transform purchase_breakdown and sale_breakdown to quote format
            let saleQuote = null;
            let purchaseQuote = null;

            if (calculationData.purchase_breakdown) {
              purchaseQuote = convertBreakdownToQuoteFormat(calculationData.purchase_breakdown, 'Purchase');
              console.log('📦 Converted Purchase breakdown to quote format:', purchaseQuote);
            }

            if (calculationData.sale_breakdown) {
              saleQuote = convertBreakdownToQuoteFormat(calculationData.sale_breakdown, 'Sale');
              console.log('🏘️ Converted Sale breakdown to quote format:', saleQuote);
            }

            // Enrich leadData with transformed quotes
            const enrichedLeadData = {
              ...leadData,
              saleQuote,
              purchaseQuote
            };

            // Set legalFeeData for modal
            const feeDataFromDB = {
              legal_fee: calculationData.legal_fee || 0,
              tt_fee: calculationData.tt_fee || 0,
              identity_check: calculationData.identity_check || 0,
              leasehold_fee: calculationData.leasehold_fee || 0,
              mortgage_admin_fee: calculationData.mortgage_admin_fee || 0,
              shared_ownership_fee: calculationData.shared_ownership_fee || 0,
              auction_repossession_fee: calculationData.auction_repossession_fee || 0,
              official_copies: calculationData.official_copies || 0,
              stamp_duty: calculationData.stamp_duty || 0,
              hm_land_registry_fee: calculationData.hm_land_registry_fee || 0,
              land_registry_search: calculationData.land_registry_search || 0,
              land_charges_search: calculationData.land_charges_search || 0,
              search_pack: calculationData.search_pack || 0,
              branch_name: calculationData.branch_name || '',
              branch_id: calculationData.branch_id || null,
              fees: calculationData.fees || {},
              disbursements: calculationData.disbursements || {},
              totals: calculationData.totals || {},
              total_net: calculationData.total_net || 0,
              total_vat: calculationData.total_vat || 0,
              total_gross: calculationData.total_gross || 0,
              purchase: calculationData.purchase_data || null,
              sale: calculationData.sale_data || null,
              calculation_source: 'database',
              calculated_at: calculationData.calculated_at
            };

            console.log('✅ Opening modal with existing calculation and transformed quotes');
            setSelectedQuote({ legalFeeData: feeDataFromDB, leadData: enrichedLeadData });
            setShowQuoteDetailModal(true);
            return;
          }
        } catch (apiError) {
          console.log('⚠️ No existing calculation (404), creating new...');
        }

        // 🎯 STEP 2: Create new calculation if not exists
        try {
          console.log('📞 Step 2: Creating new combined calculation...');

          const purchasePostcode = leadData.purchasePropertyDetails?.address?.postcode ||
                                   leadData.purchasePropertyDetails?.address?.postal_code;
          const salePostcode = leadData.salePropertyDetails?.address?.postcode ||
                              leadData.salePropertyDetails?.address?.postal_code;
          const partnerId = leadData.partner_id?._id || leadData.partner_id;

          const payload = {
            lead_id: leadData.lead_id || leadData._id,
            product_id: leadData.product_id?._id || leadData.product_id,
            purchase_postcode: purchasePostcode,
            purchase_property_value: leadData.purchasePropertyDetails?.purchasePrice || 0,
            purchase_ownership_type: leadData.purchasePropertyDetails?.ownershipType || 'Freehold',
            purchase_info: leadData.purchasePropertyDetails?.info || leadData.info || {},
            sale_postcode: salePostcode,
            sale_property_value: leadData.salePropertyDetails?.salePrice || 0,
            sale_ownership_type: leadData.salePropertyDetails?.ownershipType || 'Freehold',
            sale_info: leadData.salePropertyDetails?.info || leadData.info || {},
            partner_id: partnerId
          };

          console.log('📤 Payload:', payload);

          const createResponse = await postRequest('private/calculateAndSaveSalePurchaseFee', payload, authCtx.token);

          if (createResponse?.status === 200 && createResponse?.data) {
            console.log('✅ Calculation created!');

            setQuoteFeeData({
              fees: createResponse.data.fees || {},
              disbursements: createResponse.data.disbursements || {},
              totals: createResponse.data.totals || {}
            });

            // Helper function to convert breakdown to renderQuoteTable format
            const convertBreakdownToQuoteFormat = (breakdown, serviceType) => {
              if (!breakdown || !breakdown.fees) return null;

              const fixedFees = [];
              const disbursements = [];
              const fees = breakdown.fees || {};
              const disbs = breakdown.disbursements || {};

              // Extract fixed fees from fees Map
              Object.entries(fees).forEach(([key, value]) => {
                const feeLabel = value.label || key;
                const feeAmount = value.amount || value.net || 0;

                // Skip legal fee (it's the base)
                if (key.toLowerCase().includes('legalfee') || key.toLowerCase() === 'legal_fee') {
                  return;
                }

                // Add to fixed fees if it has amount
                if (feeAmount > 0) {
                  fixedFees.push({ label: feeLabel, amount: feeAmount });
                }
              });

              // Extract disbursements from disbursements Map
              Object.entries(disbs).forEach(([key, value]) => {
                const disbLabel = value.label || key;
                const disbAmount = value.amount || value.net || 0;

                if (disbAmount > 0) {
                  disbursements.push({ label: disbLabel, amount: disbAmount });
                }
              });

              // Get legal fee (base)
              const legalFeeEntry = Object.entries(fees).find(([key]) =>
                key.toLowerCase().includes('legalfee') || key.toLowerCase() === 'legal_fee'
              );
              const baseLegalFee = legalFeeEntry ? (legalFeeEntry[1].amount || legalFeeEntry[1].net || 0) : 0;

              return {
                base: baseLegalFee,
                fixedFees,
                disbursements
              };
            };

            // Transform purchase_breakdown and sale_breakdown to quote format
            let saleQuote = null;
            let purchaseQuote = null;

            if (createResponse.data.purchase_breakdown) {
              purchaseQuote = convertBreakdownToQuoteFormat(createResponse.data.purchase_breakdown, 'Purchase');
              console.log('📦 Converted Purchase breakdown to quote format:', purchaseQuote);
            }

            if (createResponse.data.sale_breakdown) {
              saleQuote = convertBreakdownToQuoteFormat(createResponse.data.sale_breakdown, 'Sale');
              console.log('🏘️ Converted Sale breakdown to quote format:', saleQuote);
            }

            // Enrich leadData with transformed quotes
            const enrichedLeadData = {
              ...leadData,
              saleQuote,
              purchaseQuote
            };

            const feeDataFromAPI = {
              legal_fee: createResponse.data.legal_fee || 0,
              branch_name: createResponse.data.branch_name || '',
              branch_id: createResponse.data.branch_id || null,
              fees: createResponse.data.fees || {},
              disbursements: createResponse.data.disbursements || {},
              totals: createResponse.data.totals || {},
              total_net: createResponse.data.total_net || 0,
              total_vat: createResponse.data.total_vat || 0,
              total_gross: createResponse.data.total_gross || 0,
              purchase: createResponse.data.purchase || null,
              sale: createResponse.data.sale || null,
              calculation_source: 'api',
              calculated_at: createResponse.data.calculated_at
            };

            console.log('✅ Opening modal with new calculation and transformed quotes');
            setSelectedQuote({ legalFeeData: feeDataFromAPI, leadData: enrichedLeadData });
            setShowQuoteDetailModal(true);
            return;
          }
        } catch (createError) {
          console.error('❌ Failed to create calculation:', createError);
        }

        // 🔄 FALLBACK: If API call failed, do manual calculation (existing logic)
        console.log('🔄 Proceeding with manual calculation for Sale-Purchase');
        const branch = await fetchBranchByPostcode(postcode);
        if (branch && leadData.product_id) {
          // Helper function to transform fee data to renderQuoteTable format
          const transformToQuoteFormat = (feeData, serviceType) => {
            const fixedFees = [];
            const disbursements = [];

            // Add fixed fees
            if (feeData.tt_fee) {
              fixedFees.push({ label: 'Telegraphic Transfer (TT) Fee', amount: feeData.tt_fee });
            }
            if (feeData.mortgage_admin_fee && feeData.mortgage_admin_fee > 0) {
              fixedFees.push({ label: 'Mortgage Admin Fee', amount: feeData.mortgage_admin_fee });
            }
            if (serviceType === 'Sale') {
              // Sale-specific fees from salePropertyDetails.info
              if (leadData.salePropertyDetails?.info?.sharedOwnership) {
                fixedFees.push({ label: 'Shared Ownership Fee', amount: 150 });
              }
              if (leadData.salePropertyDetails?.info?.auctionRepossession) {
                fixedFees.push({ label: 'Auction/Repossession Fee', amount: 150 });
              }
            } else if (serviceType === 'Purchase') {
              // Purchase-specific fees from purchasePropertyDetails.info
              if (leadData.purchasePropertyDetails?.info?.helpToBuyISA) {
                fixedFees.push({ label: 'Help to Buy ISA Fee', amount: 100 });
              }
              if (leadData.purchasePropertyDetails?.info?.helpToBuy || leadData.purchasePropertyDetails?.info?.helpToBuyEquityLoan) {
                fixedFees.push({ label: 'Help to Buy Fee', amount: 150 });
              }
            }

            // Add disbursements
            if (feeData.identity_check) {
              disbursements.push({ label: 'Identity Check', amount: feeData.identity_check });
            }
            if (feeData.hm_land_registry_fee) {
              disbursements.push({ label: 'HM Land Registry Fee', amount: feeData.hm_land_registry_fee });
            }
            if (feeData.stamp_duty && serviceType === 'Purchase') {
              disbursements.push({ label: 'Stamp Duty Land Tax', amount: feeData.stamp_duty });
            }
            if (feeData.land_registry_search) {
              disbursements.push({ label: 'Land Registry Priority Search', amount: feeData.land_registry_search });
            }
            if (feeData.land_charges_search) {
              disbursements.push({ label: 'Land Charges Search', amount: feeData.land_charges_search });
            }
            if (feeData.search_pack) {
              disbursements.push({ label: 'Search Pack - Local Authority, Water & Drainage, Environmental Search', amount: feeData.search_pack });
            }
            if (feeData.official_copies) {
              disbursements.push({ label: 'Official Copies', amount: feeData.official_copies });
            }

            return {
              base: feeData.legal_fee || 0,
              branchName: feeData.branch_name,
              branchAddress: branch.address,
              fixedFees,
              disbursements
            };
          };

          // Fetch costs for SALE part
          const salePropertyValue = leadData.salePropertyDetails?.salePrice || 0;
          const saleCosts = await fetchConveyancingCosts(branch._id, leadData.product_id, salePropertyValue, 'Sale');
          let saleFeeData = null;

          if (saleCosts) {
            console.log('💰 Got conveyancing costs for Sale part:', saleCosts);

            let saleLegalFee = saleCosts.legal_fee || 0;
            let ttFee = saleCosts.tt_fee || 30;
            let identityCheck = saleCosts.identity_check || 10;
            let officialCopies = saleCosts.official_copies || 14;
            let mortgageAdminFee = 0;

            // Check if selling with mortgage
            if (leadData.salePropertyDetails?.info?.sellingWithMortgage) {
              mortgageAdminFee = saleCosts.mortgage_admin_fee || 150;
            }

            saleFeeData = {
              legal_fee: saleLegalFee,
              branch_name: branch.name,
              branch_id: branch._id,
              tt_fee: ttFee,
              identity_check: identityCheck,
              mortgage_admin_fee: mortgageAdminFee,
              official_copies: officialCopies,
              stamp_duty: 0,
              land_registry_search: 0,
              land_charges_search: 0,
              hm_land_registry_fee: saleCosts.hm_land_registry_fee || 0,
              search_pack: saleCosts.search_pack || 0,
              property_value: salePropertyValue,
              service_type: 'Sale'
            };
          }

          // Fetch costs for PURCHASE part
          const purchaseLegalFeeResponse = await postRequest(`private/getLegalFeeByPostcode`, {
            postcode: postcode,
            purchase_price: leadData.purchasePropertyDetails?.purchasePrice || 0,
            service_type: 'Purchase'
          }, authCtx.token);

          let purchaseFeeData = null;
          if (purchaseLegalFeeResponse?.status === 200 && purchaseLegalFeeResponse?.data) {
            const legalFeeApiData = purchaseLegalFeeResponse.data;
            console.log('💰 Got legal fee for Purchase part:', legalFeeApiData);

            purchaseFeeData = {
              legal_fee: Number(legalFeeApiData.legal_fee) || 0,
              branch_name: legalFeeApiData.branch_name,
              branch_id: legalFeeApiData.branch_id,
              tt_fee: legalFeeApiData.tt_fee || 30,
              identity_check: legalFeeApiData.identity_check || 10,
              stamp_duty: legalFeeApiData.stamp_duty || 0,
              land_registry_search: legalFeeApiData.land_registry_search || 0,
              land_charges_search: legalFeeApiData.land_charges_search || 0,
              hm_land_registry_fee: legalFeeApiData.hm_land_registry_fee || 0,
              search_pack: legalFeeApiData.search_pack || 0,
              property_value: leadData.purchasePropertyDetails?.purchasePrice || 0,
              service_type: 'Purchase',
              mortgage_admin_fee: 0,
              official_copies: 0
            };
          }

          // Transform to renderQuoteTable format and attach to leadData
          if (saleFeeData && purchaseFeeData) {
            const saleQuote = transformToQuoteFormat(saleFeeData, 'Sale');
            const purchaseQuote = transformToQuoteFormat(purchaseFeeData, 'Purchase');

            // Attach quotes to leadData for modal access
            const enrichedLeadData = {
              ...leadData,
              saleQuote,
              purchaseQuote
            };

            console.log('✅ Generated quotes for Purchase_Sale:', { saleQuote, purchaseQuote });
            setSelectedQuote({ legalFeeData: purchaseFeeData, leadData: enrichedLeadData });
            setShowQuoteDetailModal(true);
            return;
          }
        }

        // Fallback if costs couldn't be fetched
        console.log('⚠️ Could not obtain costs for Purchase_Sale; falling back to existing data');
        setSelectedQuote({ legalFeeData, leadData });
        setShowQuoteDetailModal(true);
        return;
      }

      // PURCHASE flow
      const legalFeeResponse = await postRequest(`private/getLegalFeeByPostcode`, {
        postcode: postcode,
        purchase_price: leadData?.property_value || 0,
        service_type: leadData?.service_type || 'Purchase'
      }, authCtx.token);

      if (legalFeeResponse?.status === 200 && legalFeeResponse?.data) {
        const legalFeeApiData = legalFeeResponse.data;
        const purchaseFeeData = {
          legal_fee: Number(legalFeeApiData.legal_fee) || 0,
          branch_name: legalFeeApiData.branch_name,
          branch_id: legalFeeApiData.branch_id,
          tt_fee: legalFeeApiData.tt_fee || 30,
          identity_check: legalFeeApiData.identity_check || 10,
          stamp_duty: legalFeeApiData.stamp_duty || 0,
          land_registry_search: legalFeeApiData.land_registry_search || 0,
          land_charges_search: legalFeeApiData.land_charges_search || 0,
          hm_land_registry_fee: legalFeeApiData.hm_land_registry_fee || 0,
          search_pack: legalFeeApiData.search_pack || 0,
          property_value: leadData?.property_value || 0,
          service_type: leadData?.service_type || 'Purchase',
          all_fixed_fees: legalFeeApiData.all_fixed_fees || [],
          all_disbursements: legalFeeApiData.all_disbursements || []
        };

        setLegalFeeData(purchaseFeeData);
        setSelectedQuote({ legalFeeData: purchaseFeeData, leadData });
        setShowQuoteDetailModal(true);
        return;
      }

      // If we reach here, fallback to existing data
      setSelectedQuote({ legalFeeData, leadData });
      setShowQuoteDetailModal(true);
    } catch (error) {
      console.error('Error fetching quote calculation:', error);
      // Fallback to original data
      setSelectedQuote({ legalFeeData, leadData });
      setShowQuoteDetailModal(true);
    }
  };

  // Function to fetch branches and match by postcode
  const fetchBranchByPostcode = async (postcode) => {
    if (!postcode) return null;
    
    console.log('🏢 Fetching branches for postcode:', postcode);
    
    try {
      const branchesResponse = await postRequest('private/getAllBranches', {}, authCtx.token);
      
      if (branchesResponse.status === 200 && branchesResponse.data) {
        console.log('📋 All branches:', branchesResponse.data);
        
        // Match branch by postcode (exact match first, then partial)
        const exactMatch = branchesResponse.data.find(branch => 
          branch.address?.postcode?.toLowerCase() === postcode.toLowerCase()
        );
        
        if (exactMatch) {
          console.log('✅ Exact postcode match found:', exactMatch);
          return exactMatch;
        }
        
        // Partial match - first 4 characters of postcode
        const postcodePrefix = postcode.replace(/\s/g, '').substring(0, 4).toLowerCase();
        const partialMatch = branchesResponse.data.find(branch => 
          branch.address?.postcode?.replace(/\s/g, '').substring(0, 4).toLowerCase() === postcodePrefix
        );
        
        if (partialMatch) {
          console.log('✅ Partial postcode match found:', partialMatch);
          return partialMatch;
        }
        
        console.log('❌ No postcode match found, using default branch');
        return branchesResponse.data[0] || null; // Default to first branch
      }
    } catch (err) {
      console.error('Error fetching branches:', err);
    }
    
    return null;
  };

  // Function to fetch conveyancing costs for a branch
  const fetchConveyancingCosts = async (branchId, productId, overridePropertyValue = null, overrideServiceType = null) => {
    if (!branchId || !productId) return null;

    console.log('💰 Fetching conveyancing costs for branch:', branchId, 'product:', productId);

    // Get property value and service type from leadData or use overrides
    const propertyValue = overridePropertyValue !== null
      ? overridePropertyValue
      : (leadData?.service_type === 'Sale'
        ? (leadData?.salePropertyDetails?.salePrice || leadData?.property_value)
        : leadData?.property_value);
    const serviceType = overrideServiceType || leadData?.service_type || 'Purchase';

    console.log('💰 Property Value:', propertyValue, 'Service Type:', serviceType);

    try {
      const costsResponse = await postRequest('private/getConveyancingCost', {
        branch_id: branchId,
        product_id: productId,
        property_value: propertyValue,
        service_type: serviceType
      }, authCtx.token);
      
      if (costsResponse.status === 'success' && costsResponse.data) {
        console.log('✅ Conveyancing costs found:', costsResponse);
        // Return the entire response to include calculated fees (legal_fee, tt_fee, etc.)
        return costsResponse;
      } else {
        console.log('❌ No conveyancing costs found for this branch');
      }
    } catch (err) {
      console.error('Error fetching conveyancing costs:', err);
    }
    
    return null;
  };

  // Function to calculate quote based on branch costs
  const calculateBranchBasedQuote = (propertyValue, serviceType, costs, options = {}) => {
    if (!costs || !costs.transactions) {
      console.log('❌ No cost data available for calculation');
      return null;
    }
    
    console.log('🧮 Calculating quote with branch costs:', {
      propertyValue,
      serviceType,
      costs: costs.transactions,
      options
    });
    
    // Find the cost breakdown for the service type.
    // Be tolerant: transaction.transactionType can be a string or an object.
    const normalizeTransactionType = (t) => {
      if (!t) return '';
      if (typeof t === 'string') return t;
      if (typeof t === 'object') return (t.name || t.label || t.type || t.transactionType || '') + '';
      return '';
    };

    let transaction = costs.transactions.find(t => {
      const txType = (normalizeTransactionType(t.transactionType) || '').toLowerCase();
      return txType === (serviceType || '').toLowerCase() || txType.includes((serviceType || '').toLowerCase());
    });

    // Fallbacks: try matching keys, or pick first transaction if nothing matches
    if (!transaction) {
      transaction = costs.transactions.find(t => {
        const txType = (normalizeTransactionType(t.transactionType) || '').toLowerCase();
        return txType.includes('sale') && (serviceType || '').toLowerCase() === 'sale' || txType.includes('purchase') && (serviceType || '').toLowerCase() === 'purchase';
      });
    }

    if (!transaction) {
      // As a last resort, pick the first available transaction and continue
      transaction = costs.transactions[0];
      console.log('⚠️ No exact transaction match found; using first transaction as fallback:', transaction ? normalizeTransactionType(transaction.transactionType) : 'none');
    }
    
    // Calculate based on property value ranges
    let baseFee = 575; // Default
    if (transaction.propertyValues) {
      const propertyRanges = Object.keys(transaction.propertyValues).sort((a, b) => {
        const aMax = parseInt(a.split('-')[1]?.replace(/[^\d]/g, '') || '999999999');
        const bMax = parseInt(b.split('-')[1]?.replace(/[^\d]/g, '') || '999999999');
        return aMax - bMax;
      });
      
      for (const range of propertyRanges) {
        const [min, max] = range.split('-').map(val => 
          parseInt(val.replace(/[^\d]/g, '')) || 0
        );
        
        if (propertyValue >= min && (!max || propertyValue <= max)) {
          baseFee = parseFloat(transaction.propertyValues[range]) || baseFee;
          break;
        }
      }
    }
    
    // For Sale, we don't include fixed fees in additional fees as they're extracted separately
    let additionalFees = 0;
    
    // Add option-based fees for Purchase
    if (serviceType?.toLowerCase() === 'purchase') {
      // Include fixed fees for Purchase
      if (transaction.fixedFees) {
        Object.values(transaction.fixedFees).forEach(fee => {
          additionalFees += parseFloat(fee) || 0;
        });
      }
      
      if (options.leasehold) additionalFees += 150;
      if (options.mortgage_lender) additionalFees += 150;
      if (options.help_to_buy) additionalFees += 150;
      if (options.shared_ownership) additionalFees += 150;
    }
    
    // Add option-based fees for Sale
    if (serviceType?.toLowerCase() === 'sale') {
      // For Sale, fixed fees (TT, Identity) are extracted separately in handleViewQuoteDetail
      // Only add option-based fees here
      if (options.leasehold) {
        // Leasehold Fee
        additionalFees += 150;
      }
      if (options.mortgage_outstanding) {
        // Mortgage Admin Fee
        additionalFees += 150;
      }
      if (options.shared_ownership) {
        // Shared Ownership Fee
        additionalFees += 150;
      }
      if (options.auction_repossession) {
        // Auction/Repossession Fee
        additionalFees += 350;
      }
    }
    
    // Add disbursements
    let disbursements = 0;
    if (transaction.disbursements) {
      Object.values(transaction.disbursements).forEach(fee => {
        disbursements += parseFloat(fee) || 0;
      });
    }
    
    const subtotal = baseFee + additionalFees;
    const vat = Math.round(subtotal * 0.20 * 100) / 100;
    const total = Math.round((subtotal + vat + disbursements) * 100) / 100;
    
    const quote = {
      legal_fee: baseFee,
      additional_fees: additionalFees,
      disbursements,
      vat_amount: vat,
      total_quote: total,
      calculation_source: 'branch_costs'
    };
    
    console.log('✅ Calculated branch-based quote:', quote);
    return quote;
  };

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Leads', path: '/leads' },
          { label: `View Conveyancing (${leadData?.service_type === 'Purchase_Sale' ? 'Sale & Purchase' : (leadData?.service_type === 'Sale' ? 'Sale' : leadData?.service_type?.replace(/_/g, ' ') || 'Purchase')}) Lead`, path: '' },
        ]}
      />
      <br />

      <div className='page-header pb-3 mb-3'>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h1 className='mt-0 mb-0' style={{ fontSize: '1.5rem', fontWeight: '500' }}>
              Conveyancing ({leadData?.service_type === 'Purchase_Sale' ? 'Sale & Purchase' : (leadData?.service_type === 'Sale' ? 'Sale' : leadData?.service_type?.replace(/_/g, ' ') || 'Purchase')})
              <span style={{ color: '#6c757d', marginLeft: '10px' }}>#{lead_id}</span>
            </h1>
          </div>
          <div className="d-flex gap-2">
            {/* Status Badge */}
            {leadData?.status && (
              <span className="badge" style={{ 
                backgroundColor: leadData.status === 'active' ? '#28a745' : '#6c757d', 
                color: 'white', 
                padding: '6px 12px', 
                fontSize: '0.875rem' 
              }}>
                {leadData.status.charAt(0).toUpperCase() + leadData.status.slice(1)}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs defaultActiveKey="overview" id="uncontrolled-tab-example">
            {/* OVERVIEW TAB */}
            <Tab eventKey="overview" title="Overview">
              <div className='mt-3'>

                {/* ------------------------ Quote Box UI ------------------------ */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                  <div className="card-header" style={{ 
                    backgroundColor: '#f8f9fa', 
                    borderBottom: '2px solid #e9ecef',
                    padding: '1rem 1.25rem'
                  }}>
                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                      Quote Summary
                    </h5>
                  </div>
                  <div className="card-body" style={{ padding: '1.5rem' }}>
                  {(() => {
                    if (!leadData) {
                      return (
                        <div className="text-center py-3">
                          <div className="spinner-border text-primary spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 mb-0 text-muted">Loading lead data...</p>
                        </div>
                      );
                    }
                    
                    const propertyValue = leadData.property_value || 0;
                    
                    console.log('=== CONVEYANCING DISPLAY CALCULATION ===');
                    console.log('Property Value from lead:', propertyValue);
                    console.log('Branch info available:', !!branchInfo);
                    console.log('Conveyancing costs available:', !!conveyancingCosts);
                    
                    // Get service type
                    const serviceType = leadData.service_type || 'Purchase';
                    
                    let totalCost = 0;
                    let legalFee = 0;
                    let vatAmount = 0;
                    let dataSource = 'No data';

                    // IMPORTANT: Always use legalFeeData if available (to match View Quote Detail popup)
                    // This ensures Quote Summary and popup show identical values
                    if (legalFeeData) {
                      console.log('📊 Calculating totals from legalFeeData:', legalFeeData);

                      // Legal Fees
                      const legalFeeNet = Number(legalFeeData.legal_fee) || 0;
                        const legalFeeVAT = legalFeeNet * 0.20;
                        const legalFeeGross = legalFeeNet + legalFeeVAT;
                        
                        // Fixed Fees
                        const ttFeeNet = Number(legalFeeData.tt_fee) || 0;
                        const ttFeeVAT = ttFeeNet * 0.20;
                        const ttFeeGross = ttFeeNet + ttFeeVAT;
                        
                        const identityCheckNet = Number(legalFeeData.identity_check) || 0;
                        const identityCheckVAT = 0; // No VAT
                        const identityCheckGross = identityCheckNet;
                        
                        const stampDutyNet = Number(legalFeeData.stamp_duty) || 0;
                        const stampDutyVAT = 0; // No VAT
                        const stampDutyGross = stampDutyNet;
                        
                        // Disbursements
                        const hmLandRegistryFeeNet = Number(legalFeeData.hm_land_registry_fee) || 0;
                        const hmLandRegistryFeeVAT = 0; // No VAT
                        const hmLandRegistryFeeGross = hmLandRegistryFeeNet;
                        
                        const landRegistrySearchNet = Number(legalFeeData.land_registry_search) || 0;
                        const landRegistrySearchVAT = landRegistrySearchNet * 0.20;
                        const landRegistrySearchGross = landRegistrySearchNet + landRegistrySearchVAT;
                        
                        const landChargesSearchNet = Number(legalFeeData.land_charges_search) || 0;
                        const landChargesSearchVAT = landChargesSearchNet * 0.20;
                        const landChargesSearchGross = landChargesSearchNet + landChargesSearchVAT;
                        
                        const searchPackNet = Number(legalFeeData.search_pack) || 0;
                        const searchPackVAT = 0; // No VAT
                        const searchPackGross = searchPackNet;

                        // Conditional fees - check multiple possible locations for fields
                        const purchaseInfo = leadData?.purchase_details_info || leadData?.purchasePropertyDetails;
                        const saleInfo = leadData?.sale_details_info || leadData?.salePropertyDetails;
                        const infoObj = leadData?.info || {};
                        const conveyancingDetails = leadData?.conveyancing_details || leadData?.conveyancing || {};

                        // Help to Buy ISA Fee
                        const showHelpToBuyISAFee = purchaseInfo?.help_to_buy_isa || leadData?.help_to_buy_isa || infoObj?.helpToBuyISA || conveyancingDetails?.help_to_buy_isa || false;
                        const helpToBuyISAFeeNet = showHelpToBuyISAFee ? (Number(legalFeeData?.help_to_buy_isa_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'helpToBuyISAFee')?.amount || 0)) : 0;
                        const helpToBuyISAFeeVAT = helpToBuyISAFeeNet * 0.20;
                        const helpToBuyISAFeeGross = helpToBuyISAFeeNet + helpToBuyISAFeeVAT;

                        // Help to Buy Fee
                        const showHelpToBuyFee = purchaseInfo?.help_to_buy || leadData?.help_to_buy || infoObj?.helpToBuy || conveyancingDetails?.help_to_buy || false;
                        const helpToBuyFeeNet = showHelpToBuyFee ? (Number(legalFeeData?.help_to_buy_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'helpToBuyFee')?.amount || 0)) : 0;
                        const helpToBuyFeeVAT = helpToBuyFeeNet * 0.20;
                        const helpToBuyFeeGross = helpToBuyFeeNet + helpToBuyFeeVAT;

                        // Right to Buy Fee
                        const showRightToBuyFee = purchaseInfo?.right_to_buy || leadData?.right_to_buy || infoObj?.rightToBuy || conveyancingDetails?.right_to_buy || false;
                        const rightToBuyFeeNet = showRightToBuyFee ? (Number(legalFeeData?.right_to_buy_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'rightToBuyFee')?.amount || 0)) : 0;
                        const rightToBuyFeeVAT = rightToBuyFeeNet * 0.20;
                        const rightToBuyFeeGross = rightToBuyFeeNet + rightToBuyFeeVAT;

                        // Islamic Mortgage Fee
                        const showIslamicMortgageFee = purchaseInfo?.islamic_mortgage || leadData?.islamic_mortgage || infoObj?.islamicMortgage || conveyancingDetails?.islamic_mortgage || false;
                        const islamicMortgageFeeNet = showIslamicMortgageFee ? (Number(legalFeeData?.islamic_mortgage_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'islamicMortgageFee')?.amount || 0)) : 0;
                        const islamicMortgageFeeVAT = islamicMortgageFeeNet * 0.20;
                        const islamicMortgageFeeGross = islamicMortgageFeeNet + islamicMortgageFeeVAT;

                        // Gifted Deposit Fee
                        const giftedDepositCount = Number(purchaseInfo?.gifted_deposit || leadData?.gifted_deposit || infoObj?.giftedDeposit || conveyancingDetails?.gifted_deposit) || 0;
                        const showGiftedDepositFee = giftedDepositCount > 0;
                        let giftedDepositFeeNet = 0;
                        if (showGiftedDepositFee) {
                          const firstGiftorFee = Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'giftedDepositFeeFirstGiftor')?.amount || 0);
                          giftedDepositFeeNet = firstGiftorFee;
                          if (giftedDepositCount > 1) {
                            const additionalGiftorFee = Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'giftedDepositFeeAdditionalGiftors')?.amount || 0);
                            giftedDepositFeeNet += additionalGiftorFee * (giftedDepositCount - 1);
                          }
                        }
                        const giftedDepositFeeVAT = giftedDepositFeeNet * 0.20;
                        const giftedDepositFeeGross = giftedDepositFeeNet + giftedDepositFeeVAT;

                        // Buy to Let Fee
                        const showBuyToLetFee = purchaseInfo?.buy_to_let || leadData?.buy_to_let || infoObj?.buyToLet || conveyancingDetails?.buy_to_let || false;
                        const buyToLetFeeNet = showBuyToLetFee ? (Number(legalFeeData?.buy_to_let_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'buyToLetFee')?.amount || 0)) : 0;
                        const buyToLetFeeVAT = buyToLetFeeNet * 0.20;
                        const buyToLetFeeGross = buyToLetFeeNet + buyToLetFeeVAT;

                        // Shared Ownership Fee
                        const showSharedOwnershipFee = purchaseInfo?.shared_ownership || leadData?.shared_ownership || infoObj?.sharedOwnership || conveyancingDetails?.shared_ownership || false;
                        const sharedOwnershipFeeNet = showSharedOwnershipFee ? (Number(legalFeeData?.shared_ownership_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'sharedOwnershipFee')?.amount || 0)) : 0;
                        const sharedOwnershipFeeVAT = sharedOwnershipFeeNet * 0.20;
                        const sharedOwnershipFeeGross = sharedOwnershipFeeNet + sharedOwnershipFeeVAT;

                        // New Build Fee
                        const showNewBuildFee = purchaseInfo?.new_build || leadData?.new_build || infoObj?.newBuild || conveyancingDetails?.new_build || false;
                        const newBuildFeeNet = showNewBuildFee ? (Number(legalFeeData?.new_build_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'newBuildFee')?.amount || 0)) : 0;
                        const newBuildFeeVAT = newBuildFeeNet * 0.20;
                        const newBuildFeeGross = newBuildFeeNet + newBuildFeeVAT;

                        // Auction/Repossession Fee
                        const showAuctionRepossessionFee = saleInfo?.auction_repossession || purchaseInfo?.auction_repossession || leadData?.auction_repossession || infoObj?.auctionRepossession || conveyancingDetails?.auction_repossession || false;
                        const auctionRepossessionFeeNet = showAuctionRepossessionFee ? (Number(legalFeeData?.auction_repossession_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'auctionRepossessionFee')?.amount || 0)) : 0;
                        const auctionRepossessionFeeVAT = auctionRepossessionFeeNet * 0.20;
                        const auctionRepossessionFeeGross = auctionRepossessionFeeNet + auctionRepossessionFeeVAT;

                        // Mortgage Admin Fee - for both Sale (if mortgage_outstanding) and Purchase (if buying_with_mortgage)
                        const showMortgageAdminFeeForPurchase = purchaseInfo?.buying_with_mortgage || leadData?.buying_with_mortgage || infoObj?.buyingWithMortgage || conveyancingDetails?.buying_with_mortgage || !!leadData?.mortgage_lender || false;
                        const showMortgageAdminFee = (serviceType === 'Sale' && leadData?.mortgage_outstanding) || (serviceType === 'Purchase' && showMortgageAdminFeeForPurchase);
                        const mortgageAdminFeeNet = showMortgageAdminFee ? (Number(legalFeeData?.mortgage_admin_fee) || Number(legalFeeData?.all_fixed_fees?.find(fee => fee.label === 'mortgageAdminFee')?.amount || 0)) : 0;
                        const mortgageAdminFeeVAT = mortgageAdminFeeNet * 0.20;
                        const mortgageAdminFeeGross = mortgageAdminFeeNet + mortgageAdminFeeVAT;

                        // Official Copies (Sale only)
                        const officialCopiesNet = legalFeeData?.official_copies || (serviceType === 'Sale' ? 14 : 0);
                        const officialCopiesVAT = 0; // No VAT
                        const officialCopiesGross = officialCopiesNet;

                        // Leasehold Fee (for Sale)
                        const leaseholdFeeNet = Number(legalFeeData?.leasehold_fee || 0);
                        const leaseholdFeeVAT = leaseholdFeeNet * 0.20;
                        const leaseholdFeeGross = leaseholdFeeNet + leaseholdFeeVAT;

                        // Calculate totals based on service type (matching ViewQuoteDetailModal logic)
                        let totalNet, totalVAT, totalGross;

                        if (serviceType === 'Sale') {
                          // Sale total calculation - include all Sale-specific fees
                          totalNet = legalFeeNet + leaseholdFeeNet + ttFeeNet + identityCheckNet + mortgageAdminFeeNet + sharedOwnershipFeeNet + auctionRepossessionFeeNet + officialCopiesNet;
                          totalVAT = legalFeeVAT + leaseholdFeeVAT + ttFeeVAT + identityCheckVAT + mortgageAdminFeeVAT + sharedOwnershipFeeVAT + auctionRepossessionFeeVAT + officialCopiesVAT;
                          totalGross = legalFeeGross + leaseholdFeeGross + ttFeeGross + identityCheckGross + mortgageAdminFeeGross + sharedOwnershipFeeGross + auctionRepossessionFeeGross + officialCopiesGross;
                        } else {
                          // Purchase total calculation - including all conditional fees
                          totalNet = legalFeeNet + ttFeeNet + identityCheckNet + mortgageAdminFeeNet +
                                    helpToBuyISAFeeNet + helpToBuyFeeNet + rightToBuyFeeNet + islamicMortgageFeeNet +
                                    giftedDepositFeeNet + buyToLetFeeNet + sharedOwnershipFeeNet + newBuildFeeNet +
                                    auctionRepossessionFeeNet + stampDutyNet + hmLandRegistryFeeNet +
                                    landRegistrySearchNet + landChargesSearchNet + searchPackNet;

                          totalVAT = legalFeeVAT + ttFeeVAT + identityCheckVAT + mortgageAdminFeeVAT +
                                    helpToBuyISAFeeVAT + helpToBuyFeeVAT + rightToBuyFeeVAT + islamicMortgageFeeVAT +
                                    giftedDepositFeeVAT + buyToLetFeeVAT + sharedOwnershipFeeVAT + newBuildFeeVAT +
                                    auctionRepossessionFeeVAT + stampDutyVAT + hmLandRegistryFeeVAT +
                                    landRegistrySearchVAT + landChargesSearchVAT + searchPackVAT;

                          totalGross = legalFeeGross + ttFeeGross + identityCheckGross + mortgageAdminFeeGross +
                                      helpToBuyISAFeeGross + helpToBuyFeeGross + rightToBuyFeeGross + islamicMortgageFeeGross +
                                      giftedDepositFeeGross + buyToLetFeeGross + sharedOwnershipFeeGross + newBuildFeeGross +
                                      auctionRepossessionFeeGross + stampDutyGross + hmLandRegistryFeeGross +
                                      landRegistrySearchGross + landChargesSearchGross + searchPackGross;
                        }
                        
                        totalCost = totalGross;
                        vatAmount = totalVAT;
                        legalFee = totalNet;
                        dataSource = 'Legal Fee API Data';
                        
                        console.log('✅ Calculated totals from legalFeeData:', {
                          totalNet, totalVAT, totalGross
                        });
                    } else if (leadData?.legal_fee || leadData?.total_quote) {
                      // Use lead data if available
                      totalCost = leadData.total_quote || 0;
                      legalFee = leadData.legal_fee || 0;
                      vatAmount = leadData.vat_amount || 0;
                      dataSource = 'Lead Data';

                      console.log('⚠️ Using lead data:', {
                        totalCost, legalFee, vatAmount
                      });
                    } else {
                      // Default values
                      totalCost = 0;
                      legalFee = 0;
                      vatAmount = 0;
                      dataSource = 'No Data';
                    }
                    
                    console.log('Final conveyancing display values:', {
                      totalCost, legalFee, vatAmount, serviceType, dataSource
                    });
                    
                    // Determine service type badge color
                    const getServiceTypeColor = (serviceType) => {
                      switch(serviceType) {
                        case 'Purchase': return 'success';
                        case 'Sale': return 'warning';
                        case 'Purchase_Sale': return 'primary';
                        case 'Remortgage': return 'info';
                        case 'Transfer_of_Equity': return 'secondary';
                        default: return 'secondary';
                      }
                    };
                    
                    return (
                      <>
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-baseline gap-3">
                            <span className="text-muted small">Total Cost</span>
                            {(() => {
                              console.log('💰 QUOTE SUMMARY - quoteFeeData:', quoteFeeData);
                              console.log('💰 QUOTE SUMMARY - quoteFeeData.totals:', quoteFeeData?.totals);
                              console.log('💰 QUOTE SUMMARY - quoteFeeData.totals.total:', quoteFeeData?.totals?.total);
                              return null;
                            })()}
                            {quoteFeeData?.totals?.total ? (
                              // Use totals from database (matches View Quote Detail modal exactly)
                              <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                                £{Number(quoteFeeData.totals.total.net || 0).toFixed(2)} Net + £{Number(quoteFeeData.totals.total.vat || 0).toFixed(2)} VAT = £{Number(quoteFeeData.totals.total.gross || 0).toFixed(2)} Gross
                              </span>
                            ) : (
                              // Fallback calculation
                              <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                                £{(totalCost - vatAmount).toFixed(2)} Net + £{vatAmount.toFixed(2)} VAT = £{totalCost.toFixed(2)} Gross
                              </span>
                            )}
                          </div>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                                console.log('🚀 Opening View Quote Detail Modal with legalFeeData:', legalFeeData);

                                // If legalFeeData is not loaded yet, fetch it first
                                if (!legalFeeData && leadData?.property_address && leadData?.property_value) {
                                  console.log('🔄 legalFeeData not loaded, fetching now...');

                                  // Extract postcode
                                  let postcode = null;
                                  const addressObj = leadData.property_address || leadData.property;

                                  if (typeof addressObj === 'string') {
                                    const addressParts = addressObj.split(',').map(p => p.trim());
                                    postcode = addressParts[addressParts.length - 1];
                                  } else if (addressObj) {
                                    postcode = addressObj.postcode || addressObj.postal_code || addressObj.post_code;
                                  }

                                  if (postcode) {
                                    try {
                                      const propertyValue = leadData.service_type === 'Sale'
                                        ? (leadData.salePropertyDetails?.salePrice || leadData.property_value)
                                        : leadData.property_value;

                                      // Check if partner is selected
                                      const partnerId = leadData.partner_id
                                        ? (typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id)
                                        : null;

                                      console.log('🤝 Partner ID for View Quote Detail:', partnerId);

                                      const payload = {
                                        postcode: postcode,
                                        purchase_price: propertyValue,
                                        service_type: leadData.service_type || 'Purchase'
                                      };

                                      // Add partner_id if exists (to fetch partner rate card)
                                      if (partnerId) {
                                        payload.partner_id = partnerId;
                                        console.log('✅ Fetching Partner Rate Card for modal');
                                      } else {
                                        console.log('📋 Fetching Branch Rate Card for modal');
                                      }

                                      const response = await postRequest(`private/getLegalFeeByPostcode`, payload, authCtx.token);

                                      console.log('🔍 Raw API Response:', response);
                                      console.log('🔍 Response status:', response?.status);
                                      console.log('🔍 Response data:', response?.data);

                                      if (response?.status === 200 && response?.data) {
                                        console.log('🔍 Full API Response:', response);
                                        const apiData = response.data;
                                        console.log('📦 API Data extracted:', apiData);
                                        console.log('💵 Legal fee from API:', apiData.legal_fee);
                                        const feeData = {
                                          legal_fee: apiData.legal_fee || apiData.legal_fees,
                                          legal_fees: apiData.legal_fees || apiData.legal_fee,  // Support both variations
                                          branch_name: apiData.branch_name,
                                          branch_id: apiData.branch_id,
                                          tt_fee: apiData.tt_fee,
                                          tt_fee_label: apiData.tt_fee_label,
                                          identity_check: apiData.identity_check,
                                          identity_check_label: apiData.identity_check_label,
                                          land_registry_search: apiData.land_registry_search,
                                          land_registry_search_label: apiData.land_registry_search_label,
                                          land_charges_search: apiData.land_charges_search,
                                          land_charges_search_label: apiData.land_charges_search_label,
                                          stamp_duty: apiData.stamp_duty,
                                          stamp_duty_label: apiData.stamp_duty_label,
                                          hm_land_registry_fee: apiData.hm_land_registry_fee,
                                          hm_land_registry_fee_label: apiData.hm_land_registry_fee_label,
                                          search_pack: apiData.search_pack,
                                          search_pack_label: apiData.search_pack_label,
                                          all_fixed_fees: apiData.all_fixed_fees,
                                          all_disbursements: apiData.all_disbursements,
                                          // Sale-specific fields
                                          official_copies: apiData.official_copies,
                                          mortgage_admin_fee: apiData.mortgage_admin_fee,
                                          auction_repossession_fee: apiData.auction_repossession_fee
                                        };
                                        console.log('💾 Setting legalFeeData from button click:', feeData);
                                        setLegalFeeData(feeData);
                                        console.log('✅ Legal fee data loaded successfully');

                                        // Open modal after data is loaded
                                        setTimeout(() => {
                                          console.log('🎯 Opening modal with fresh data');
                                          setShowQuoteDetailModal(true);
                                        }, 100);
                                        return; // Exit early since we're opening modal after fetch
                                      } else {
                                        console.log('⚠️ Legal fee API response not in expected format');
                                        console.log('Expected: { status: 200, data: {...} }');
                                        console.log('Got:', response);
                                      }
                                    } catch (error) {
                                      console.error('❌ Error fetching legal fee:', error);
                                    }
                                  }
                                }

                                // If data already exists, use handleViewQuoteDetail
                                console.log('🎯 Final check before opening modal - legalFeeData:', legalFeeData);
                                handleViewQuoteDetail(null);
                              }}
                              style={{
                                color: '#0d6efd',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                fontSize: '14px'
                              }}
                              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                            >
                              View Quote Detail
                            </a>
                        </div>

                        <hr style={{ margin: '1rem 0', borderTop: '1px solid #e9ecef', opacity: '1' }} />

                        {/* Branch and Date Info */}
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <span className="badge bg-secondary me-2">
                              {branchInfo?.name || leadData?.branch_name || 'Branch'}
                            </span>
                            <span className="badge bg-primary">
                              {localStorage.getItem('username') || leadData?.created_by || 'User'}
                            </span>
                          </div>
                          <div className="text-muted small">
                            {(() => {
                              const date = leadData?.quote_date || leadData?.createdAt || leadData?.created_at;
                              if (!date) return 'Date not available';
                              const dateObj = new Date(date);
                              return `${dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${dateObj.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
                            })()}
                          </div>
                        </div>
                      </>
                    );
                  })()}

                  </div>
                  
                  {/* Action Buttons */}
                  <div className="card-footer bg-light" style={{ borderTop: '1px solid #e9ecef', padding: '1rem 1.25rem' }}>
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                      {canReviseQuotes && leadData?.status !== 'Instructed' && (
                        <Button
                          variant="contained"
                          className='text-capitalize'
                          onClick={() => setReviseModalShow(true)}
                          disabled={revisionCount >= 2}
                          style={{
                            backgroundColor: revisionCount >= 2 ? '#6c757d' : '#dc3545',
                            borderColor: revisionCount >= 2 ? '#6c757d' : '#dc3545',
                            fontSize: '0.875rem',
                            padding: '8px 16px'
                          }}
                        >
                          <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                          {revisionCount >= 2 ? 'Revision Limit Reached' : 'Revise Quote'}
                        </Button>
                      )}
                      {leadData?.status !== 'Instructed' && (
                        <Button
                          variant="outlined"
                          className='text-capitalize'
                          onClick={handleRegenerateQuote}
                          style={{
                            color: '#6c757d',
                            borderColor: '#6c757d',
                            fontSize: '0.875rem',
                            padding: '8px 16px'
                          }}
                        >
                          <RefreshIcon fontSize="small" style={{ marginRight: '6px' }} />
                          Regenerate Quote
                        </Button>
                      )}
                      {revisionCount > 0 && (
                        <Button 
                          variant="text" 
                          className='text-capitalize'
                          onClick={() => console.log("View Quote History")}
                          style={{ 
                            color: '#6c757d',
                            fontSize: '0.875rem',
                            padding: '8px 16px'
                          }}
                        >
                          <i className="fas fa-history me-1"></i>
                          View History ({revisionCount})
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Sale & Purchase Details Sections */}
                {leadData?.service_type === 'Purchase_Sale' && (
                  <div className="card mb-3" style={{ border: '1px solid #dee2e6', borderRadius: '0.25rem' }}>
                    <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6', padding: '0.75rem 1rem' }}>
                      <h5 className="mb-0" style={{ fontSize: '1.125rem', fontWeight: '500' }}>🏠 Sale Details</h5>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Vendors</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {(() => {
                                if (isLoadingVendors) {
                                  return <div className="text-muted"><small>Loading vendor details...</small></div>;
                                }
                                if (populatedVendors.length === 0) {
                                  return 'No vendors specified';
                                }
                                return populatedVendors.map((customer, index) => (
                                  <div key={customer._id || index} className="mb-1">
                                    <strong>{customer.title || ''} {customer.forename || ''} {customer.surname || ''}</strong>
                                    <br />
                                    <small className="text-muted">
                                      📧 {customer.email || 'N/A'} | 📞 {customer.phone_number || 'N/A'}
                                    </small>
                                  </div>
                                ));
                              })()}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Sale Address</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {(() => {
                                const address = leadData?.salePropertyDetails?.address;
                                if (!address) return 'No address specified';
                                if (typeof address === 'string') return address;
                                const parts = [];
                                if (address.address1) parts.push(address.address1);
                                if (address.address2) parts.push(address.address2);
                                if (address.town) parts.push(address.town);
                                if (address.country) parts.push(address.country);
                                if (address.postcode) parts.push(address.postcode);
                                return parts.length > 0 ? parts.join(', ') : 'No address specified';
                              })()}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Sale Price</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              £{(leadData?.salePropertyDetails?.salePrice || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Ownership Type</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {(() => {
                                const ownershipType = leadData?.salePropertyDetails?.ownershipType || 'freehold';
                                const isLeasehold = ownershipType.toLowerCase() === 'leasehold';
                                return (
                                  <span className={`badge ${isLeasehold ? 'bg-warning' : 'bg-success'}`}>
                                    {ownershipType.charAt(0).toUpperCase() + ownershipType.slice(1)}
                                  </span>
                                );
                              })()}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Group Code</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {(() => {
                                const groupCode = leadData?.group_code;
                                if (!groupCode) return <span className="text-muted">Not assigned</span>;
                                if (typeof groupCode === 'object') {
                                  return groupCode.name || groupCode.code || 'Unknown';
                                }
                                return groupCode;
                              })()}
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Acquisition</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {leadData?.acquisition || <span className="text-muted">Not specified</span>}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Sale Info</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              <div className="d-flex flex-wrap gap-1">
                                {(() => {
                                  const info = [];
                                  const saleInfo = leadData?.info || leadData?.salePropertyDetails?.info || leadData?.saleInfo || {};

                                  // Sale-specific info fields (5 fields)
                                  if (saleInfo.sellingWithMortgage === true || leadData?.selling_with_mortgage === true) info.push('Selling with Mortgage');
                                  if (saleInfo.arrangingIndemnityPolicy === true || leadData?.arranging_indemnity_policy === true) info.push('Arranging Indemnity Policy');
                                  if (saleInfo.unregisteredProperty === true || leadData?.unregistered_property === true) info.push('Unregistered Property');
                                  if (saleInfo.sharedOwnership === true || leadData?.shared_ownership === true) info.push('Shared Ownership');
                                  if (saleInfo.auctionRepossession === true || leadData?.auction_repossession === true) info.push('Auction / Repossession');

                                  if (info.length === 0) return <span className="text-muted">No additional sale info</span>;

                                  return info.map((item, index) => (
                                    <span key={index} className="badge bg-primary me-1">{item}</span>
                                  ));
                                })()}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Purchase Details Section */}
                <div className="card" style={{ border: leadData?.service_type === 'Purchase_Sale' ? '2px solid #007bff' : '1px solid #dee2e6', borderRadius: '0.25rem' }}>
                  <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6', padding: '0.75rem 1rem' }}>
                    <h5 className="mb-0" style={{ fontSize: '1.125rem', fontWeight: '500' }}>
                      {leadData?.service_type === 'Purchase_Sale' ? '🏢 Purchase Details' : (leadData?.service_type === 'Sale' ? 'Sale Details' : (leadData?.service_type === 'Review_Legal_Pack' ? 'Review of Legal Pack Details' : (leadData?.service_type === 'First_Registration' ? 'First Registration Details' : 'Purchase Details')))}
                    </h5>
                  </div>
                  <div className="card-body p-0">
                    <table className="table table-borderless mb-0">
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Address</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              console.log('🏠 === ADDRESS DISPLAY DEBUG ===');
                              console.log('window.purchaseDetailsData:', window.purchaseDetailsData);
                              console.log('leadData:', leadData);
                              console.log('leadData.property_address:', leadData?.property_address);
                              console.log('leadData.address:', leadData?.address);

                              // For Purchase_Sale type, use purchasePropertyDetails
                              if (leadData?.service_type === 'Purchase_Sale') {
                                const address = leadData?.purchasePropertyDetails?.address;
                                if (!address) return 'No address specified';
                                if (typeof address === 'string') return address;

                                const parts = [];
                                if (address.address1) parts.push(address.address1);
                                if (address.address2) parts.push(address.address2);
                                if (address.town) parts.push(address.town);
                                if (address.country) parts.push(address.country);
                                if (address.postcode) parts.push(address.postcode);
                                return parts.length > 0 ? parts.join(', ') : 'No address specified';
                              }

                              // First check if we have data from Purchase Details API
                              if (window.purchaseDetailsData && window.purchaseDetailsData.address) {
                                console.log('Using window.purchaseDetailsData.address:', window.purchaseDetailsData.address);
                                return window.purchaseDetailsData.address;
                              }

                              // Fallback to existing logic
                              const address = leadData?.property_address || leadData?.address || leadData?.property || leadData?.conveyancingDetails?.propertyDetails?.address;
                              console.log('Address object found:', address);
                              
                              if (!address) {
                                console.log('No address object found!');
                                return 'No address specified';
                              }
                              
                              if (typeof address === 'string') {
                                console.log('Address is string:', address);
                                return address;
                              } else {
                                console.log('Address is object, building from fields:', address);
                                const parts = [];
                                // Check for address1/address2 format (what we save)
                                if (address.address1) parts.push(address.address1);
                                if (address.address2) parts.push(address.address2);
                                if (address.town) parts.push(address.town);
                                if (address.country) parts.push(address.country);
                                if (address.postcode) parts.push(address.postcode);
                                
                                // If no parts yet, check alternate field names
                                if (parts.length === 0) {
                                  console.log('No address1/address2 format found, checking alternate fields');
                                  if (address.house_flat_number) parts.push(address.house_flat_number);
                                  if (address.line1) parts.push(address.line1);
                                  if (address.street_name) parts.push(address.street_name);
                                  if (address.line2) parts.push(address.line2);
                                  if (address.town || address.city || address.town_city) parts.push(address.town || address.city || address.town_city);
                                  if (address.county || address.state) parts.push(address.county || address.state);
                                  if (address.postcode || address.postal_code || address.post_code) parts.push(address.postcode || address.postal_code || address.post_code);
                                }
                                
                                console.log('Address parts:', parts);
                                return parts.length > 0 ? parts.join(', ') : 'No address specified';
                              }
                            })()}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>{leadData?.service_type === 'Sale' ? 'Vendors' : 'Purchasers'}</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              // Check if this is a Sale - if so, show vendors
                              if (leadData?.service_type === 'Sale') {
                                console.log('📺 DISPLAY - isLoadingVendors:', isLoadingVendors);
                                console.log('📺 DISPLAY - populatedVendors:', populatedVendors);
                                console.log('📺 DISPLAY - populatedVendors.length:', populatedVendors.length);
                                console.log('📺 DISPLAY - leadData.vendors:', leadData?.vendors);
                                console.log('📺 DISPLAY - leadData.customers:', leadData?.customers);

                                // Check if vendors exist but not populated yet
                                const hasVendorIds = leadData?.vendors && Array.isArray(leadData.vendors) && leadData.vendors.length > 0;
                                const firstVendorIsId = hasVendorIds && typeof leadData.vendors[0] === 'string';

                                console.log('📺 DISPLAY - hasVendorIds:', hasVendorIds);
                                console.log('📺 DISPLAY - firstVendorIsId:', firstVendorIsId);

                                // If we have vendor IDs but they're not populated yet, show loading
                                if (firstVendorIsId && populatedVendors.length === 0) {
                                  console.log('⏳ DISPLAY - Vendors are IDs, waiting for population');
                                  return (
                                    <div className="text-muted">
                                      <small>Loading vendor details...</small>
                                    </div>
                                  );
                                }

                                // If still loading, show loading message
                                if (isLoadingVendors) {
                                  console.log('⏳ DISPLAY - Still loading vendors');
                                  return (
                                    <div className="text-muted">
                                      <small>Loading vendor details...</small>
                                    </div>
                                  );
                                }

                                // If loaded but no vendors, check if customers exist (fallback for old data)
                                if (populatedVendors.length === 0) {
                                  console.log('⚠️ DISPLAY - No vendors found, checking customers as fallback');

                                  // Fallback: Use customers if vendors are empty (for backward compatibility)
                                  const customersData = leadData?.customers;
                                  if (customersData && Array.isArray(customersData) && customersData.length > 0) {
                                    console.log('✅ DISPLAY - Using customers as vendors (fallback)');
                                    return customersData.map((customer, index) => (
                                      <div key={customer._id || index} className="mb-1">
                                        <strong>{customer.title || ''} {customer.forename || ''} {customer.surname || ''}</strong>
                                        <br />
                                        <small className="text-muted">
                                          📧 {customer.email || 'N/A'} | 📞 {customer.phone_number || 'N/A'}
                                        </small>
                                      </div>
                                    ));
                                  }

                                  return 'No vendors specified';
                                }

                                // Display populated vendors
                                console.log('✅ DISPLAY - Showing populated vendor data');
                                return populatedVendors.map((customer, index) => (
                                  <div key={customer._id || index} className="mb-1">
                                    <strong>{customer.title || ''} {customer.forename || ''} {customer.surname || ''}</strong>
                                    <br />
                                    <small className="text-muted">
                                      📧 {customer.email || 'N/A'} | 📞 {customer.phone_number || 'N/A'}
                                    </small>
                                  </div>
                                ));
                              }

                              // For Purchase - show purchasers
                              console.log('📺 DISPLAY - isLoadingPurchasers:', isLoadingPurchasers);
                              console.log('📺 DISPLAY - populatedPurchasers:', populatedPurchasers);
                              console.log('📺 DISPLAY - populatedPurchasers.length:', populatedPurchasers.length);
                              console.log('📺 DISPLAY - leadData.purchasers:', leadData?.purchasers);

                              // First check if we have data from Purchase Details API
                              if (window.purchaseDetailsData && window.purchaseDetailsData.purchasers) {
                                const purchasers = window.purchaseDetailsData.purchasers;
                                if (Array.isArray(purchasers) && purchasers.length > 0) {
                                  return purchasers.map((customer, index) => (
                                    <div key={customer._id || index} className="mb-1">
                                      <strong>{customer.title} {customer.forename} {customer.surname}</strong>
                                      <br />
                                      <small className="text-muted">
                                        📧 {customer.email} | 📞 {customer.phone_number}
                                      </small>
                                    </div>
                                  ));
                                }
                              }

                              // Check if purchasers exist but not populated yet
                              console.log('🔍 ====== PURCHASERS DISPLAY LOGIC ======');
                              console.log('📊 leadData:', leadData);
                              console.log('📊 leadData.purchasers:', leadData?.purchasers);
                              console.log('📊 populatedPurchasers:', populatedPurchasers);
                              console.log('📊 isLoadingPurchasers:', isLoadingPurchasers);

                              const hasPurchaserIds = leadData?.purchasers && Array.isArray(leadData.purchasers) && leadData.purchasers.length > 0;
                              const firstPurchaserIsId = hasPurchaserIds && typeof leadData.purchasers[0] === 'string';

                              console.log('📺 DISPLAY - hasPurchaserIds:', hasPurchaserIds);
                              console.log('📺 DISPLAY - leadData.purchasers type:', typeof leadData?.purchasers);
                              console.log('📺 DISPLAY - leadData.purchasers length:', leadData?.purchasers?.length);
                              console.log('📺 DISPLAY - firstPurchaserIsId:', firstPurchaserIsId);
                              console.log('📺 DISPLAY - First purchaser:', leadData?.purchasers?.[0]);

                              // If we have purchaser IDs but they're not populated yet, show loading
                              if (firstPurchaserIsId && populatedPurchasers.length === 0) {
                                console.log('⏳ DISPLAY - Purchasers are IDs, waiting for population');
                                return (
                                  <div className="text-muted">
                                    <small>Loading purchaser details...</small>
                                  </div>
                                );
                              }

                              // If still loading, show loading message
                              if (isLoadingPurchasers) {
                                console.log('⏳ DISPLAY - Still loading purchasers');
                                return (
                                  <div className="text-muted">
                                    <small>Loading purchaser details...</small>
                                  </div>
                                );
                              }

                              // If loaded but no purchasers
                              if (populatedPurchasers.length === 0) {
                                // Check for fallback customer data
                                if (leadData?.customer_name) {
                                  return leadData.customer_name;
                                } else if (leadData?.customer_names) {
                                  return leadData.customer_names;
                                } else {
                                  return 'No purchasers specified';
                                }
                              }

                              // Display populated purchasers
                              console.log('✅ DISPLAY - Showing populated purchaser data');
                              return populatedPurchasers.map((customer, index) => (
                                <div key={customer._id || index} className="mb-1">
                                  <strong>{customer.title || ''} {customer.forename || ''} {customer.surname || ''}</strong>
                                  <br />
                                  <small className="text-muted">
                                    📧 {customer.email || 'N/A'} | 📞 {customer.phone_number || 'N/A'}
                                  </small>
                                </div>
                              ));
                            })()}
                          </td>
                        </tr>
                        {leadData?.service_type !== 'Review_Legal_Pack' && leadData?.service_type !== 'First_Registration' && (
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>{leadData?.service_type === 'Sale' ? 'Sale Price' : 'Purchase Price'}</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              £{(() => {
                                // For Purchase_Sale type, use purchasePropertyDetails
                                if (leadData?.service_type === 'Purchase_Sale') {
                                  return (leadData?.purchasePropertyDetails?.purchasePrice || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                }

                                // First check if we have data from Purchase Details API
                                if (window.purchaseDetailsData && window.purchaseDetailsData.purchasePrice !== undefined) {
                                  return window.purchaseDetailsData.purchasePrice.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                }
                                // Fallback to existing logic
                                return (leadData?.property_value || leadData?.net_value || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                              })()}
                            </td>
                          </tr>
                        )}
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Ownership Type</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              // For Purchase_Sale type, use purchasePropertyDetails
                              if (leadData?.service_type === 'Purchase_Sale') {
                                const ownershipType = leadData?.purchasePropertyDetails?.ownershipType || 'freehold';
                                const isLeasehold = ownershipType.toLowerCase() === 'leasehold';
                                return (
                                  <span className={`badge ${isLeasehold ? 'bg-warning' : 'bg-success'}`}>
                                    {ownershipType.charAt(0).toUpperCase() + ownershipType.slice(1)}
                                  </span>
                                );
                              }

                              // First check if we have data from Purchase Details API
                              if (window.purchaseDetailsData && window.purchaseDetailsData.ownershipType) {
                                const ownershipType = window.purchaseDetailsData.ownershipType;
                                const isLeasehold = ownershipType.toLowerCase() === 'leasehold';
                                return (
                                  <span className={`badge ${isLeasehold ? 'bg-warning' : 'bg-success'}`}>
                                    {ownershipType}
                                  </span>
                                );
                              }
                              // Fallback to existing logic
                              return (
                                <span className={`badge ${leadData?.leasehold ? 'bg-warning' : 'bg-success'}`}>
                                  {leadData?.ownership_type || (leadData?.leasehold ? 'Leasehold' : 'Freehold')}
                                </span>
                              );
                            })()}
                          </td>
                        </tr>
                        {leadData?.service_type !== 'Sale' && leadData?.service_type !== 'Review_Legal_Pack' && leadData?.service_type !== 'First_Registration' && (
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Est. Completion Date</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              {(() => {
                                // For Purchase_Sale type, use purchasePropertyDetails
                                if (leadData?.service_type === 'Purchase_Sale') {
                                  return leadData?.purchasePropertyDetails?.completionDate
                                    ? new Date(leadData.purchasePropertyDetails.completionDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                      })
                                    : 'Not specified';
                                }

                                // First check if we have data from Purchase Details API
                                if (window.purchaseDetailsData && window.purchaseDetailsData.completionDate) {
                                  return new Date(window.purchaseDetailsData.completionDate).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                  });
                                }
                                // Fallback to existing logic
                                return leadData?.completion_date
                                  ? new Date(leadData.completion_date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                  : 'Not specified';
                              })()}
                            </td>
                          </tr>
                        )}

                        {/* Lender Panel */}
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Lender Panel</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              console.log('🔍 Lender Panel check:', {
                                lender_panel_id: leadData?.lender_panel_id,
                                lender_panel_name: leadData?.lender_panel_name,
                                type: typeof leadData?.lender_panel_id
                              });

                              // Check for lender_panel_name field first (from backend aggregation)
                              if (leadData?.lender_panel_name) {
                                return (
                                  <div>
                                    <div style={{ color: '#495057' }}>
                                      {leadData.lender_panel_name}
                                    </div>
                                    {leadData?.lender_panel_id?.lender_numbers && leadData.lender_panel_id.lender_numbers.length > 0 && (
                                      <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                        {leadData.lender_panel_id.lender_numbers.join(', ')}
                                      </div>
                                    )}
                                  </div>
                                );
                              }

                              const lenderPanel = leadData?.lender_panel_id;

                              // If lender panel is populated object
                              if (lenderPanel && typeof lenderPanel === 'object' && lenderPanel.name) {
                                return (
                                  <div>
                                    <div style={{ color: '#495057' }}>
                                      {lenderPanel.name}
                                    </div>
                                    {lenderPanel?.lender_numbers && lenderPanel.lender_numbers.length > 0 && (
                                      <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                        {lenderPanel.lender_numbers.join(', ')}
                                      </div>
                                    )}
                                  </div>
                                );
                              }

                              // If no lender panel selected
                              return <span className="text-muted">Not specified</span>;
                            })()}
                          </td>
                        </tr>

                        {/* Partner */}
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Partner</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              console.log('🔍 Partner display check:', {
                                partner_id: leadData?.partner_id,
                                partner_name: leadData?.partner_name,
                                type: typeof leadData?.partner_id
                              });

                              // Check for partner_name field first (from backend aggregation)
                              if (leadData?.partner_name) {
                                return leadData.partner_name;
                              }

                              // If partner_id is populated object with name
                              if (leadData?.partner_id && typeof leadData.partner_id === 'object' && leadData.partner_id.name) {
                                return leadData.partner_id.name;
                              }

                              // Try to find from partners array as fallback
                              if (leadData?.partner_id) {
                                const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                                const partner = partners.find(p => p._id === partnerId);
                                if (partner) {
                                  return partner.name;
                                }
                              }

                              return <span className="text-muted">Not assigned</span>;
                            })()}
                          </td>
                        </tr>

                        {/* Sale-specific fields - removed Estate Agent, Mortgage Outstanding, Chain Status, Onward Purchase */}

                        {leadData?.service_type !== 'First_Registration' && (
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Purchase Info</td>
                            <td style={{ padding: '0.75rem 1rem' }}>
                              <div className="d-flex flex-wrap gap-1">
                                {(() => {
                                  // For Purchase_Sale type, check top-level info first (new structure), then nested (backward compatibility)
                                  const info = [];
                                  const purchaseInfo = leadData?.info || leadData?.purchasePropertyDetails?.info || leadData?.purchaseInfo || {};
                                  const conv = leadData?.conveyancing_details || {};
                                  const infoObj = leadData?.info || {};

                                  // Purchase-specific info fields (All 18 fields)
                                  if (purchaseInfo.firstTimeBuyer === true || leadData?.first_time_buyer === true || conv.first_time_buyer === true || infoObj.firstTimeBuyer === true) info.push('First Time Buyer');
                                  if (purchaseInfo.helpToBuyISA === true || leadData?.help_to_buy_isa === true || conv.help_to_buy_isa === true || infoObj.helpToBuyISA === true) info.push('Help to Buy ISA');
                                  if (purchaseInfo.helpToBuy === true || leadData?.help_to_buy === true || conv.help_to_buy === true || infoObj.helpToBuy === true) info.push('Help to Buy');
                                  if (purchaseInfo.helpToBuyEquityLoan === true || leadData?.help_to_buy_equity_loan === true || conv.help_to_buy_equity_loan === true || infoObj.helpToBuyEquityLoan === true) info.push('Help to Buy Equity Loan');
                                  if (purchaseInfo.rightToBuy === true || leadData?.right_to_buy === true || conv.right_to_buy === true || infoObj.rightToBuy === true) info.push('Right to Buy');
                                  if (purchaseInfo.sharedOwnership === true || leadData?.shared_ownership === true || conv.shared_ownership === true || infoObj.sharedOwnership === true) info.push('Shared Ownership');
                                  if (purchaseInfo.buyingWithMortgage === true || leadData?.buying_with_mortgage === true || conv.buying_with_mortgage === true || infoObj.buyingWithMortgage === true || leadData?.mortgage_lender) info.push('Buying with Mortgage');
                                  if (purchaseInfo.newBuild === true || leadData?.new_build === true || conv.new_build === true || infoObj.newBuild === true) info.push('New Build');
                                  if (purchaseInfo.islamicMortgage === true || leadData?.islamic_mortgage === true || conv.islamic_mortgage === true || infoObj.islamicMortgage === true) info.push('Islamic Mortgage');
                                  if (purchaseInfo.auctionRepossession === true || leadData?.auction_repossession === true || conv.auction_repossession === true || infoObj.auctionRepossession === true) info.push('Auction / Repossession');
                                  if (purchaseInfo.giftedDeposit || leadData?.gifted_deposit || conv.gifted_deposit || infoObj.giftedDeposit) {
                                    const numGiftors = purchaseInfo.giftedDeposit || leadData?.gifted_deposit || conv.gifted_deposit || infoObj.giftedDeposit;
                                    info.push(`Gifted Deposit - ${numGiftors} Giftors`);
                                  }
                                  if (purchaseInfo.multipleProperties === true || leadData?.multiple_properties === true || conv.multiple_properties === true || infoObj.multipleProperties === true) info.push('Multiple Properties');
                                  if (purchaseInfo.buyToLet === true || leadData?.buy_to_let === true || conv.buy_to_let === true || infoObj.buyToLet === true) info.push('Buy to Let');
                                  if (purchaseInfo.arrangingIndemnityPolicy === true || leadData?.arranging_indemnity_policy === true || conv.arranging_indemnity_policy === true || infoObj.arrangingIndemnityPolicy === true) info.push('Arranging Indemnity Policy');
                                  if (purchaseInfo.unregisteredProperty === true || leadData?.unregistered_property === true || conv.unregistered_property === true || infoObj.unregisteredProperty === true) info.push('Unregistered Property');
                                  if (purchaseInfo.staircasing === true || leadData?.staircasing === true || conv.staircasing === true || infoObj.staircasing === true) info.push('Staircasing');

                                  // Non-UK Resident field (dropdown)
                                  const isNonUK = purchaseInfo.isNonUKResident || leadData?.is_non_uk_resident || conv.is_non_uk_resident || infoObj.isNonUKResident;
                                  if (isNonUK === 'Yes' || isNonUK === true) info.push('Non-UK Resident');

                                  if (purchaseInfo.nonResidentialMixed === true || leadData?.non_residential_mixed === true || conv.non_residential_mixed === true || infoObj.nonResidentialMixed === true) info.push('Non-Residential / Mixed Use');

                                  if (info.length === 0) return <span className="text-muted">No additional purchase info</span>;

                                  return info.map((item, index) => (
                                    <span key={index} className="badge bg-primary me-1">{item}</span>
                                  ));
                                })()}
                              </div>
                            </td>
                          </tr>
                        )}
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Group Code</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              // First check if we have data from Purchase Details API
                              if (window.purchaseDetailsData && window.purchaseDetailsData.groupCode) {
                                return window.purchaseDetailsData.groupCode.name || window.purchaseDetailsData.groupCode;
                              }
                              // Fallback to existing logic
                              return leadData?.group_code?.name || leadData?.group_code || 'Not specified';
                            })()}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: '30%', padding: '0.75rem 1rem', fontWeight: '500' }}>Acquisition</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {(() => {
                              // First check if we have data from Purchase Details API
                              if (window.purchaseDetailsData && window.purchaseDetailsData.acquisition) {
                                return window.purchaseDetailsData.acquisition;
                              }
                              // Fallback to existing logic
                              return leadData?.acquisition || 'Not specified';
                            })()}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {/* Branch Information Section - Removed as per user request */}
                
                {/* Edit Button */}
                {canEditLeads && (
                  <div className="mt-3">
                    <Button
                      variant="outlined"
                      className='text-capitalize'
                      onClick={() => {
                        console.log('Edit button clicked - Service Type:', leadData?.service_type);
                        let editPath;

                        // Get first customer ID if available
                        const firstCustomerId = leadData?.customers && leadData.customers.length > 0
                          ? (leadData.customers[0]._id || leadData.customers[0].customer_id || leadData.customers[0])
                          : null;
                        const customerParam = firstCustomerId ? `?customerId=${firstCustomerId}` : '';

                        if (leadData?.service_type === 'Sale') {
                          editPath = `/leads/edit/conveyancing-sale/${leadData?.lead_id || lead_id}`;
                        } else if (leadData?.service_type === 'Purchase') {
                          editPath = `/leads/edit/conveyancing-purchase/${leadData?.lead_id || lead_id}`;
                        } else if (leadData?.service_type === 'Purchase_Sale' || leadData?.service_type === 'Sale & Purchase' || leadData?.service_type === 'Sale_Purchase') {
                          editPath = `/leads/edit/conveyancing-sale-purchase/${leadData?.lead_id || lead_id}`;
                        } else if (leadData?.service_type === 'First_Registration') {
                          editPath = `/conveyancing/first-registration/${leadData?.lead_id || lead_id}${customerParam}`;
                        } else {
                          editPath = `/leads/edit/conveyancing/${leadData?.lead_id || lead_id}`;
                        }
                        console.log('Navigating to:', editPath);
                        navigate(editPath);
                    }}
                    style={{ 
                      color: '#6c757d',
                      borderColor: '#6c757d',
                      fontSize: '0.875rem'
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" className="me-1" />
                    Edit
                  </Button>
                  </div>
                )}
                
                {/* Additional content or creation info */}
                <div className="mt-3 text-end">
                  <small className="text-muted">
                    Created: {leadData?.createdAt ? new Date(leadData.createdAt).toLocaleDateString('en-GB') : 'Date not available'} - {leadData?.created_by || localStorage.getItem('username') || 'Unknown'}
                  </small>
                  <div className="mt-1">
                    <Dropdown>
                      <Dropdown.Toggle 
                        variant="outlined" 
                        size="small"
                        className='text-capitalize'
                        style={{ 
                          color: '#6c757d',
                          borderColor: '#6c757d',
                          fontSize: '0.75rem',
                          backgroundColor: 'transparent'
                        }}
                      >
                        More Actions
                      </Dropdown.Toggle>
                      
                      <Dropdown.Menu>
                        <Dropdown.Item 
                          onClick={() => {
                            navigate('/leads/changestatus', {
                              state: { 
                                leadId: lead_id,
                                currentStatus: leadData?.status,
                                returnUrl: window.location.pathname
                              }
                            });
                          }}
                        >
                          <UpdateIcon fontSize="small" style={{ marginRight: '8px' }} />
                          Change Status
                        </Dropdown.Item>
                        
                        {canChangeGroupCode && (
                          <Dropdown.Item 
                            onClick={() => {
                              navigate('/leads/changegroupcode', {
                                state: { 
                                  leadId: lead_id,
                                  currentGroupCode: leadData?.group_code,
                                  returnUrl: window.location.pathname
                                }
                              });
                            }}
                          >
                            <EditOutlinedIcon fontSize="small" style={{ marginRight: '8px' }} />
                            Change Group Code
                          </Dropdown.Item>
                        )}
                        
                        {(canDeleteLeads || canChangeGroupCode) && <Dropdown.Divider />}
                        
                        {canDeleteLeads && (
                          <Dropdown.Item 
                            onClick={() => handleDeleteLead()}
                            style={{ color: '#dc3545' }}
                          >
                            <DeleteOutlineOutlinedIcon fontSize="small" style={{ marginRight: '8px' }} />
                            Delete Lead
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </Tab>
            
            {/* QUOTES TAB */}
            <Tab eventKey="quotes" title="Quotes">
              <div className="mt-3">
                {/* Current Quote Card */}
                {leadData && legalFeeData && (
                  <div className="card mb-3" style={{ border: '1px solid #dee2e6' }}>
                    <div className="card-body">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h5 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#2c3e50', margin: 0 }}>
                          £{(() => {
                            // Use totals from database if available (quoteFeeData.totals.total.gross)
                            if (quoteFeeData?.totals?.total?.gross) {
                              return Number(quoteFeeData.totals.total.gross).toFixed(2);
                            }

                            // Fallback: Calculate current total based on legalFeeData
                            const legalFee = Number(legalFeeData.legal_fee || 0);
                            const ttFee = Number(legalFeeData.tt_fee || 0);
                            const identityCheck = Number(legalFeeData.identity_check || 0);
                            const stampDuty = Number(legalFeeData.stamp_duty || 0);
                            const hmLandRegistryFee = Number(legalFeeData.hm_land_registry_fee || 0);
                            const landRegistrySearch = Number(legalFeeData.land_registry_search || 0);
                            const landChargesSearch = Number(legalFeeData.land_charges_search || 0);
                            const searchPack = Number(legalFeeData.search_pack || 0);

                            const totalNet = legalFee + ttFee + identityCheck + stampDuty + hmLandRegistryFee + landRegistrySearch + landChargesSearch + searchPack;
                            const legalFeeVAT = legalFee * 0.20;
                            const ttFeeVAT = ttFee * 0.20;
                            const landRegistrySearchVAT = landRegistrySearch * 0.20;
                            const landChargesSearchVAT = landChargesSearch * 0.20;
                            const totalVAT = legalFeeVAT + ttFeeVAT + landRegistrySearchVAT + landChargesSearchVAT;
                            const totalGross = totalNet + totalVAT;

                            return totalGross.toFixed(2);
                          })()}
                        </h5>
                        <span className="badge bg-primary" style={{ padding: '8px 15px', fontSize: '0.9rem' }}>
                          {legalFeeData.branch_name || 'Branch'}
                        </span>
                      </div>
                      <p style={{ color: '#6c757d', fontSize: '0.95rem', marginBottom: 0 }}>
                        <i className="far fa-calendar-alt me-2"></i>
                        {leadData?.quote_date ? new Date(leadData.quote_date).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : new Date().toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </p>
                      {/* Hide View Quote Detail button for Sale leads */}
                      {leadData?.service_type !== 'Sale' && (
                        <Button
                          variant="link"
                          className="text-decoration-none p-0 mt-2"
                          onClick={() => {
                            console.log('🔴 View Quote Detail button clicked!');
                            console.log('Current showQuoteDetailModal state:', showQuoteDetailModal);
                            handleViewQuoteDetail(null);
                          }}
                        >
                          View Quote Detail
                        </Button>
                      )}
                    </div>
                  </div>
                )}

                {/* Quote History Section - Enhanced UI */}
                {quoteHistory && quoteHistory.length > 0 && (
                  <div className="quote-history-section">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                        <i className="fas fa-history me-2" style={{ color: '#3498db' }}></i>
                        Quote History
                      </h5>
                      <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                        {quoteHistory.length} {quoteHistory.length === 1 ? 'Version' : 'Versions'}
                      </span>
                    </div>

                    <div className="timeline" style={{ position: 'relative', paddingLeft: '30px' }}>
                      {/* Timeline line */}
                      <div style={{
                        position: 'absolute',
                        left: '8px',
                        top: '20px',
                        bottom: '20px',
                        width: '2px',
                        backgroundColor: '#e0e0e0'
                      }}></div>

                      {quoteHistory.map((quote, index) => {
                        // Calculate total for Sale & Purchase from new structure
                        let totalAmount = 0;
                        let purchaseAmount = 0;
                        let saleAmount = 0;
                        let purchaseVat = 0;
                        let saleVat = 0;
                        let purchaseLegalCost = 0;
                        let saleLegalCost = 0;

                        if (quote.purchase_breakdown && quote.sale_breakdown) {
                          // ✅ New structure with separate breakdowns - Use totals.total.gross (grand total)
                          purchaseAmount = quote.purchase_breakdown.totals?.total?.gross || 0;
                          saleAmount = quote.sale_breakdown.totals?.total?.gross || 0;
                          totalAmount = purchaseAmount + saleAmount;
                          purchaseVat = quote.purchase_breakdown.totals?.total?.vat || 0;
                          saleVat = quote.sale_breakdown.totals?.total?.vat || 0;
                          purchaseLegalCost = quote.purchase_breakdown.totals?.legalCost?.gross || 0;
                          saleLegalCost = quote.sale_breakdown.totals?.legalCost?.gross || 0;
                        } else {
                          // Fallback to old structure
                          totalAmount = quote.total_quote || 0;
                        }

                        const totalVat = purchaseVat + saleVat;
                        const totalLegalCost = purchaseLegalCost + saleLegalCost;
                        const isActive = quote.is_active || false;
                        const revisionNumber = quote.revision_number || 1;
                        const source = quote.calculation_source || 'api';

                        // Use revision_label directly from API
                        const versionLabel = quote.revision_label || `Revision ${revisionNumber}`;

                        // Format date
                        const displayDate = quote.revised_at || quote.createdAt;

                        // Icon and color based on type
                        let iconClass = 'fa-file-invoice';
                        let iconColor = '#95a5a6';
                        let borderColor = '#e0e0e0';

                        if (isActive) {
                          iconClass = 'fa-check-circle';
                          iconColor = '#27ae60';
                          borderColor = '#27ae60';
                        } else if (versionLabel === 'Original') {
                          iconClass = 'fa-star';
                          iconColor = '#f39c12';
                        } else if (source === 'manual_revision') {
                          iconClass = 'fa-edit';
                          iconColor = '#3498db';
                        }

                        return (
                          <div key={quote._id || index} style={{ position: 'relative', marginBottom: '24px' }}>
                            {/* Timeline dot */}
                            <div style={{
                              position: 'absolute',
                              left: '-26px',
                              top: '16px',
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: iconColor,
                              border: '3px solid white',
                              boxShadow: '0 0 0 2px ' + iconColor,
                              zIndex: 1
                            }}></div>

                            {/* Card */}
                            <div className="card" style={{
                              border: `2px solid ${isActive ? borderColor : '#e9ecef'}`,
                              borderRadius: '12px',
                              boxShadow: isActive ? '0 4px 12px rgba(39, 174, 96, 0.15)' : '0 2px 8px rgba(0,0,0,0.08)',
                              transition: 'all 0.3s ease',
                              backgroundColor: isActive ? '#f8fff9' : 'white'
                            }}>
                              <div className="card-body" style={{ padding: '20px' }}>
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  {/* Left: Version & Amount */}
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                      <i className={`fas ${iconClass}`} style={{ color: iconColor, fontSize: '18px' }}></i>
                                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        {versionLabel}
                                      </h5>
                                      {isActive && (
                                        <span className="badge" style={{
                                          backgroundColor: '#27ae60',
                                          color: 'white',
                                          padding: '4px 10px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          CURRENT
                                        </span>
                                      )}
                                    </div>

                                    {/* Date & Time */}
                                    <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                      <i className="far fa-clock me-1"></i>
                                      {new Date(displayDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                      })} at {new Date(displayDate).toLocaleTimeString('en-GB', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </p>

                                    {/* Source Badge */}
                                    <span className="badge" style={{
                                      backgroundColor: source === 'manual_revision' ? '#3498db' : '#95a5a6',
                                      color: 'white',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      fontSize: '0.7rem'
                                    }}>
                                      {source === 'manual_revision' ? 'MANUAL REVISION' :
                                       source === 'api' ? 'AUTO CALCULATED' :
                                       source.toUpperCase()}
                                    </span>
                                  </div>

                                  {/* Right: Branch & Action */}
                                  <div className="d-flex flex-column align-items-end gap-2">
                                    {quote.branch_name && (
                                      <span className="badge" style={{
                                        backgroundColor: '#e8f4f8',
                                        color: '#3498db',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        fontSize: '0.75rem',
                                        fontWeight: 600
                                      }}>
                                        <i className="fas fa-building me-1"></i>
                                        {quote.branch_name}
                                      </span>
                                    )}
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      style={{
                                        borderRadius: '8px',
                                        padding: '6px 16px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        borderWidth: '2px'
                                      }}
                                      onClick={() => {
                                        console.log('🔍 View Quote clicked for:', versionLabel);
                                        console.log('📦 Quote data:', quote);

                                        // Transform NESTED format to FLAT format for ViewQuoteDetailModal
                                        const fees = quote.fees || {};
                                        const disbursements = quote.disbursements || {};

                                        // Convert Map to Object if needed
                                        const feesObj = fees instanceof Map ? Object.fromEntries(fees) : fees;
                                        const disbursementsObj = disbursements instanceof Map ? Object.fromEntries(disbursements) : disbursements;

                                        // Calculate totals
                                        const totalVat = quote.totals?.total?.vat || 0;
                                        const totalGross = quote.totals?.total?.gross || 0;

                                        const transformedFeeData = {
                                          branch_name: quote.branch_name,
                                          service_type: quote.service_type,
                                          // Purchase-specific fees
                                          purchase_legal_fee: feesObj.purchaseLegalFee?.amount || 0,
                                          purchase_tt_fee: feesObj.purchaseTTFee?.amount || 0,
                                          purchase_identity_check: feesObj.purchaseIdentityCheck?.amount || 0,
                                          purchase_mortgage_admin_fee: feesObj.purchaseMortgageAdminFee?.amount || 0,
                                          purchase_leasehold_fee: feesObj.purchaseLeaseholdFee?.amount || 0,
                                          purchase_help_to_buy_fee: feesObj.purchaseHelpToBuyFee?.amount || 0,
                                          // Purchase disbursements
                                          purchase_stamp_duty: disbursementsObj.purchaseStampDuty?.amount || 0,
                                          purchase_hm_land_registry_fee: disbursementsObj.purchaseHMLandRegistryFee?.amount || 0,
                                          purchase_land_registry_search: disbursementsObj.purchaseLandRegistrySearch?.amount || 0,
                                          purchase_land_charges_search: disbursementsObj.purchaseLandChargesSearch?.amount || 0,
                                          purchase_search_pack: disbursementsObj.purchaseSearchPack?.amount || 0,
                                          // Sale-specific fees
                                          sale_legal_fee: feesObj.saleLegalFee?.amount || 0,
                                          sale_tt_fee: feesObj.saleTTFee?.amount || 0,
                                          sale_identity_check: feesObj.saleIdentityCheck?.amount || 0,
                                          sale_mortgage_admin_fee: feesObj.saleMortgageAdminFee?.amount || 0,
                                          sale_official_copies: disbursementsObj.saleOfficialCopies?.amount || 0,
                                          // Totals
                                          vat_amount: totalVat,
                                          total_quote: totalGross,
                                          all_fees: feesObj,
                                          all_disbursements: disbursementsObj,
                                          // Add purchase and sale breakdowns for Sale-Purchase service
                                          purchase: quote.purchase_breakdown,
                                          sale: quote.sale_breakdown
                                        };

                                        console.log('✅ Transformed fee data:', transformedFeeData);

                                        setSelectedQuote({
                                          legalFeeData: transformedFeeData,
                                          leadData: leadData,
                                          revision_label: versionLabel,
                                          is_history: !isActive
                                        });
                                        setShowQuoteDetailModal(true);
                                      }}
                                    >
                                      <VisibilityIcon fontSize="small" style={{ fontSize: '14px', marginRight: '4px' }} />
                                      View Details
                                    </Button>
                                  </div>
                                </div>

                                {/* Pricing Breakdown */}
                                <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                  <div className="row g-3">
                                    {/* Total Amount - Highlighted */}
                                    <div className="col-md-3">
                                      <div style={{
                                        backgroundColor: isActive ? '#e8f5e9' : '#f8f9fa',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        textAlign: 'center'
                                      }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>
                                          Total Amount
                                        </p>
                                        <h4 className="mb-0" style={{ color: isActive ? '#27ae60' : '#2c3e50', fontWeight: 700 }}>
                                          £{Number(totalAmount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h4>
                                      </div>
                                    </div>

                                    {/* Purchase Amount */}
                                    {purchaseAmount > 0 && (
                                      <div className="col-md-3">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-home me-1" style={{ color: '#0d6efd' }}></i>
                                            Purchase
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#0d6efd', fontWeight: 600 }}>
                                            £{Number(purchaseAmount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>
                                    )}

                                    {/* Sale Amount */}
                                    {saleAmount > 0 && (
                                      <div className="col-md-3">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-tag me-1" style={{ color: '#198754' }}></i>
                                            Sale
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#198754', fontWeight: 600 }}>
                                            £{Number(saleAmount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>
                                    )}

                                    {/* VAT */}
                                    <div className="col-md-3">
                                      <div style={{ padding: '12px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                          <i className="fas fa-receipt me-1"></i>
                                          VAT Included
                                        </p>
                                        <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                          £{Number(totalVat).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* No quotes message */}
                {(!leadData || !legalFeeData) && (!quoteHistory || quoteHistory.length === 0) && (
                  <div className="text-center py-5">
                    <i className="fas fa-file-invoice fa-3x text-muted mb-3"></i>
                    <h5 className="text-muted">No Quotes Available</h5>
                    <p className="text-muted">No quotes have been generated yet.</p>
                  </div>
                )}
              </div>
            </Tab>

            {/* NOTES TAB */}
            <Tab eventKey="notes" title="Notes">
              <Notes lead_id={lead_id} product_id={leadData?.product_id} />
            </Tab>

            {/* COMMUNICATION TAB */}
            <Tab eventKey="communication" title="Communication">
              <div className='communication-table'>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Dropdown>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                      Contact Attempt ({contactAttempts})
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleUpdateContactAttempt('increase')}>
                        <MailOutlineIcon fontSize="small" /> &nbsp; Increase Contact Attempt Count
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleUpdateContactAttempt('reset')}>
                        <CallOutlinedIcon fontSize="small" /> &nbsp; Reset
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* Send Email Dropdown - Right Aligned */}
                  <div className="d-flex align-items-center gap-2">
                    <Dropdown>
                      <Dropdown.Toggle variant="primary" id="send-email-dropdown" disabled={sendingEmail}>
                        {sendingEmail ? 'Sending...' : 'Send Email'}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {emailTemplates.length === 0 ? (
                          <Dropdown.Item disabled>No templates available (Count: {emailTemplates.length})</Dropdown.Item>
                        ) : (
                          emailTemplates.map((template) => (
                            <Dropdown.Item
                              key={template._id}
                              onClick={() => handleSendEmail(template._id, template.name)}
                            >
                              {template.name}
                            </Dropdown.Item>
                          ))
                        )}
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Refresh Button for debugging */}
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => {
                        console.log('🔄 Manual refresh triggered');
                        fetchEmailTemplates();
                      }}
                      title="Refresh templates"
                    >
                      <RefreshIcon fontSize="small" />
                    </Button>
                  </div>

                  {/* Send SMS Button - Hidden for now */}
                  {/* <Button variant="outline-primary" disabled>
                    Send SMS
                  </Button> */}
                </div>

                {/* Email History Table */}
                <div className="mt-4">
                  <Table striped responsive bordered>
                    <thead>
                      <tr>
                        <th>Sent</th>
                        <th>Customer</th>
                        <th>Content</th>
                        <th style={{ width: '80px', textAlign: 'center' }}>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingEmails ? (
                        <tr>
                          <td colSpan="4" className="text-center">Loading...</td>
                        </tr>
                      ) : emailLogs.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center">No communication logs found</td>
                        </tr>
                      ) : (
                        emailLogs.map((log, index) => (
                          <tr key={log._id || index}>
                            <td>
                              {log.sent_at ? new Date(log.sent_at).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              }) : (log.isAutomation ? <span className="text-muted">Not triggered</span> : 'N/A')}
                            </td>
                            <td>
                              <div>
                                {log.recipient_name || log.customer_id?.forename || 'Unknown'}
                                <div className="text-muted small">{log.recipient_email}</div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <strong>{log.template_name || log.subject || 'No title'}</strong>
                                <div className="text-muted small">
                                  {log.subject && log.subject !== log.template_name && (
                                    <span>Subject: {log.subject}</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleViewEmailTemplate(log)}
                                title="View email content"
                                sx={{ minWidth: '40px', padding: '4px 8px' }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </Button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Tab>

            {/* TASKS TAB */}
            <Tab eventKey="appointment" title="Tasks">
              <div className='mt-4'>
                <Table striped responsive bordered>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date / Time</th>
                      <th>Case Ref</th>
                      <th>Booked</th>
                      <th>Status</th>
                      <th>Notes</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="8" className='text-center'>No tasks available</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab>

          </Tabs>
        </div>
      </div>

      <ConveyancingQuoteModal 
        show={modalShow} 
        onHide={() => {
          setModalShow(false);
          setSelectedQuote(null);
        }}
        quoteData={selectedQuote}
        leadData={leadData}
      />
      
      {/* Revise Quote Modal */}
      <ReviseQuoteModal 
        show={reviseModalShow} 
        onHide={() => setReviseModalShow(false)}
        leadData={leadData}
        authToken={authCtx.token}
        onReviseQuote={handleReviseQuote}
        legalFeeData={legalFeeData}
      />
      
      {/* View Quote Detail Modal - Sale or Purchase specific */}
      {console.log('🟦 ViewQuoteDetailModal props:', {
        show: showQuoteDetailModal,
        serviceType: leadData?.service_type,
        legalFeeData: selectedQuote?.legalFeeData || legalFeeData,
        leadData: selectedQuote?.leadData || leadData
      })}
      {leadData?.service_type === 'Sale' ? (
        <ViewQuoteDetailModalSale
          show={showQuoteDetailModal}
          onHide={() => {
            console.log('🔵 Closing ViewQuoteDetailModalSale');
            setShowQuoteDetailModal(false);
            setSelectedQuote(null);
          }}
          leadId={leadData?._id || lead_id}
          legalFeeData={selectedQuote?.legalFeeData || legalFeeData}
          leadData={selectedQuote?.leadData || leadData}
          calculationTotals={selectedQuote?.legalFeeData?.totals || quoteFeeData?.totals || null}
        />
      ) : (
        <ViewQuoteDetailModal
          show={showQuoteDetailModal}
          onHide={() => {
            console.log('🔵 Closing ViewQuoteDetailModal');
            setShowQuoteDetailModal(false);
            setSelectedQuote(null);
          }}
          leadId={leadData?._id || lead_id}
          authToken={authCtx.token}
          legalFeeData={selectedQuote?.legalFeeData || legalFeeData}
          leadData={selectedQuote?.leadData || leadData}
          calculationTotals={selectedQuote?.legalFeeData?.purchase || selectedQuote?.legalFeeData?.totals || quoteFeeData?.totals || null}
        />
      )}

      {/* Email View Modal */}
      <Modal show={viewEmailModal} onHide={() => setViewEmailModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedEmail?.template_name || selectedEmail?.subject || 'Email Template'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmail && (
            <div
              style={{
                maxHeight: '500px',
                overflowY: 'auto',
                padding: '10px'
              }}
              dangerouslySetInnerHTML={{ __html: selectedEmail.content || 'No content available' }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={() => setViewEmailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Conveyancing Modal - Commented out as we're using route navigation now */}
      {/* <EditConveyancingModal
        show={editModalShow}
        onHide={() => setEditModalShow(false)}
        leadData={leadData}
        authToken={authCtx.token}
        onUpdate={(updatedData) => {
          // Update local state with new data
          setLeadData(prev => ({ ...prev, ...updatedData }));
          // Reload page to reflect changes
          setTimeout(() => window.location.reload(), 1000);
        }}
      /> */}
    </>
  );
}